<template>
<div class="wai-analytics-page">
    <!-- {{ d_statsList }} -->
    <!-- {{p_selectedProjectType}} -->

    <div class="wai-hero">
      <div class="wai-hero-left">
        <div class="wai-badge">
          <i class="fa fa-area-chart"></i>
          Wistats 3.0 Analytics
        </div>
      </div>

      <div
        v-if="p_projectPermission && p_creditAuthData && p_creditAuthData['auth_data'] && p_creditAuthData['auth_data']['data'] && p_creditAuthData['auth_data']['data']['0'] && p_creditAuthData['auth_data']['data']['0']['6'] && p_creditAuthData['auth_data']['data']['0']['6']['val'] && p_creditAuthData['auth_data']['data']['0']['7'] && p_creditAuthData['auth_data']['data']['0']['7']['val']"
        class="wai-credit-card"
      >
        <span>Available Credit</span>
        <strong>
          {{ parseInt(p_creditAuthData['auth_data']['data']['0']['6']['val']) - parseInt(p_creditAuthData['auth_data']['data']['0']['7']['val']) }}
        </strong>
      </div>
    </div>

    <b-tabs class="wai-tabs">
      <b-tab v-if="['wanalyzer_create_query', 'wanalyzer_credit_count'].indexOf(p_selectedProjectType) !== -1 || (['wanalyzer_dataset_filter'].indexOf(p_selectedProjectType) !== -1 && p_datasetAdmin)" :active="d_selectedTab === 'general_settings'" @click="d_selectedTab = 'general_settings'">
        <template slot="title">
          {{ StoreLangTranslation.data['general_settings'][StoreLang] }}
        </template>
        <template v-if="d_selectedTab === 'general_settings' && ['wanalyzer_create_query', 'wanalyzer_credit_count'].indexOf(p_selectedProjectType) !== -1">
          <b-row style="margin: 3px;">
            <b-col sm="12" lg="10">
              {{ StoreLangTranslation.data['general_settings'][StoreLang] }}
            </b-col>
            <b-col sm="12" lg="2">
              <template v-if="d_projectSaveLoading || d_projectColumnListLoading || d_datasetViewLoading">
                  <b-spinner variant="primary" label="Spinning"></b-spinner>
              </template>
              <template v-else>
                <b-button variant="outline-primary" size="xl" @click="f_wanalyzerProjectSave('')" style="width: 100%;" :disabled="f_projectSaveEligibleCheck()">
                  <i class="fa fa-send-o"></i> {{ StoreLangTranslation.data['save'][StoreLang] }}
                </b-button>
              </template>
            </b-col>
          </b-row>
          <hr>
          <template>
            <template v-if="d_projectSaveLoading || d_projectColumnListLoading || d_datasetViewLoading">
              <b-spinner variant="primary" label="Spinning"></b-spinner>
            </template>
            <template v-else>
              <b-row v-if="p_projectPermission" style="margin: 3px;">
                <b-col sm="12" lg="4">
                  <strong>
                    {{ StoreLangTranslation.data['project_name'][StoreLang] }}
                  </strong>
                </b-col>
                <b-col sm="12" lg="8">
                  <b-form-group validated label-for="">
                    <b-textarea v-model="p_projectPermission.wanalyzer_project_name" rows="3" required></b-textarea>
                  </b-form-group>
                </b-col>
              </b-row>
              <hr>

              <template v-if="p_projectPermission && ['wanalyzer_create_query'].indexOf(p_selectedProjectType) !== -1">
                <b-row style="margin: 3px;">
                  <b-col sm="12" lg="4">
                    <strong>
                      {{ StoreLangTranslation.data['scope_already_exist'][StoreLang] }}
                    </strong>
                  </b-col>
                  <b-col sm="12" lg="8">
                    <b-form-select v-model="d_selectScope">
                        <option value="" selected>-</option>
                        <option v-for="scope_item in p_scopeList" :value="scope_item" >
                          {{ scope_item }}
                        </option>
                      </b-form-select>
                  </b-col>
                </b-row>
                <hr>

                <b-row style="margin: 3px;">
                  <b-col sm="12" lg="4">
                    <strong>
                      {{ StoreLangTranslation.data['scope'][StoreLang] }}
                      <i class="fa fa-info-circle" style="color:#2492FF;margin-left:5px;" @click="$help('project_scope', StoreLang)"> </i>
                    </strong>
                  </b-col>
                  <b-col sm="12" lg="8">
                    <b-form-group validated label-for="">
                      <b-textarea v-model="d_projectLocalScope" rows="1" ></b-textarea>
                    </b-form-group>
                  </b-col>
                </b-row>
                <hr>
              </template>

              <template v-if="p_projectPermission && ['wanalyzer_create_query'].indexOf(p_selectedProjectType) !== -1">
                <b-row style="margin: 3px;">
                  <b-col sm="12" lg="4">
                    <strong>
                      {{ StoreLangTranslation.data['case_limit_count'][StoreLang] }}
                      <i class="fa fa-info-circle" style="color:#2492FF;margin-left:5px;" @click="$help('project_case_limit_count', StoreLang)"> </i>
                    </strong>
                  </b-col>
                  <b-col sm="12" lg="6">
                    <template v-if="p_projectPermission.case_limit_count">
                      <b-form-group validated label-for="">
                        <b-form-input type="number" v-model="p_projectPermission.case_limit_count_set" required :max="parseInt(p_projectPermission.case_limit_count)"></b-form-input>
                      </b-form-group>
                    </template>
                    <template v-else>
                      <b-form-input type="number" v-model="p_projectPermission.case_limit_count_set"></b-form-input>
                    </template>
                  </b-col>
                  <b-col sm="12" lg="2">
                    <small v-if="p_projectPermission.case_limit_count" style="color: red;">(max: {{ p_projectPermission.case_limit_count }})</small>
                  </b-col>
                </b-row>
                <hr>
              </template>

              <template v-if="p_projectPermission && ['wanalyzer_create_query'].indexOf(p_selectedProjectType) !== -1">
                <b-row style="margin: 3px;">
                  <b-col sm="12" lg="4">
                    <strong>
                      {{ StoreLangTranslation.data['main_layer'][StoreLang] }}
                      <i class="fa fa-info-circle" style="color:#2492FF;margin-left:5px;" @click="$help('project_main_layer', StoreLang)"> </i>
                    </strong>
                  </b-col>
                  <b-col sm="12" lg="8">
                    <b-form-select v-model="p_projectPermission.main_layer">
                      <option v-for="(layer_item, layer_item_index) in p_projectPermission.layer_list" :value="layer_item.layer.value">
                        {{ layer_item.layer.name[StoreLang] }}
                      </option>
                    </b-form-select>
                  </b-col>
                </b-row>
                <hr>
              </template>

              <template v-if="p_projectPermission && ['wanalyzer_create_query'].indexOf(p_selectedProjectType) !== -1">
                <b-row style="margin: 3px;">
                  <b-col sm="12" lg="4">
                    <strong>
                      {{ StoreLangTranslation.data['location'][StoreLang] }}
                      <i class="fa fa-info-circle" style="color:#2492FF;margin-left:5px;" @click="$help('project_location', StoreLang)"> </i>
                    </strong>
                  </b-col>
                  <b-col sm="12" lg="8">
                    <template v-for="(location, location_index) in p_projectPermission.location_list">
                      <b-card-header :key="'header' + location_index" header-bg-variant="white" header-text-variant="dark" class="p-1" :title="location.name[StoreLang]">
                        <b-row>
                          <b-col sm="12" lg="12">
                            <h4 @click="f_selectLocation(location_index)" :style="location.selected ? 'cursor: pointer; color: rgb(2 123 255); font-weight: bold;' : 'cursor: pointer; '">
                              <i v-if="!location.selected" class="fa fa-minus-square-o"></i>
                              <i v-if="location.selected" class="fa fa-check-square"></i>
                              {{ location.name[StoreLang] }}
                            </h4>
                          </b-col>
                        </b-row>
                      </b-card-header>
                      <template v-if="location.selected">
                          <template v-for="(server, server_index) in location.server_list">
                            <div @click="f_selectServer(location_index, server_index)" :style="server.selected ? 'cursor: pointer; color: rgb(2 123 255); font-weight: bold; padding: 5px; background-color: #f8f8f8; margin: 3px;' : 'cursor: pointer; padding: 5px; margin: 3px;'">
                              <i v-if="!server.selected" class="fa fa-minus-square-o"></i>
                              <i v-if="server.selected" class="fa fa-check-square"></i>
                              {{ server.name[StoreLang] }}
                            </div>
                          </template>
                      </template>
                    </template>
                  </b-col>
                </b-row>
                <hr>
              </template>

              <template v-if="p_projectPermission && ['wanalyzer_create_query'].indexOf(p_selectedProjectType) !== -1">
                <b-row style="margin: 3px;">
                  <b-col sm="12" lg="10">
                    {{ StoreLangTranslation.data['main_rule'][StoreLang] }}
                    <i class="fa fa-info-circle" style="color:#2492FF;margin-left:5px;" @click="$help('project_main_rule', StoreLang)"> </i>
                  </b-col>
                  <b-col sm="12" lg="2">
                    <b-button variant="outline-primary" size="sm" @click="f_editMainRuleAlgorithm()">
                      <i class="fa fa-send-o"></i> {{ StoreLangTranslation.data['edit_main_rule_algorithm'][StoreLang] }}
                    </b-button>
                  </b-col>
                </b-row>
                <b-row v-if="!d_mainRuleShowModal" style="margin: 3px;">
                  <b-col sm="12" lg="12">
                    <b-row style="margin-top: 10px;">
                      <b-col sm="12" lg="12">
                        <template v-if="p_projectPermission.main_rule_algorithm_set.query_list && p_projectPermission.main_rule_algorithm_set.query_list.length > 0">
                          <rule-query :query_list="p_projectPermission.main_rule_algorithm_set.query_list" :compile_str="p_projectPermission.main_rule_algorithm_set.compile_str_array" :compile_str_date="p_projectPermission.main_rule_algorithm_set.compile_str_date" :mode="'view'" :compile_str_text="p_projectPermission.main_rule_algorithm_set.compile_str_text"></rule-query>
                        </template>
                      </b-col>
                    </b-row>
                  </b-col>
                </b-row>
                <hr>
              </template>

              <template v-if="p_projectPermission && ['wanalyzer_credit_count'].indexOf(p_selectedProjectType) !== -1">
                <b-row style="margin: 3px;">
                  <b-col sm="12" lg="4">
                    <strong>
                      {{ StoreLangTranslation.data['excel_file'][StoreLang] }}
                    </strong>
                    <i class="fa fa-info-circle" style="color:#2492FF;margin-left:5px;" @click="$help('projects_excel_file', StoreLang)"> </i>
                  </b-col>
                  <b-col sm="12" lg="8">
                    <b-form-file
                      v-model="d_excelFile"
                      accept=".xlsx, .xls"
                      ref="excelFileInput"
                      @change="f_handleFileUpload"
                      :browse-text="StoreLangTranslation.data['select_file'][StoreLang]"
                      :placeholder="StoreLangTranslation.data['select_excel_file'][StoreLang]"
                    ></b-form-file>
                  </b-col>
                </b-row>
                <template v-if="d_fileUploadLoading">
                  <b-spinner variant="primary" label="Spinning"></b-spinner>
                </template>
                <template v-else-if="d_excelFileCreditEligible">
                  <b-row style="margin: 3px;">
                    <b-col sm="12" lg="4">
                      {{ d_excelFileName }}
                    </b-col>
                    <b-col sm="12" lg="8">
                      <strong>({{ d_excelFileCredit }} {{ StoreLangTranslation.data['credits'][StoreLang] }})</strong>
                      <small @click="f_removeExcel()" style="color: red; cursor: pointer;">
                        [{{ StoreLangTranslation.data['cancel'][StoreLang] }}]
                      </small>
                    </b-col>
                  </b-row>
                  <b-row style="margin: 25px 3px 15px 3px;">
                    <b-col sm="12" lg="12">
                      <strong>{{ StoreLangTranslation.data['excel_warning'][StoreLang] }}</strong>
                    </b-col>
                  </b-row>
                  <b-row style="margin: 3px;">
                    <b-col sm="12" lg="4">
                      <strong>{{ StoreLangTranslation.data['pricing'][StoreLang] }}</strong>
                    </b-col>
                    <b-col sm="12" lg="8">
                      <b-row style="margin: 3px;">
                        <b-col sm="6" lg="6">
                          0 - 99 {{ StoreLangTranslation.data['cells'][StoreLang] }}
                        </b-col>
                        <b-col sm="6" lg="6">
                          10 {{ StoreLangTranslation.data['credits'][StoreLang] }}
                        </b-col>
                      </b-row>
                      <hr style="margin: 3px;"/>
                      <b-row style="margin: 3px;">
                        <b-col sm="6" lg="6">
                          100 - 499 {{ StoreLangTranslation.data['cells'][StoreLang] }}
                        </b-col>
                        <b-col sm="6" lg="6">
                          25 {{ StoreLangTranslation.data['credits'][StoreLang] }}
                        </b-col>
                      </b-row>
                      <hr style="margin: 3px;"/>
                      <b-row style="margin: 3px;">
                        <b-col sm="6" lg="6">
                          500 - 999 {{ StoreLangTranslation.data['cells'][StoreLang] }}
                        </b-col>
                        <b-col sm="6" lg="6">
                          50 {{ StoreLangTranslation.data['credits'][StoreLang] }}
                        </b-col>
                      </b-row>
                      <hr style="margin: 3px;"/>
                      <b-row style="margin: 3px;">
                        <b-col sm="6" lg="6">
                          1.000 - 9.999 {{ StoreLangTranslation.data['cells'][StoreLang] }}
                        </b-col>
                        <b-col sm="6" lg="6">
                          100 {{ StoreLangTranslation.data['credits'][StoreLang] }}
                        </b-col>
                      </b-row>
                      <hr style="margin: 3px;"/>
                      <b-row style="margin: 3px;">
                        <b-col sm="6" lg="6">
                          10.000 - 24.999 {{ StoreLangTranslation.data['cells'][StoreLang] }}
                        </b-col>
                        <b-col sm="6" lg="6">
                          150 {{ StoreLangTranslation.data['credits'][StoreLang] }}
                        </b-col>
                      </b-row>
                      <hr style="margin: 3px;"/>
                      <b-row style="margin: 3px;">
                        <b-col sm="6" lg="6">
                          25.000 - 99.999 {{ StoreLangTranslation.data['cells'][StoreLang] }}
                        </b-col>
                        <b-col sm="6" lg="6">
                          200 {{ StoreLangTranslation.data['credits'][StoreLang] }}
                        </b-col>
                      </b-row>
                      <hr style="margin: 3px;"/>
                      <b-row style="margin: 3px;">
                        <b-col sm="6" lg="6">
                          100.000 - 249.999 {{ StoreLangTranslation.data['cells'][StoreLang] }}
                        </b-col>
                        <b-col sm="6" lg="6">
                          250 {{ StoreLangTranslation.data['credits'][StoreLang] }}
                        </b-col>
                      </b-row>
                      <hr style="margin: 3px;"/>
                      <b-row style="margin: 3px;">
                        <b-col sm="6" lg="6">
                          250.000 - 499.999 {{ StoreLangTranslation.data['cells'][StoreLang] }}
                        </b-col>
                        <b-col sm="6" lg="6">
                          300 {{ StoreLangTranslation.data['credits'][StoreLang] }}
                        </b-col>
                      </b-row>
                      <hr style="margin: 3px;"/>
                      <b-row style="margin: 3px;">
                        <b-col sm="6" lg="6">
                          500.000 - 749.999 {{ StoreLangTranslation.data['cells'][StoreLang] }}
                        </b-col>
                        <b-col sm="6" lg="6">
                          350 {{ StoreLangTranslation.data['credits'][StoreLang] }}
                        </b-col>
                      </b-row>
                      <hr style="margin: 3px;"/>
                      <b-row style="margin: 3px;">
                        <b-col sm="6" lg="6">
                          750.000 - 1.000.000 {{ StoreLangTranslation.data['cells'][StoreLang] }}
                        </b-col>
                        <b-col sm="6" lg="6">
                          400 {{ StoreLangTranslation.data['credits'][StoreLang] }}
                        </b-col>
                      </b-row>
                    </b-col>
                  </b-row>
                  <hr style="margin: 3px;"/>
                  <b-row style="margin: 15px 3px 3px 3px;">
                    <b-col sm="4" lg="4">
                      <strong>{{ StoreLangTranslation.data['confirm'][StoreLang] }}</strong>
                    </b-col>
                    <b-col sm="8" lg="8">
                      <b-form-checkbox
                        v-model="d_approveCredit"
                        name="approve_checkbox"
                        value="true"
                        unchecked-value=""
                      >
                        {{ StoreLangTranslation.data['i_approve'][StoreLang] }}
                      </b-form-checkbox>
                    </b-col>
                  </b-row>
                </template>
                <hr>
                <b-row style="margin: 3px;" v-if="d_excelCorrection.correction_column_list.length > 0">
                  <b-col sm="12" lg="4">
                  </b-col>
                  <b-col sm="12" lg="8" style="text-align: right;">
                    <b-button @click="d_excelCorrection.show = true" variant="outline-primary">
                      {{ StoreLangTranslation.data['edit_the_column_structure_and_data_of_the_uploaded_excel'][StoreLang] }}
                    </b-button>
                  </b-col>
                </b-row>
              </template>


            </template>
          </template>

        </template>
        <template v-else>
          <b-row style="margin: 3px;">
            <b-col sm="12" lg="10">
              {{ StoreLangTranslation.data['general_settings'][StoreLang] }}
            </b-col>
            <b-col sm="12" lg="2">
              <template v-if="d_projectSaveLoading || d_projectColumnListLoading || d_datasetViewLoading || d_columnListLoading">
                  <b-spinner variant="primary" label="Spinning"></b-spinner>
              </template>
              <template v-else>
                <b-button variant="outline-primary" size="xl" @click="f_wanalyzerProjectSave('')" style="width: 100%;" :disabled="f_projectSaveEligibleCheck()">
                  <i class="fa fa-send-o"></i> {{ StoreLangTranslation.data['save'][StoreLang] }}
                </b-button>
              </template>
            </b-col>
          </b-row>
          <hr>
          <template>
            <template v-if="d_projectSaveLoading || d_projectColumnListLoading || d_datasetViewLoading || d_columnListLoading">
              <b-spinner variant="primary" label="Spinning"></b-spinner>
            </template>
            <template v-else>
              <b-row style="margin: 3px;">
                <b-col sm="12" lg="4">
                  <strong>
                    {{ StoreLangTranslation.data['project_name'][StoreLang] }}
                  </strong>
                </b-col>
                <b-col sm="12" lg="8">
                  <b-form-group validated label-for="">
                    <b-textarea v-model="d_project.details.name" rows="3" required></b-textarea>
                  </b-form-group>
                </b-col>
              </b-row>
              <hr>

              <template>
                <b-row style="margin: 3px;">
                  <b-col sm="12" lg="4">
                    <strong>
                      {{ StoreLangTranslation.data['excel_file'][StoreLang] }}
                    </strong>
                    <i class="fa fa-info-circle" style="color:#2492FF;margin-left:5px;" @click="$help('projects_excel_file', StoreLang)"> </i>
                  </b-col>
                  <b-col sm="12" lg="8">
                    <b-form-file
                      v-model="d_excelFile"
                      accept=".xlsx, .xls"
                      ref="excelFileInput"
                      @change="f_handleFileUpload"
                      :browse-text="StoreLangTranslation.data['select_file'][StoreLang]"
                      :placeholder="StoreLangTranslation.data['select_excel_file'][StoreLang]"
                    ></b-form-file>
                  </b-col>
                </b-row>
                <template v-if="d_fileUploadLoading">
                  <b-spinner variant="primary" label="Spinning"></b-spinner>
                </template>
                <template>
                  <b-row style="margin: 3px;">
                    <b-col sm="12" lg="4">
                      {{ d_excelFileName }}
                    </b-col>
                    <b-col sm="12" lg="8">
                    </b-col>
                  </b-row>
                </template>
                <hr>
                <b-row style="margin: 3px;" v-if="d_excelCorrection.correction_column_list.length > 0">
                  <b-col sm="12" lg="4">
                  </b-col>
                  <b-col sm="12" lg="8" style="text-align: right;">
                    <b-button @click="d_excelCorrection.show = true" variant="outline-primary">
                      {{ StoreLangTranslation.data['edit_the_column_structure_and_data_of_the_uploaded_excel'][StoreLang] }}
                    </b-button>
                  </b-col>
                </b-row>
              </template>


            </template>
          </template>
        </template>
      </b-tab>


      <b-tab v-if="(p_projectPermission && ['wanalyzer_create_query'].indexOf(p_selectedProjectType) !== -1) || (['wanalyzer_dataset_filter'].indexOf(p_selectedProjectType) !== -1 && d_projectId && p_datasetAdmin) || (p_projectPermission && ['wanalyzer_credit_count'].indexOf(p_selectedProjectType) !== -1 && d_projectId)" :active="d_selectedTab === 'column_list'" @click="d_selectedTab = 'column_list'">
        <template slot="title">
          {{ StoreLangTranslation.data['column_list'][StoreLang] }}
        </template>
        <template v-if="d_selectedTab === 'column_list'">
          <template v-if="d_columnListLoading">
            <b-spinner variant="primary" label="Spinning"></b-spinner>
          </template>
          <template v-else>
            <wanalyzer-project-column :p_columnList="d_columnList" :p_projectPermission="p_projectPermission" :f_wanalyzerProjectColumnDataList="f_wanalyzerProjectColumnDataList" :f_wanalyzerProjectDatasetGet="f_wanalyzerProjectDatasetGet" :p_selectedProjectType="p_selectedProjectType" :p_fullScreen="p_fullScreen" :p_projectId="d_projectId"></wanalyzer-project-column>
          </template>
        </template>
      </b-tab>



      <b-tab v-if="(p_projectPermission && ['wanalyzer_create_query'].indexOf(p_selectedProjectType) !== -1 || (p_projectPermission && ['wanalyzer_credit_count'].indexOf(p_selectedProjectType) !== -1 && d_projectId)) || (['wanalyzer_dataset_filter'].indexOf(p_selectedProjectType) !== -1 && d_projectId && p_datasetAdmin)" :active="d_selectedTab === 'dataset'" @click="d_selectedTab = 'dataset'">
        <template slot="title">
          {{ StoreLangTranslation.data['dataset'][StoreLang] }}
          <i class="fa fa-info-circle" style="color:#2492FF;margin-left:5px;" @click="$help('projects_dataset_filter', StoreLang)"> </i>
        </template>
        <template v-if="d_selectedTab === 'dataset'">
          <b-card-header header-bg-variant="white" header-text-variant="dark" style="margin-bottom: 10px;">
            <b-row>
              <b-col sm="12" lg="4">
                <!-- <h5> {{ StoreLangTranslation.data['results'][StoreLang] }} </h5> -->
              </b-col>
              <b-col sm="12" lg="2">
                <template v-if="d_projectDataQueryLoading">
                    <b-spinner variant="primary" label="Spinning"></b-spinner>
                    {{ StoreLangTranslation.data['continuing'][StoreLang] }}
                </template>
              </b-col>
              <b-col sm="12" lg="6" style="text-align: right;" v-if="['wanalyzer_create_query'].indexOf(p_selectedProjectType) !== -1">
                <b-button variant="outline-primary" size="sm" @click="f_wanalyzerDataQuery('delete_all_and_recreate')" :title="StoreLangTranslation.data['delete_all_and_recreate'][StoreLang]" :disabled="d_columnList.length === 0 || d_projectDataQueryLoading">
                  <i class="fa fa-database"></i>
                  {{ StoreLangTranslation.data['delete_all_and_recreate'][StoreLang] }}
                  <small v-if="d_columnList.length === 0" style="color: red;">
                    ({{ StoreLangTranslation.data['first_create_column'][StoreLang] }})
                  </small>
                </b-button>
              </b-col>
            </b-row>
          </b-card-header>
          <template v-if="d_datasetViewLoading">
              <b-spinner variant="primary" label="Spinning"></b-spinner>
          </template>
          <template v-else>
            <w-table2 style="transition: 2s; transform: none;" v-if="d_datasetWTable && d_datasetShow" :key="'dataset_view'" :p_tableDetails="d_datasetWTable"></w-table2>
          </template>
        </template>
      </b-tab>


      <b-tab v-if="['wanalyzer_create_query'].indexOf(p_selectedProjectType) !== -1" :active="d_selectedTab === 'data_count'" @click="d_selectedTab = 'data_count'">
        <template slot="title">
          {{ StoreLangTranslation.data['data_count'][StoreLang] }}
        </template>
        <template v-if="d_selectedTab === 'data_count'">
          <b-card-header header-bg-variant="white" header-text-variant="dark" style="margin-bottom: 10px;">
            <b-row>
              <b-col sm="12" lg="4">
              </b-col>
              <b-col sm="12" lg="2">
                <template v-if="d_projectDataQueryLoading">
                    <b-spinner variant="primary" label="Spinning"></b-spinner>
                    {{ StoreLangTranslation.data['continuing'][StoreLang] }}
                </template>
              </b-col>
              <b-col sm="12" lg="6" style="text-align: right;">
                <i class="fa fa-info-circle" style="color:#2492FF;margin-left:5px;" @click="$help('projects_calculate_case_count', StoreLang)"> </i>
                <b-button variant="outline-success" size="sm" @click="f_wanalyzerDataQuery('calculate_case_count')" :title="StoreLangTranslation.data['calculate_case_count'][StoreLang]" :disabled="d_projectDataQueryLoading">
                  <i class="fa fa-calculator"></i>
                  {{ StoreLangTranslation.data['calculate_case_count'][StoreLang] }}
                </b-button>                      
              </b-col>
            </b-row>
          </b-card-header>
          <template v-if="d_datasetViewLoading">
              <b-spinner variant="primary" label="Spinning"></b-spinner>
          </template>
          <template v-else>
            <div style="min-height: 300px;">
              <b-card-header v-if="d_project.details.calculated_case_count !== undefined" header-bg-variant="white" class="p-1" header-text-variant="dark">
                <strong>
                  {{ StoreLangTranslation.data['total_case_count'][StoreLang] }} :
                  {{ d_project.details.calculated_case_count }} </strong>
                  /
                  {{ StoreLangTranslation.data['last_update'][StoreLang] }} :
                  {{ d_project.details['locations_count_update_date'] ? f_dateFormat(d_project.details['locations_count_update_date'], 'year-month-day hh:mm') : '' }}
              </b-card-header>ƒ
              <template v-if="d_project.details.locations_data_count && d_project.details.locations_data_count.location_order && d_project.details.locations_data_count.location_order.length > 0">
                <b-card-header header-bg-variant="white" class="p-1" header-text-variant="dark">
                  <strong> {{ StoreLangTranslation.data['location'][StoreLang] }} </strong>
                </b-card-header>
                <template v-for="(location_order, location_order_index) in d_project.details.locations_data_count.location_order">
                  <b-row style="margin: 3px;">
                    <b-col cols="4">
                      <strong>{{ d_project.details.locations_data_count.location_results[location_order].info.label }}</strong>
                    </b-col>
                    <b-col cols="1">
                        {{ d_project.details.locations_data_count.location_results[location_order].total_count }}
                    </b-col>
                    <b-col cols="7">
                        <b-progress :value="(d_project.details.locations_data_count.location_results[location_order].total_count / d_project.details.calculated_case_count) * 100" class="mb-3"></b-progress>
                    </b-col>
                  </b-row>
                  <template v-for="(server_order, server_order_index) in d_project.details.locations_data_count.location_results[location_order].server_order">
                    <b-row style="margin: 3px; border-bottom: solid 1px whitesmoke;">
                      <b-col cols="4">
                        <span style="margin-left: 20px;">
                          {{ server_order_index + 1 }} )
                          {{ d_project.details.locations_data_count.location_results[location_order].server_results[server_order].info.label }}
                        </span>
                      </b-col>
                      <b-col cols="1">
                        <strong> {{ d_project.details.locations_data_count.location_results[location_order].server_results[server_order].total_count }} </strong>
                      </b-col>
                      <b-col cols="7">
                        <b-progress :value="(d_project.details.locations_data_count.location_results[location_order].server_results[server_order].total_count / d_project.details.calculated_case_count) * 100"> </b-progress>
                      </b-col>
                    </b-row>
                  </template>
                </template>
              </template>
            </div>
          </template>
        
        </template>
      </b-tab>


      <b-tab v-if="['wanalyzer_dataset_stats_query', 'wanalyzer_dataset_filter', 'wanalyzer_create_query'].indexOf(p_selectedProjectType) !== -1 || (p_projectPermission && ['wanalyzer_credit_count'].indexOf(p_selectedProjectType) !== -1 && d_projectId)" :active="d_selectedTab === 'dataset_filter'" @click="d_selectedTab = 'dataset_filter'">
        <template slot="title">
          <i class="fa fa-area-chart" style="color: #028bf5;"></i>
          {{ StoreLangTranslation.data['dataset_filter_and_stats'][StoreLang] }}
        </template>
        <template v-if="d_selectedTab === 'dataset_filter'">
          <b-row style="border-top: solid 1px lightblue; border-bottom: solid 1px lightblue;">
              <b-col sm="12" md="12" lg="4" v-if="d_variablesShow">
                <b-card-header header-bg-variant="white" header-text-variant="dark" style="margin-bottom: 10px;">
                  <b-row>
                    <b-col sm="12" lg="8">
                      <h5>
                        <i class="fa fa-tags"></i>
                        {{ StoreLangTranslation.data['variables'][StoreLang] }}
                      </h5>
                    </b-col>
                    <!-- <b-col sm="12" lg="4" style="text-align: right;"> </b-col> -->
                    <b-col sm="12" lg="4" style="text-align: right;">
                      <b-button variant="outline-primary" size="sm" @click="f_resetProjectData()" :title="StoreLangTranslation.data['reset'][StoreLang]"  style="margin-right: 5px;">
                        <i class="fa fa-refresh"></i>
                      </b-button>
                      <b-button variant="outline-primary" size="sm" @click="f_variablesListShow()" style="margin-right: 5px;">
                        <i class="fa fa-list"></i>
                      </b-button>
                    </b-col>
                  </b-row>
                </b-card-header>
                <template v-if="d_projectColumnListLoading || d_columnListLoading">
                  <b-spinner variant="primary" label="Spinning"></b-spinner>
                </template>
                <template v-else>

                <b-row style="border-bottom: solid 1px rgb(227, 246, 255); font-size: 12px; font-weight: bold; background-color: lightblue; margin: 0px;">
                    <b-col sm="12" lg="4">
                      {{ StoreLangTranslation.data['variables'][StoreLang] }}
                      <i class="fa fa-info-circle" style="color:#2492FF;margin-left:5px;" @click="$help('projects_variables', StoreLang)"> </i>
                    </b-col>
                    <b-col sm="12" lg="3">
                      {{ StoreLangTranslation.data['operator'][StoreLang] }}
                      <i class="fa fa-info-circle" style="color:#2492FF;margin-left:5px;" @click="$help('projects_variables_operator', StoreLang)"> </i>
                    </b-col>
                    <b-col sm="12" lg="3">
                      {{ StoreLangTranslation.data['filter'][StoreLang] }}
                      <i class="fa fa-info-circle" style="color:#2492FF;margin-left:5px;" @click="$help('projects_variables_filter', StoreLang)"> </i>
                    </b-col>
                    <b-col sm="12" lg="2" @click="f_selectOrNotColumnForStatsAnalyze()" style="cursor: pointer;">
                      <i class="fa fa-area-chart" style="color: #028bf5; font-size: 24px;"></i>
                      <i class="fa fa-info-circle" style="color:#2492FF;margin-left:5px;" @click="$help('projects_variables_selection', StoreLang)"> </i>
                    </b-col>
                  </b-row>

                  <div style="overflow-x: hidden; overflow-y: auto; max-height: 500px;">


                    <!-- <template v-for="(col, col_ind) in d_project.column_list">d_project.column_list.indexOf(d_project.column_list[indx_lst_indx]) -->
                    <template v-for="indx_lst_indx in d_orderedColumnIndexList">
                      <div :style="indx_lst_indx % 2 == 0 ? 'background-color: #ededed' : ''">
                        <template v-if="d_selectedModeTab === 'graph_mode'">
                          <template v-if="d_project.column_list.indexOf(d_project.column_list[indx_lst_indx]) === d_firstInputIndex">
                            <b-row style="margin: 3px;">
                              <b-col sm="12" lg="4">
                                <strong><i class="fa fa-upload" style="margin-right: 3px"></i>{{ StoreLangTranslation.data['inputs'][StoreLang] }}</strong>
                              </b-col>
                            </b-row>
                            <hr style="margin-top: 0px;" />
                          </template>
                          <template v-else-if="d_project.column_list.indexOf(d_project.column_list[indx_lst_indx]) === d_firstOutputIndex">
                            <b-row style="margin: 3px;">
                              <b-col sm="12" lg="4">
                                <strong><i class="fa fa-download" style="margin-right: 3px"></i>{{ StoreLangTranslation.data['outputs'][StoreLang] }}</strong>
                              </b-col>
                            </b-row>
                            <hr style="margin-top: 0px;" />
                          </template>
                        </template>
                        <!-- output olarak seçilen değişkeni seçilebilir yapmak istemiyoruz. Dolayısıyla bu kontrolü yapıyoruz. -->
                        <div :style="d_selectedTabItemId == 'machine_learning_training' && d_selectedOutput == indx_lst_indx ? 'background-color: lightgreen !important' : ''">
                          <template v-if="d_project.column_list[indx_lst_indx].param_type === 'select' || d_project.column_list[indx_lst_indx].param_type === 'radiogroup'">

                            <b-row v-if="['wanalyzer_create_query', 'wanalyzer_credit_count'].indexOf(p_selectedProjectType) !== -1 || (['wanalyzer_dataset_stats_query'].indexOf(p_selectedProjectType) !== -1 && d_project.column_list[indx_lst_indx].wai_output) || (['wanalyzer_dataset_filter'].indexOf(p_selectedProjectType) !== -1 && (d_project.column_list[indx_lst_indx].wai_output || d_project.column_list[indx_lst_indx].wai_input))" style="border-bottom: solid 1px rgb(227, 246, 255); font-size: 12px; margin:  0px;">

                              <b-col sm="12" lg="4">
                                <strong>{{ d_project.column_list[indx_lst_indx].name }}</strong>
                                <i v-if="d_project.column_list[indx_lst_indx].info" class="fa fa-info-circle" :title="d_project.column_list[indx_lst_indx].info" style="color: blue;" @click="f_showTextAsModal(d_project.column_list[indx_lst_indx].info)"></i>
                              </b-col>

                              <b-col sm="12" lg="3">
                                <b-dropdown variant="white" size="sm" style="width: 100%; margin: 0px;" no-caret>
                                  <template slot="button-content">
                                    <div style="font-size: 12px; white-space: pre-wrap;">
                                      <i class="fa fa-check"></i>
                                      {{ d_project.column_list[indx_lst_indx].operation ? d_project.column_list[indx_lst_indx].operation.translation[StoreLang] : '' }}
                                    </div>
                                  </template>
                                  <template v-for="(oper, oper_ind) in d_operatorList">
                                    <template v-if="['=', '<>', 'is_null', 'is_not_null'].indexOf(oper.value) !== -1">
                                      <b-dropdown-item @click="f_selectOperationForColumn(d_project.column_list.indexOf(d_project.column_list[indx_lst_indx]), oper)">
                                        <i class="fa fa-check"></i>
                                        {{ oper.translation[StoreLang] }}
                                      </b-dropdown-item>
                                    </template>
                                  </template>
                                </b-dropdown>
                              </b-col>


                              <b-col sm="12" lg="3">
                                <div>
                                    <b-dropdown id="dropdown-grouped" variant="outline-white" no-caret style="width: 100%;">
                                    <template #button-content>
                                      <i class="fa fa-list"></i>
                                    </template>
                                    <!-- <b-row style="width: 100%;">
                                      <b-col sm="12" lg="1"></b-col>
                                      <b-col sm="12" lg="8">
                                        <b-form-input v-model="d_searchText" :placeholder="StoreLangTranslation.data['write_for_filtering'][StoreLang]"></b-form-input>
                                      </b-col>
                                      <b-col sm="12" lg="3">
                                        <i class="fa fa-trash" style="cursor: pointer;" @click="d_searchText = ''"></i>
                                      </b-col>
                                    </b-row> -->
                                    <b-dropdown-item-button @click="f_addToColumnSelectedItems('dataset_filter', d_project.column_list.indexOf(d_project.column_list[indx_lst_indx]), '')">
                                      <i class="fa fa-plus-square"></i> {{ StoreLangTranslation.data['all'][StoreLang] }}
                                    </b-dropdown-item-button>
                                    <div style="overflow-x: hidden; overflow-y: auto; height: 300px;">
                                      <template v-for="(opt, opt_ind) in d_project.column_list[indx_lst_indx].options">
                                        <b-dropdown-item-button @click="f_addToColumnSelectedItems('dataset_filter', d_project.column_list.indexOf(d_project.column_list[indx_lst_indx]), opt)">
                                          <i class="fa fa-plus-square"></i>  {{ opt.label }}
                                        </b-dropdown-item-button>
                                      </template>
                                    </div>
                                  </b-dropdown>
                                </div>

                                <div>
                                  <template v-if="d_project.column_list[indx_lst_indx].selected_items.length > 0">
                                    <template v-for="(selected_item, selected_item_ind) in d_project.column_list[indx_lst_indx].selected_items">
                                      <b-button variant="outline-primary" size="sm" style="font-size: 10px; margin: 2px; padding: 1px; width: 100%;" @click="f_deleteSelectedItem(d_project.column_list.indexOf(d_project.column_list[indx_lst_indx]), selected_item_ind)">
                                        {{ selected_item.label }},
                                      </b-button>
                                    </template>
                                  </template>

                                </div>


                              </b-col>

                              <b-col v-if=
                              "!(d_selectedTabItemId == 'machine_learning_training' && d_selectedOutput == indx_lst_indx) && (['wanalyzer_create_query', 'wanalyzer_credit_count'].indexOf(p_selectedProjectType) !== -1 || (['wanalyzer_dataset_stats_query'].indexOf(p_selectedProjectType) !== -1 && d_project.column_list[indx_lst_indx].wai_output) || (['wanalyzer_dataset_filter'].indexOf(p_selectedProjectType) !== -1 && (d_project.column_list[indx_lst_indx].wai_output || d_project.column_list[indx_lst_indx].wai_input)))" sm="12" lg="2" @click="f_selectColumnUseAsStats(d_project.column_list.indexOf(d_project.column_list[indx_lst_indx]))" style="cursor: pointer;">
                                <i v-if="d_project.column_list[indx_lst_indx].use_as_stats === 'yes' && d_project.column_list[indx_lst_indx].wai_output && d_selectedModeTab === 'graph_mode'" class="fa fa-area-chart" style="color: #26f502; font-size: 24px;"></i>
                                <i v-else-if="d_project.column_list[indx_lst_indx].use_as_stats === 'yes'" class="fa fa-area-chart" style="color: #028bf5; font-size: 24px;"></i>
                                <i v-else-if="['wanalyzer_dataset_filter'].indexOf(p_selectedProjectType) !== -1 && d_selectedModeTab === 'detailed_mode' && d_project.column_list[indx_lst_indx].compare_eligible === '0'" class="fa fa-area-chart" style="color: red; font-size: 24px; opacity: 0.3;"></i>
                                <i v-else class="fa fa-minus-square" style="font-size: 24px;"></i>
                                <small v-if="d_selectedModeTab === 'graph_mode' && d_project.column_list[indx_lst_indx].multi_dimension_order">
                                  {{ d_project.column_list[indx_lst_indx].multi_dimension_order }}
                                </small>
                              </b-col>

                              <b-col v-else sm="12" lg="2"> </b-col>

                            </b-row>
                          </template>

                          <template v-else-if="d_project.column_list[indx_lst_indx].param_type === 'integer' || d_project.column_list[indx_lst_indx].param_type === 'float'">
                            <b-row v-if="['wanalyzer_create_query', 'wanalyzer_credit_count'].indexOf(p_selectedProjectType) !== -1 || (['wanalyzer_dataset_stats_query'].indexOf(p_selectedProjectType) !== -1 && d_project.column_list[indx_lst_indx].wai_output) || (['wanalyzer_dataset_filter'].indexOf(p_selectedProjectType) !== -1 && (d_project.column_list[indx_lst_indx].wai_output || d_project.column_list[indx_lst_indx].wai_input))" style="border-bottom: solid 1px rgb(227, 246, 255); font-size: 12px; margin:  0px;">

                              <b-col sm="12" lg="4" style="font-size: 12px;">
                                 <strong>{{ d_project.column_list[indx_lst_indx].name }}</strong>
                                 <i v-if="d_project.column_list[indx_lst_indx].info" class="fa fa-info-circle" :title="d_project.column_list[indx_lst_indx].info" style="color: blue;" @click="f_showTextAsModal(d_project.column_list[indx_lst_indx].info)"></i>
                              </b-col>
                              <b-col sm="12" lg="3">
                                <b-dropdown variant="white" size="sm" style="width: 100%; margin: 0px;" no-caret>
                                  <template slot="button-content">
                                    <div style="font-size: 12px; white-space: pre-wrap;">
                                      <i class="fa fa-check"></i>
                                      {{ d_project.column_list[indx_lst_indx].operation ? d_project.column_list[indx_lst_indx].operation.translation[StoreLang] : '' }}
                                    </div>
                                  </template>
                                  <template v-for="(oper, oper_ind) in d_operatorList">
                                    <b-dropdown-item @click="f_selectOperationForColumn(d_project.column_list.indexOf(d_project.column_list[indx_lst_indx]), oper)">
                                      <i class="fa fa-check"></i>
                                      {{ oper.translation[StoreLang] }}
                                    </b-dropdown-item>
                                  </template>
                                </b-dropdown>
                              </b-col>
                              <b-col sm="12" lg="3">
                                <b-form-input type="number" style="font-size: 12px;" v-model="d_project.column_list[indx_lst_indx].selected"></b-form-input>
                                <!-- <b-form-input type="number" style="font-size: 12px;" v-model="d_project.column_list[indx_lst_indx].selected" @change="f_wanalyzerProjectStatisticsAnalyzeList()"></b-form-input> -->
                              </b-col>

                              <b-col v-if=
                              "!(d_selectedTabItemId == 'machine_learning_training' && d_selectedOutput == indx_lst_indx) && (['wanalyzer_create_query', 'wanalyzer_credit_count'].indexOf(p_selectedProjectType) !== -1 || (['wanalyzer_dataset_stats_query'].indexOf(p_selectedProjectType) !== -1 && d_project.column_list[indx_lst_indx].wai_output) || (['wanalyzer_dataset_filter'].indexOf(p_selectedProjectType) !== -1 && (d_project.column_list[indx_lst_indx].wai_output || d_project.column_list[indx_lst_indx].wai_input)))" sm="12" lg="2" @click="f_selectColumnUseAsStats(d_project.column_list.indexOf(d_project.column_list[indx_lst_indx]))" style="cursor: pointer;">
                                <i v-if="d_project.column_list[indx_lst_indx].use_as_stats === 'yes' && d_project.column_list[indx_lst_indx].wai_output && d_selectedModeTab === 'graph_mode'" class="fa fa-area-chart" style="color: #26f502; font-size: 24px;"></i>
                                <i v-else-if="d_project.column_list[indx_lst_indx].use_as_stats === 'yes'" class="fa fa-area-chart" style="color: #028bf5; font-size: 24px;"></i>
                                <i v-else-if="['wanalyzer_dataset_filter'].indexOf(p_selectedProjectType) !== -1 && d_selectedModeTab === 'detailed_mode' && d_project.column_list[indx_lst_indx].compare_eligible === '0'" class="fa fa-area-chart" style="color: red; font-size: 24px; opacity: 0.3;"></i>
                                <i v-else class="fa fa-minus-square" style="font-size: 24px;"></i>
                                <small v-if="d_selectedModeTab === 'graph_mode' && d_project.column_list[indx_lst_indx].multi_dimension_order">
                                  {{ d_project.column_list[indx_lst_indx].multi_dimension_order }}
                                </small>
                              </b-col>

                              <b-col v-else sm="12" lg="2"> </b-col>

                            </b-row>
                          </template>

                          <template v-else-if="d_project.column_list[indx_lst_indx].param_type === 'date' || d_project.column_list[indx_lst_indx].param_type === 'datetime'">
                            <b-row v-if="['wanalyzer_create_query', 'wanalyzer_credit_count'].indexOf(p_selectedProjectType) !== -1 || (['wanalyzer_dataset_stats_query'].indexOf(p_selectedProjectType) !== -1 && d_project.column_list[indx_lst_indx].wai_output) || (['wanalyzer_dataset_filter'].indexOf(p_selectedProjectType) !== -1 && (d_project.column_list[indx_lst_indx].wai_output || d_project.column_list[indx_lst_indx].wai_input))" style="border-bottom: solid 1px rgb(227, 246, 255); font-size: 12px; margin:  0px;">

                              <b-col sm="12" lg="4" style="font-size: 12px;">
                                 <strong>{{ d_project.column_list[indx_lst_indx].name }}</strong>
                                 <i v-if="d_project.column_list[indx_lst_indx].info" class="fa fa-info-circle" :title="d_project.column_list[indx_lst_indx].info" style="color: blue;" @click="f_showTextAsModal(d_project.column_list[indx_lst_indx].info)"></i>
                              </b-col>
                              <b-col sm="12" lg="3">
                                <b-dropdown variant="white" size="sm" style="width: 100%; margin: 0px;" no-caret>
                                  <template slot="button-content">
                                    <div style="font-size: 12px; white-space: pre-wrap;">
                                      <i class="fa fa-check"></i>
                                      {{ d_project.column_list[indx_lst_indx].operation ? d_project.column_list[indx_lst_indx].operation.translation[StoreLang] : '' }}
                                    </div>
                                  </template>
                                  <template v-for="(oper, oper_ind) in d_operatorList">
                                    <b-dropdown-item @click="f_selectOperationForColumn(d_project.column_list.indexOf(d_project.column_list[indx_lst_indx]), oper)">
                                      <i class="fa fa-check"></i>
                                      {{ oper.translation[StoreLang] }}
                                    </b-dropdown-item>
                                  </template>
                                </b-dropdown>
                              </b-col>
                              <b-col sm="12" lg="3">
                                <b-form-input type="date" style="font-size: 12px;" v-model="d_project.column_list[indx_lst_indx].selected"></b-form-input>
                                <!-- <b-form-input type="number" style="font-size: 12px;" v-model="d_project.column_list[indx_lst_indx].selected" @change="f_wanalyzerProjectStatisticsAnalyzeList()"></b-form-input> -->
                              </b-col>

                              <b-col v-if=
                              "!(d_selectedTabItemId == 'machine_learning_training' && d_selectedOutput == indx_lst_indx) && (['wanalyzer_create_query', 'wanalyzer_credit_count'].indexOf(p_selectedProjectType) !== -1 || (['wanalyzer_dataset_stats_query'].indexOf(p_selectedProjectType) !== -1 && d_project.column_list[indx_lst_indx].wai_output) || (['wanalyzer_dataset_filter'].indexOf(p_selectedProjectType) !== -1 && (d_project.column_list[indx_lst_indx].wai_output || d_project.column_list[indx_lst_indx].wai_input)))" sm="12" lg="2" @click="f_selectColumnUseAsStats(d_project.column_list.indexOf(d_project.column_list[indx_lst_indx]))" style="cursor: pointer;">
                                <i v-if="d_project.column_list[indx_lst_indx].use_as_stats === 'yes' && d_project.column_list[indx_lst_indx].wai_output && d_selectedModeTab === 'graph_mode'" class="fa fa-area-chart" style="color: #26f502; font-size: 24px;"></i>
                                <i v-else-if="d_project.column_list[indx_lst_indx].use_as_stats === 'yes'" class="fa fa-area-chart" style="color: #028bf5; font-size: 24px;"></i>
                                <i v-else-if="['wanalyzer_dataset_filter'].indexOf(p_selectedProjectType) !== -1 && d_selectedModeTab === 'detailed_mode' && d_project.column_list[indx_lst_indx].compare_eligible === '0'" class="fa fa-area-chart" style="color: red; font-size: 24px; opacity: 0.3;"></i>
                                <i v-else class="fa fa-minus-square" style="font-size: 24px;"></i>
                                <small v-if="d_selectedModeTab === 'graph_mode' && d_project.column_list[indx_lst_indx].multi_dimension_order">
                                  {{ d_project.column_list[indx_lst_indx].multi_dimension_order }}
                                </small>
                              </b-col>

                              <b-col v-else sm="12" lg="2"> </b-col>

                            </b-row>
                          </template>

                          <template v-else>
                            <b-row v-if="['wanalyzer_create_query', 'wanalyzer_credit_count'].indexOf(p_selectedProjectType) !== -1 || (['wanalyzer_dataset_stats_query'].indexOf(p_selectedProjectType) !== -1 && d_project.column_list[indx_lst_indx].wai_output) || (['wanalyzer_dataset_filter'].indexOf(p_selectedProjectType) !== -1 && (d_project.column_list[indx_lst_indx].wai_output || d_project.column_list[indx_lst_indx].wai_input))" style="border-bottom: solid 1px rgb(227, 246, 255); font-size: 12px; margin:  0px;">

                              <b-col sm="12" lg="4" style="font-size: 12px;">
                                 <strong>{{ d_project.column_list[indx_lst_indx].name }}</strong>
                                 <i v-if="d_project.column_list[indx_lst_indx].info" class="fa fa-info-circle" :title="d_project.column_list[indx_lst_indx].info" style="color: blue;" @click="f_showTextAsModal(d_project.column_list[indx_lst_indx].info)"></i>
                                 <div>
                                  <b-form-select v-if="d_project.column_list[d_project.column_list.indexOf(d_project.column_list[indx_lst_indx])].use_as_stats == 'yes'" v-model="d_project.column_list[d_project.column_list.indexOf(d_project.column_list[indx_lst_indx])].stats_data_type" style="font-size: 12px;">
                                    <option style="font-size: 12px;" value="categorical" >
                                      {{ StoreLangTranslation.data['categorical'][StoreLang] }}
                                    </option>
                                    <option style="font-size: 12px;" value="numeric" >
                                      {{ StoreLangTranslation.data['numeric'][StoreLang] }}
                                    </option>
                                  </b-form-select>
                                 </div>
                              </b-col>
                              <b-col sm="12" lg="3">
                                <b-dropdown variant="white" size="sm" style="width: 100%; margin: 0px;" no-caret>
                                  <template slot="button-content">
                                    <div style="font-size: 12px; white-space: pre-wrap;">
                                      <i class="fa fa-check"></i>
                                      {{ d_project.column_list[indx_lst_indx].operation ? d_project.column_list[indx_lst_indx].operation.translation[StoreLang] : '' }}
                                    </div>
                                  </template>
                                  <template v-for="(oper, oper_ind) in d_operatorList">
                                    <b-dropdown-item @click="f_selectOperationForColumn(d_project.column_list.indexOf(d_project.column_list[indx_lst_indx]), oper)">
                                      <i class="fa fa-check"></i>
                                      {{ oper.translation[StoreLang] }}
                                    </b-dropdown-item>
                                  </template>
                                </b-dropdown>
                              </b-col>
                              <b-col sm="12" lg="3">
                                <b-form-input type="text" style="font-size: 12px;" v-model="d_project.column_list[indx_lst_indx].selected"></b-form-input>
                              </b-col>

                              <b-col v-if=
                              "!(d_selectedTabItemId == 'machine_learning_training' && d_selectedOutput == indx_lst_indx) && (['wanalyzer_create_query', 'wanalyzer_credit_count'].indexOf(p_selectedProjectType) !== -1 || (['wanalyzer_dataset_stats_query'].indexOf(p_selectedProjectType) !== -1 && d_project.column_list[indx_lst_indx].wai_output) || (['wanalyzer_dataset_filter'].indexOf(p_selectedProjectType) !== -1 && (d_project.column_list[indx_lst_indx].wai_output || d_project.column_list[indx_lst_indx].wai_input)))" sm="12" lg="2" @click="f_selectColumnUseAsStats(d_project.column_list.indexOf(d_project.column_list[indx_lst_indx]))" style="cursor: pointer;">
                                <i v-if="d_project.column_list[indx_lst_indx].use_as_stats === 'yes' && d_project.column_list[indx_lst_indx].wai_output && d_selectedModeTab === 'graph_mode'" class="fa fa-area-chart" style="color: #26f502; font-size: 24px;"></i>
                                <i v-else-if="d_project.column_list[indx_lst_indx].use_as_stats === 'yes'" class="fa fa-area-chart" style="color: #028bf5; font-size: 24px;"></i>
                                <i v-else-if="['wanalyzer_dataset_filter'].indexOf(p_selectedProjectType) !== -1 && d_selectedModeTab === 'detailed_mode' && d_project.column_list[indx_lst_indx].compare_eligible === '0'" class="fa fa-area-chart" style="color: red; font-size: 24px; opacity: 0.3;"></i>
                                <i v-else class="fa fa-minus-square" style="font-size: 24px;"></i>
                                <small v-if="d_selectedModeTab === 'graph_mode' && d_project.column_list[indx_lst_indx].multi_dimension_order">
                                  {{ d_project.column_list[indx_lst_indx].multi_dimension_order }}
                                </small>
                              </b-col>

                              <b-col v-else sm="12" lg="2"> </b-col>

                            </b-row>
                          </template>
                        </div>
                      </div>
                    </template>
                    <!-- <b-row>
                      <b-col sm="12" lg="6"> </b-col>
                      <b-col sm="12" lg="6" style="text-align: right;">
                        <template v-if="['wanalyzer_dataset_filter'].indexOf(p_selectedProjectType) !== -1">
                          <b-button variant="outline-primary" size="sm" @click="f_wanalyzerServicesTrigger()">
                            <i class="fa fa-send-o"></i> {{ StoreLangTranslation.data['analyze'][StoreLang] }}
                          </b-button>
                        </template>
                        <template v-else>
                          <b-button variant="outline-primary" size="sm" @click="f_wanalyzerProjectStatisticsAnalyzeList()">
                            <i class="fa fa-send-o"></i> {{ StoreLangTranslation.data['analyze'][StoreLang] }}
                          </b-button>
                        </template>
                      </b-col>
                    </b-row> -->
                  


                  </div>

                </template>

              </b-col>


              <b-col sm="12" md="12" :lg="d_variablesShow ? 8 : 12" style="border-left: solid 1px lightblue;">
                <b-button v-if="!d_variablesShow" variant="outline-primary" size="sm" @click="f_variablesListShow()" style="margin-right: 5px;">
                  <i class="fa fa-list"></i>
                </b-button>
                <template>
                  <b-tabs v-if="p_selectedProjectType === 'wanalyzer_dataset_filter' && d_firstOutputIndex !== ''">
                    <b-tab :active="'graph_mode' === d_selectedModeTab" @click="d_selectedModeTab = 'graph_mode'">
                      <template slot="title">
                        <i class="fa fa-bar-chart fa-lg"></i>
                        <span v-if="'graph_mode' === d_selectedModeTab" style="font-weight: bold;">
                        {{ StoreLangTranslation.data['graph_mode'][StoreLang] }}
                        <i class="fa fa-info-circle" style="color:#2492FF;margin-left:5px;" @click="$help('projects_graph_mode', StoreLang)"> </i>
                        </span>
                        <span v-else>
                        {{ StoreLangTranslation.data['graph_mode'][StoreLang] }}
                        <i class="fa fa-info-circle" style="color:#2492FF;margin-left:5px;" @click="$help('projects_graph_mode', StoreLang)"> </i>
                        </span>
                      </template>
                    </b-tab>
                    <b-tab :active="'detailed_mode' === d_selectedModeTab" @click="d_selectedModeTab = 'detailed_mode'">
                      <template slot="title">
                        <i class="fa fa-list fa-lg"></i>
                        <span v-if="'detailed_mode' === d_selectedModeTab" style="font-weight: bold;">
                        {{ StoreLangTranslation.data['detailed_mode'][StoreLang] }}
                        </span>
                        <span v-else>
                        {{ StoreLangTranslation.data['detailed_mode'][StoreLang] }}
                        </span>
                      </template>
                    </b-tab>
                  </b-tabs>
                  <b-button v-if="d_selectedModeTab === 'graph_mode'" style="float: right;" variant="outline-white" @click="d_wTableShow = !d_wTableShow">
                    <i class="fa fa-table fa-lg" title="Wtable"></i>
                  </b-button>
                  <template v-if="d_selectedModeTab === 'graph_mode'">
                    <template v-if="d_datasetViewLoading || d_projectColumnListLoading || d_statsViewLoading || d_columnListLoading">
                      <br/>
                      <b-spinner variant="primary" label="Spinning"></b-spinner>

                    </template>
                    <template v-else>
                      <template v-for="(proj_item, proj_id) in d_statisticResults">
                        <template v-for="(stats_item, stats_id) in proj_item">
                          <template v-if="stats_item.stats_data && stats_item.stats_data.data && stats_item.stats_data.data.general && stats_item.stats_data.data.general.analyze_type && stats_item.stats_data.data.general.analyze_type.val && stats_item.stats_data.data.general.analyze_type.val.value && stats_item.stats_data.data.general.analyze_type.val.value === 'cross_columns'">
                            <template v-for="(analyze_item, analyze_index) in stats_item.analyze_list">
                              <div style="min-height: 500px;">
                                <template v-if="analyze_item.table_list.length > 0">
                                  <template v-for="(table_item, table_index) in analyze_item.table_list">
                                    <template v-if="table_item.type === 'categorical_numeric' || table_item.type === 'numeric_categorical'">
                                      <b-card-header header-bg-variant="white" class="p-1" header-text-variant="dark">
                                        <strong> {{ analyze_item.label }} </strong>
                                      </b-card-header>
                                      <b-row style="margin: 3px;">
                                        <b-col cols="3">
                                          <!-- <strong>{{ table_item.label }}</strong> -->
                                        </b-col>
                                        <b-col cols="2">
                                          <span v-if="Number.isInteger(table_item.table.slice(1).reduce((toplam, satir) => toplam + satir[5], 0))">
                                            {{ table_item.table.slice(1).reduce((toplam, satir) => toplam + satir[5], 0) }}
                                          </span>
                                          <span v-else>
                                            {{ parseFloat(table_item.table.slice(1).reduce((toplam, satir) => toplam + satir[5], 0)).toFixed(1) }}
                                          </span>
                                        </b-col>
                                        <b-col cols="7">
                                            <b-progress :value="100" class="mb-3"></b-progress>
                                        </b-col>
                                      </b-row>
                                      <template v-for="(table_row, table_row_index) in table_item.table
                                        .slice(1)
                                        .sort((a, b) => parseFloat(b[5]) - parseFloat(a[5]))">
                                        <b-row style="margin: 3px; border-bottom: solid 1px whitesmoke;">
                                          <b-col cols="3">
                                            <span style="margin-left: 20px;">
                                              <!-- {{ table_row_index }} ) -->
                                              {{ table_row[0] }}
                                            </span>
                                          </b-col>
                                          <b-col cols="2">
                                            <strong v-if="Number.isInteger(table_row[5])"> {{ table_row[5] }} </strong>
                                            <strong v-else> {{ parseFloat(table_row[5]).toFixed(1) }} </strong>
                                          </b-col>
                                          <b-col cols="7">
                                            <b-progress :style="table_item.table.length <= 10 ? { height: (300 / table_item.table.length) + 'px' } : {}">
                                              <b-progress-bar
                                                :value="(table_row[5] / table_item.table.slice(1).reduce((toplam, satir) => toplam + satir[5], 0)) * 100"
                                                :style="{ backgroundColor: d_colorList[table_item.table.indexOf(table_row) - 1] ? d_colorList[table_item.table.indexOf(table_row) - 1].code : '#090fb3' }">
                                              </b-progress-bar>
                                            </b-progress>
                                          </b-col>
                                        </b-row>
                                      </template>
                                    </template>

                                    <template v-else-if="table_item.type === 'categorical_categorical' && table_index === 0">
                                      <b-card-header header-bg-variant="white" class="p-1" header-text-variant="dark">
                                        <strong> {{ analyze_item.label }} </strong>
                                      </b-card-header>
                                      <b-row style="margin: 3px;">
                                        <b-col cols="4">
                                          <!-- <strong>{{ table_item.label }}</strong> -->
                                        </b-col>
                                        <b-col cols="2">
                                          {{ parseFloat(table_item.table[table_item.table.length-1][table_item.table[0].length-1]).toFixed(1) }}
                                        </b-col>
                                        <b-col cols="6">
                                          <b-row style="margin: 3px;">
                                            <b-col cols="12">
                                              <b-progress :value="100" class="mb-3"></b-progress>
                                            </b-col>
                                          </b-row>
                                        </b-col>
                                      </b-row>
                                      <template v-for="(table_row_for_title, table_row_for_title_index) in table_item.table[0]">
                                        <template v-if="table_row_for_title_index !== 0 && table_row_for_title_index !== table_item.table.length-1">
                                          <b-row style="margin: 3px; border-bottom: solid 1px whitesmoke;">
                                            <b-col cols="2">
                                              <span>
                                                {{ table_item.table[0][table_row_for_title_index] }}
                                              </span>
                                            </b-col>
                                            <b-col cols="10">
                                              <template v-for="(table_row, table_row_index) in table_item.table">
                                                <b-row v-if="table_row_index !== 0 && table_row_index !== table_item.table.length-1" style="margin: 3px; border-bottom: solid 1px whitesmoke;">
                                                  <b-col cols="3">
                                                    <span style="margin-left: 20px;">
                                                      <!-- {{ table_row_index }} ) -->
                                                      {{ table_row[0] }}
                                                    </span>
                                                  </b-col>
                                                  <b-col cols="2">
                                                    <strong> {{ parseFloat(table_row[table_row_for_title_index].split(' ')[0]).toFixed(1) }} </strong>
                                                  </b-col>
                                                  <b-col cols="7">
                                                    <b-progress :style="(table_item.table.length * (table_item.table[0].length - 2)) <= 10 ? { height: (300 / (table_item.table.length * (table_item.table[0].length - 2))) + 'px' } : {}">
                                                      <b-progress-bar :value="(parseFloat(table_row[table_row_for_title_index].split(' ')[0]) / parseFloat(table_item.table[table_item.table.length-1][table_item.table[0].length-1])) * 100" :style="{ backgroundColor: table_row_index - 1 < 51 ? d_colorList[table_row_index - 1].code : '#cccccc' }"></b-progress-bar>
                                                    </b-progress>
                                                  </b-col>
                                                </b-row>
                                              </template>
                                            </b-col>
                                          </b-row>
                                        </template>
                                      </template>
                                    </template>

                                    <!-- <template v-else-if="table_item.type === 'multi_dima' && table_index === 0">
                                      <b-card-header header-bg-variant="white" class="p-1" header-text-variant="dark">
                                        <span style="font-weight: 600"> {{ analyze_item.label }} </span>
                                      </b-card-header>

                                      <div style="overflow-x: auto; height: 500px;">
                                        <div style="display: flex; flex-direction: column; width: max-content;">
                                          
                                          <div style="margin: 3px; display: flex;">
                                            <div style="display: flex; min-width: 200px;">
                                              <template v-for="(title_item, title_item_index) in table_item.table[0]">
                                                <div v-if="title_item_index + 5 < table_item.table[0].length" :title="title_item" style="width: 100px; flex-shrink: 0; overflow: hidden; text-overflow: ellipsis; white-space: nowrap;">
                                                  {{ title_item.length > 10 ? title_item.slice(0, 10) + '...' : title_item }}
                                                </div>
                                              </template>
                                            </div>
                                            <div style="width: 75px; flex-shrink: 0;">{{ f_sumLastColumns(table_item.table) }}</div>
                                            <div style="width: 500px; flex-shrink: 0;">
                                              <b-progress :value="100" class="mb-3"></b-progress>
                                            </div>
                                          </div>
                                          <div style="overflow-y: auto;">
                                            <template v-for="(sub_item, sub_item_index) in table_item.table.slice(1).sort((a, b) => parseFloat(b[b.length - 1]) - parseFloat(a[a.length - 1]))">
                                              <div style="display: flex; margin: 3px;">
                                                <div style="min-width: 200px; display: flex;">
                                                  <template v-for="(sub_item_row, sub_item_row_index) in sub_item">
                                                    <div v-if="sub_item_row_index + 5 < sub_item.length" :title="String(sub_item_row)" style="width: 100px; flex-shrink: 0; overflow: hidden; text-overflow: ellipsis; white-space: nowrap;">
                                                      {{ String(sub_item_row).length > 10 ? String(sub_item_row).slice(0, 10) + '...' : sub_item_row }}
                                                    </div>
                                                  </template>
                                                </div>
                                                <div style="width: 75px; flex-shrink: 0;">{{ sub_item[sub_item.length - 1] }}</div>
                                                <div style="width: 500px; flex-shrink: 0;">
                                                  <b-progress :style="table_item.table.length - 1 <= 10 ? { height: (300 / (table_item.table.length - 1)) + 'px' } : {}">
                                                    <b-progress-bar :value="(sub_item[sub_item.length - 1] / f_sumLastColumns(table_item.table)) * 100" :style="{ backgroundColor: d_colorList[sub_item_index - 1] ? d_colorList[sub_item_index - 1].code : '#090fb3' }"></b-progress-bar>
                                                  </b-progress>
                                                </div>
                                              </div>
                                              <hr style="margin: 0;" />
                                            </template>
                                          </div>
                                        </div>
                                      </div>
                                    </template> -->

                                    <template v-else-if="table_item.type === 'multi_dim' && table_index === 0">
                                      <b-card-header header-bg-variant="white" class="p-1" header-text-variant="dark">
                                        <span style="font-weight: 600"> {{ analyze_item.label }} </span>
                                      </b-card-header>
                                      <div style="overflow-x: auto; height: 500px; overflow-y: hidden;">
                                        <div style="display: flex; flex-direction: column; width: max-content;">
                                          <div style="margin: 3px; display: flex; position: sticky; top: 0; background: white; z-index: 1;">
                                            <div style="display: flex; min-width: 200px;">
                                              <template v-for="(title_item, title_item_index) in table_item.table[0]">
                                                <div v-if="title_item_index + 5 < table_item.table[0].length" :title="title_item"
                                                  style="width: 100px; flex-shrink: 0; overflow: hidden; text-overflow: ellipsis; white-space: nowrap;">
                                                  {{ title_item.length > 10 ? title_item.slice(0, 10) + '...' : title_item }}
                                                </div>
                                              </template>
                                            </div>
                                            <div style="width: 75px; flex-shrink: 0;">{{ f_sumLastColumns(table_item.table) }}</div>
                                            <div style="width: 500px; flex-shrink: 0;">
                                              <b-progress :value="100" class="mb-3"></b-progress>
                                            </div>
                                          </div>

                                          <div style="overflow-y: auto; height: 450px;">
                                            <template
                                              v-for="(sub_item, sub_item_index) in table_item.table.slice(1).sort((a, b) => parseFloat(b[b.length - 1]) - parseFloat(a[a.length - 1]))">
                                              <div style="display: flex; margin: 3px;">
                                                <div style="min-width: 200px; display: flex;">
                                                  <template v-for="(sub_item_row, sub_item_row_index) in sub_item">
                                                    <div v-if="sub_item_row_index + 5 < sub_item.length" :title="String(sub_item_row)"
                                                      style="width: 100px; flex-shrink: 0; overflow: hidden; text-overflow: ellipsis; white-space: nowrap;">
                                                      {{ String(sub_item_row).length > 10 ? String(sub_item_row).slice(0, 10) + '...' : sub_item_row }}
                                                    </div>
                                                  </template>
                                                </div>
                                                <div style="width: 75px; flex-shrink: 0;">{{ sub_item[sub_item.length - 1] }}</div>
                                                <div style="width: 500px; flex-shrink: 0;">
                                                  <b-progress :style="table_item.table.length - 1 <= 10 ? { height: (300 / (table_item.table.length - 1)) + 'px' } : {}">
                                                    <b-progress-bar :value="(sub_item[sub_item.length - 1] / f_sumLastColumns(table_item.table)) * 100" :style="{ backgroundColor: d_colorList[sub_item_index - 1] ? d_colorList[sub_item_index - 1].code : '#090fb3' }">
                                                    </b-progress-bar>
                                                  </b-progress>
                                                </div>
                                              </div>
                                              <hr style="margin: 0;" />
                                            </template>
                                          </div>
                                        </div>
                                      </div>
                                    </template>


                                  </template>
                                </template>
                              </div>
                            </template>
                          </template>
                        </template>
                      </template>
                    </template>
                  </template>
                  <template v-else-if="d_selectedModeTab === 'detailed_mode'">
                    <b-row style="margin: 3px;">
                      <b-col sm="12" lg="12">
                        <b-tabs>
                          <!-- dataset sadece wanalyzer_dataset_filter modunda gösteriliyor  -->
                          <b-tab v-if="['wanalyzer_dataset_filter', 'wanalyzer_credit_count', 'wanalyzer_create_query'].indexOf(p_selectedProjectType) !== -1" :active="'dataset_view' === d_selectedTabItemId" @click="d_selectedTabItemId = 'dataset_view'">
                            <template slot="title">
                              <i class="fa fa-area-chart"></i>
                              <span v-if="'dataset_view' === d_selectedTabItemId" style="font-weight: bold;">
                              {{ StoreLangTranslation.data['dataset'][StoreLang] }}
                              <i class="fa fa-info-circle" style="color:#2492FF;margin-left:5px;" @click="$help('projects_dataset_filter', StoreLang)"> </i>
                              </span>
                              <span v-else>
                              {{ StoreLangTranslation.data['dataset'][StoreLang] }}
                              <i class="fa fa-info-circle" style="color:#2492FF;margin-left:5px;" @click="$help('projects_dataset_filter', StoreLang)"> </i>
                              </span>
                            </template>
                            <template v-if="'dataset_view' === d_selectedTabItemId">
                              <b-card-header header-bg-variant="white" header-text-variant="dark" style="margin-bottom: 10px;">
                                <b-row>
                                  <b-col sm="12" lg="4">
                                    
                                  </b-col>
                                  <b-col sm="12" lg="2"></b-col>
                                  <b-col sm="12" lg="3"></b-col>
                                  <b-col sm="12" lg="3">
                                    <template v-if="!d_autoLoading && !d_statsViewLoading">
                                      <b-button variant="outline-primary" size="sm" @click="f_wanalyzerProjectDatasetGet('dataset_filter_table')">
                                        <i class="fa fa-send-o"></i> {{ StoreLangTranslation.data['dataset_prepare'][StoreLang] }}
                                      </b-button>
                                    </template>
                                    <template v-if="d_statsViewLoading">
                                        <b-spinner variant="primary" label="Spinning"></b-spinner>
                                    </template>
                                  </b-col>
                                </b-row>
                              </b-card-header>
                              <template v-if="d_datasetViewLoading">
                                <b-spinner variant="primary" label="Spinning"></b-spinner>
                              </template>
                              <template v-else>
                                <!-- {{d_datasetWTableFilter}} -->
                                <w-table2 style="transition: 2s; transform: none;" v-if="d_datasetWTableFilter && d_datasetShow" :key="'dataset_view'" :p_tableDetails="d_datasetWTableFilter"></w-table2>
                              </template>
                            </template>
                          </b-tab>
                          


                          <b-tab v-if="['wanalyzer_create_query', 'wanalyzer_credit_count', 'wanalyzer_dataset_stats_query'].indexOf(p_selectedProjectType) !== -1 || (['wanalyzer_dataset_filter'].indexOf(p_selectedProjectType) !== -1 && d_compareEligible)" :active="'stats_results' === d_selectedTabItemId" @click="d_selectedTabItemId = 'stats_results'">
                            <template slot="title">
                              <i class="fa fa-area-chart"></i>
                              {{ StoreLangTranslation.data['stats'][StoreLang] }}
                            </template>
                            <template v-if="'stats_results' === d_selectedTabItemId">
                              <!-- istatistik varsa her halükarda gösteriliyor. -->
                              <b-card-header v-if="d_variablesShow" header-bg-variant="white" header-text-variant="dark" style="margin-bottom: 10px;">
                                
                                <b-row style="margin: 3px;">
                                  <b-col sm="12" lg="4">
                                    {{ StoreLangTranslation.data['statistics_methods'][StoreLang] }}
                                    <i class="fa fa-info-circle" style="color:#2492FF;margin-left:5px;" @click="$help('projects_statistics_methods', StoreLang)"> </i>
                                  </b-col>
                                  <b-col sm="12" lg="5">
                                    <b-form-select v-model="d_selectedStatisticsMethod" style="display: inline; font-size: 12px; width: 100%;" @change="d_selectedOutput = ''">
                                      <option value="selected_variables_descriptive">{{ StoreLangTranslation.data['selected_variables_descriptive'][StoreLang] }}</option>
                                      <option value="selected_variables_combinations_compare">{{ StoreLangTranslation.data['selected_variables_combinations_compare'][StoreLang] }}</option>
                                      <option value="selected_multi_input_and_one_output_variable">{{ StoreLangTranslation.data['selected_multi_input_and_one_output_variable'][StoreLang] }}</option>
                                    </b-form-select>
                                  </b-col>
                                  <b-col sm="12" lg="3" style="text-align: right;">
                                    <template v-if="!d_autoLoading && !d_statsViewLoading">
                                      <!-- analyze analyze analyze analyze -->
                                      <b-button variant="outline-primary" size="sm" @click="f_wanalyzerServicesTrigger()">
                                        <i class="fa fa-send-o"></i> {{ StoreLangTranslation.data['analyze'][StoreLang] }}
                                      </b-button>

                                      <b-button v-if="p_projectPermission && p_projectPermission.auth_data" variant="outline-secondary" size="sm" @click="f_wanalyzerProjectOldResultList('statistical_analysis')" style="margin-left: 10px;">
                                        {{ StoreLangTranslation.data['old_results'][StoreLang] }}
                                        <i class="fa fa-info-circle" style="color:#2492FF;margin-left:5px;" @click="$help('projects_old_results', StoreLang)"> </i>
                                        <!-- <i class="fa fa-send-o"></i> {{ StoreLangTranslation.data['analyze'][StoreLang] }} -->
                                      </b-button>

                                    </template>
                                    <template v-if="d_statsViewLoading">
                                        <b-spinner variant="primary" label="Spinning"></b-spinner>
                                    </template>
                                  </b-col>
                                </b-row>

                                <template v-if="d_selectedStatisticsMethod === 'selected_multi_input_and_one_output_variable'">
                                  <b-row style="margin: 3px;">
                                    <b-col sm="12" lg="4">
                                      {{ StoreLangTranslation.data['output'][StoreLang] }}
                                    </b-col>
                                    <b-col sm="12" lg="5">
                                         <b-form-select v-model="d_selectedOutput" style="font-size: 12px; width: 100%;">
                                          <option v-for="x in d_project.column_list" :value="x.index" :key="x.index">{{ x.name }}</option>
                                        </b-form-select>
                                    </b-col>
                                    <b-col sm="12" lg="3"></b-col>
                                  </b-row>

                                  <b-row style="margin: 3px;" v-if="d_selectedOutput && d_project.column_list[d_selectedOutput].param_type === 'text'">
                                    <b-col sm="12" lg="4">
                                      {{ StoreLangTranslation.data['param_type'][StoreLang] }}
                                      <i class="fa fa-info-circle" style="color:#2492FF;margin-left:5px;" @click="$help('projects_param_type_text_analyze', StoreLang)"> </i>
                                    </b-col>
                                    <b-col sm="12" lg="5">
                                      <b-form-select v-model="d_selectedOutputParamType" style="display: inline; font-size: 12px; width: 100%;">
                                        <option value="categorical">
                                          {{ StoreLangTranslation.data['categorical'][StoreLang] }}
                                        </option>
                                        <option value="numeric" >
                                          {{ StoreLangTranslation.data['numeric'][StoreLang] }}
                                        </option>
                                      </b-form-select>
                                    </b-col>
                                    <b-col sm="12" lg="3"></b-col>
                                  </b-row>

                                  <b-row style="margin: 3px;" v-if="d_selectedOutput && d_project.column_list[d_selectedOutput].param_type === 'select' && d_project.column_list[d_selectedOutput].options.length === 2 && d_selectedStatisticsMethod === 'selected_multi_input_and_one_output_variable'">
                                    <b-col sm="12" lg="4">
                                      {{ StoreLangTranslation.data['logistic_regression_true_option'][StoreLang] }}
                                      <i class="fa fa-info-circle" style="color:#2492FF;margin-left:5px;" @click="$help('projects_logistic_regression_true_option', StoreLang)"> </i>
                                    </b-col>
                                    <b-col sm="12" lg="5">
                                    <template v-if="d_selectedOutput && d_project.column_list[d_selectedOutput].options && d_project.column_list[d_selectedOutput].options.length === 2">
                                      <b-form-select v-model="d_selectedOutputTrueOption" style="max-width: 150px; display: inline; font-size: 12px;">
                                        <option value="" >{{ '-' }}</option>
                                        <option v-for="output_option in d_project.column_list[d_selectedOutput].options" :value="output_option.label" :key="output_option.value">{{ output_option.label }}</option>
                                      </b-form-select>
                                    </template>
                                    </b-col>
                                    <b-col sm="12" lg="3"></b-col>
                                  </b-row>

<!--                                   <b-row style="margin: 3px;">
                                    <b-col sm="12" lg="4">
                                       {{ StoreLangTranslation.data['add_total_row'][StoreLang] }}
                                       <i class="fa fa-info-circle" style="color:#2492FF;margin-left:5px;" @click="$help('add_total_row', StoreLang)"> </i>
                                    </b-col>
                                    <b-col sm="12" lg="5">
                                      <b-form-select v-model="d_addTotalRow" style="display: inline; font-size: 12px; width: 100%;">
                                        <option value="yes">{{ StoreLangTranslation.data['yes'][StoreLang] }}</option>
                                        <option value="no">{{ StoreLangTranslation.data['no'][StoreLang] }}</option>
                                      </b-form-select>
                                    </b-col>
                                    <b-col sm="12" lg="3" style="text-align: right;"></b-col>
                                  </b-row> -->
                                </template>

                                <b-row style="margin: 3px;">
                                  <b-col sm="12" lg="4">
                                     {{ StoreLangTranslation.data['analyze_cross_columns_by_two_grouping'][StoreLang] }}
                                     <i class="fa fa-info-circle" style="color:#2492FF;margin-left:5px;" @click="$help('project_analyze_cross_columns_by_two_grouping', StoreLang)"> </i>
                                  </b-col>
                                  <b-col sm="12" lg="5">
                                    <b-form-select v-model="d_analyze_cross_columns_by_two_grouping" style="display: inline; font-size: 12px; width: 100%;">
                                      <option value="yes">{{ StoreLangTranslation.data['yes'][StoreLang] }}</option>
                                      <option value="no">{{ StoreLangTranslation.data['no'][StoreLang] }}</option>
                                    </b-form-select>
                                  </b-col>
                                  <b-col sm="12" lg="3" style="text-align: right;"></b-col>
                                </b-row>

                              </b-card-header>

                              <b-row v-if="d_taskStarted" style="background-color: #bcf7fe; border-radius: 5px; min-height: 40px; font-size: 20px; text-align: center;">
                                <b-col sm="12" lg="10">
                                  <div class="processing-banner">
                                    <div class="spinner"></div>
                                    <div class="processing-text">
                                      {{ StoreLangTranslation.data['task_is_continuing_background'][StoreLang] }}
                                    </div>
                                  </div>
                                </b-col>
                                <b-col sm="12" lg="2">
                                    <b-button variant="outline-danger" size="sm" @click="f_cancelService()">
                                      <i class="fa fa-trash"></i> cancel
                                    </b-button>

                                </b-col>
                              </b-row>


                              <b-row>
                                <b-col sm="12" lg="4">
                                  <b-row>
                                    <b-col cols="12">
                                      <b-card-header header-bg-variant="outline-primary" class="p-1">
                                        {{ StoreLangTranslation.data['outputs'][StoreLang] }}
                                        <i class="fa fa-info-circle" style="color:#2492FF;margin-left:5px;" @click="$help('statistics_parameters', StoreLang)"> </i>
                                      </b-card-header>
                                    </b-col>
                                  </b-row>
                                  <div :style="d_variablesShow ? 'overflow-x: hidden; overflow-y: auto; height: 400px;' : 'overflow-x: hidden; overflow-y: auto; height: 600px;'">
                                    <template v-if="d_statsViewLoading">
                                      <!-- <b-spinner variant="primary" label="Spinning">statistics loading</b-spinner> -->
                                    </template>
                                    <template v-else>
                                      <template v-for="(proj_item, proj_id) in d_statisticResults">
                                        <template v-for="(stats_item, stats_id) in proj_item">
                                          <div v-if="stats_item.analyze_list && stats_item.analyze_list.length > 0">
                                            {{ f_statsResultName(stats_item.stats_data) }}
                                            <hr style="border: solid 3px skyblue;">
                                          </div>
                                          <template v-for="(analyze_item, analyze_index) in stats_item.analyze_list">
                                            <b-row v-if="f_checkShowAnalyzeItem(analyze_item)" @click="d_selectedStatsResultItem = 'analyze_' + proj_id + '_' + stats_id + '_' + analyze_index" :style="d_selectedStatsResultItem === 'analyze_' + proj_id + '_' + stats_id + '_' + analyze_index ? 'cursor: pointer; margin: 0px; background-color: rgb(227, 246, 255); border-bottom: solid 1px rgb(227, 246, 255);' : 'cursor: pointer; margin: 0px; border-bottom: solid 1px rgb(227, 246, 255);'">
                                              <b-col cols="1" style="padding-left: 1px; padding-right: 1px;">
                                                <strong>{{ d_statsOrderList[stats_id + '_' + analyze_index] }} </strong> 
                                              </b-col>
                                              <b-col cols="11" style="padding-left: 1px; padding-right: 1px;">
                                                <template v-if="analyze_item.label_html">
                                                  <div v-html="analyze_item.label_html"></div>
                                                </template>
                                                <template v-else>
                                                  {{ analyze_item.label }}
                                                </template>

<!--                                                 <div class="alz-wrap">
                                                  <div class="alz-card">
                                                    <div class="alz-top">
                                                      <div>
                                                        <div class="alz-title">Statistical Analysis Summary</div>
                                                        <div class="alz-sub">Automatically generated analysis metadata</div>
                                                      </div>
                                                    </div>

                                                    <div class="alz-chips">
                                                      <span class="alz-chip alz-chip-ok">
                                                        <span class="alz-chip-k">Analyze Type</span>
                                                        <span class="alz-chip-v">cross_columns</span>
                                                      </span>

                                                      <span class="alz-chip alz-chip-warn">
                                                        <span class="alz-chip-k">Compare Type</span>
                                                        <span class="alz-chip-v">categorical-numeric</span>
                                                      </span>

                                                      <span class="alz-chip alz-chip-info">
                                                        <span class="alz-chip-k">Test List</span>
                                                        <span class="alz-chip-v">kruskal_wallis, oneway_anova, t_test, mann_whitney_u</span>
                                                      </span>
                                                    </div>
                                                  </div>
                                                </div> -->



                                              </b-col>
                                            </b-row>
                                          </template>
                                        </template>
                                      </template>
                                    </template>
                                  </div>
                                </b-col>
                                <b-col sm="12" lg="8">
                                  <template v-for="(proj_item, proj_id) in d_statisticResults">
                                    <template v-for="(stats_item, stats_id) in proj_item">
                                      <template v-for="(analyze_item, analyze_index) in stats_item.analyze_list">
                                        <template v-if="'analyze_' + proj_id + '_' + stats_id + '_' + analyze_index === d_selectedStatsResultItem">
                                            <div :style="d_variablesShow ? 'overflow-x: hidden; overflow-y: auto; height: 400px;' : 'overflow-x: hidden; overflow-y: auto; height: 600px;'">

                                              <wanalyzer-analyze-view v-if="d_statsShow" :key="'analyze_' + proj_id + '_' + stats_id + '_' + analyze_index" :p_analyzeList="[analyze_item]" :p_authClientId="p_projectPermission ? p_projectPermission.auth_data.client_id : undefined"></wanalyzer-analyze-view>
                                            </div>
                                        </template>
                                      </template>
                                    </template>
                                  </template>
                                </b-col>
                              </b-row>


                            </template>
                          </b-tab> 



                          <b-tab v-if="['wanalyzer_create_query', 'wanalyzer_credit_count'].indexOf(p_selectedProjectType) !== -1 || (['wanalyzer_dataset_filter'].indexOf(p_selectedProjectType) !== -1 && d_compareEligible)" :active="'machine_learning_training' === d_selectedTabItemId" @click="f_clickMachineLearningTraining()">
                            <template slot="title">
                              <i class="fa fa-area-chart"></i>
                              {{ StoreLangTranslation.data['machine_learning_training'][StoreLang] }}
                            </template>
                            <template v-if="d_selectedTabItemId === 'machine_learning_training'">
                              <b-card-header header-bg-variant="white" header-text-variant="dark" style="margin-bottom: 10px;">
                                <b-row>
                                  <b-col sm="12" lg="4">
                                    {{ StoreLangTranslation.data['output'][StoreLang] }}
                                    <i class="fa fa-info-circle" style="color:#2492FF;margin-left:5px;" @click="$help('projects_machine_learning_output', StoreLang)"> </i>
                                  </b-col>
                                  <b-col sm="12" lg="4">
                                    <b-form-select v-model="d_selectedOutput" style="max-width: 150px; display: inline; font-size: 12px;">
                                      <option v-for="x in d_project.column_list" :value="x.index" :key="x.index">{{ x.name }}</option>
                                    </b-form-select>
                                  </b-col>
                                  <b-col sm="12" lg="4">
                                    <template v-if="!d_autoLoading && !d_statsViewLoading && !d_mlTrainLoading">
                                      <b-button :disabled="!d_selectedOutput" variant="outline-primary" size="sm" @click="f_mlTrain()">
                                        <i class="fa fa-send-o"></i> {{ StoreLangTranslation.data['train'][StoreLang] }}
                                      </b-button>
                                      <b-button v-if="p_projectPermission && p_projectPermission.auth_data" variant="outline-secondary" size="sm" @click="f_wanalyzerProjectOldResultList('ml_training')" style="margin-left: 10px;">
                                        {{ StoreLangTranslation.data['old_results'][StoreLang] }}
                                        <!-- <i class="fa fa-send-o"></i> {{ StoreLangTranslation.data['analyze'][StoreLang] }} -->
                                      </b-button>
                                      <i class="fa fa-info-circle" style="color:#2492FF;margin-left:5px;" @click="$help('projects_old_results', StoreLang)"> </i>
                                    </template>
                                  </b-col>
                                </b-row>
                                <b-row>
                                  <b-col sm="12" lg="4">
                                    <template v-if="d_selectedOutput && d_project.column_list[d_selectedOutput].param_type === 'text'">
                                      {{ StoreLangTranslation.data['param_type'][StoreLang] }} {{ ': ' }}
                                    </template>
                                    <template v-if="d_selectedOutput && d_selectedOutputParamType == 'categorical' && d_project.column_list[d_selectedOutput].options && d_project.column_list[d_selectedOutput].options.length <= 3">
                                      {{ StoreLangTranslation.data['true_option'][StoreLang] }} {{ ': ' }}
                                      <i class="fa fa-info-circle" style="color:#2492FF;margin-left:5px;" @click="$help('projects_machine_learning_true_option', StoreLang)"> </i>
                                    </template>
                                  </b-col>
                                  <b-col sm="12" lg="4">
                                    <template v-if="d_selectedOutput && d_project.column_list[d_selectedOutput].param_type === 'text'">
                                      <b-form-select v-model="d_selectedOutputParamType" style="max-width: 150px; display: inline; font-size: 12px; margin-left: 5px;">
                                        <option value="categorical">
                                          {{ StoreLangTranslation.data['categorical'][StoreLang] }}
                                        </option>
                                        <option value="numeric" >
                                          {{ StoreLangTranslation.data['numeric'][StoreLang] }}
                                        </option>
                                      </b-form-select>
                                    </template>
                                    <template v-if="d_selectedOutput && d_selectedOutputParamType == 'categorical' && d_project.column_list[d_selectedOutput].options && d_project.column_list[d_selectedOutput].options.length === 2">
                                      <b-form-select v-model="d_selectedOutputTrueOption" style="max-width: 150px; display: inline; font-size: 12px;">
                                        <option value="" >{{ '-' }}</option>
                                        <option v-for="output_option in d_project.column_list[d_selectedOutput].options" :value="output_option.label" :key="output_option.value">{{ output_option.label }}</option>
                                      </b-form-select>
                                    </template>
                                  </b-col>
                                  <b-col sm="12" lg="4"></b-col>
                                </b-row>
                                <b-row>
                                  <b-col sm="12" lg="4">
                                    Multi Input Combination
                                  </b-col>
                                  <b-col sm="12" lg="4">
                                    <b-form-select v-model="d_machineLearningMultiInputCombinationType" style="max-width: 150px; display: inline; font-size: 12px; margin-left: 5px;">
                                      <option value="create_permutations">
                                        create_permutations
                                      </option>
                                      <option value="all_inputs_together" >
                                        all_inputs_together
                                      </option>
                                    </b-form-select>
                                  </b-col>
                                  <b-col sm="12" lg="4"></b-col>
                                </b-row>
                              </b-card-header>
                              <b-row>
                                <b-col sm="12" lg="12">
                                  <i class="fa fa-info-circle" style="color:#2492FF;margin-left:5px; cursor: pointer;" @click="$help('projects_machine_learning_model_list', StoreLang)">
                                      {{ StoreLangTranslation.data['machine_learning_training'][StoreLang] }}
                                  </i>
                                </b-col>
                              </b-row>

                              <b-row v-if="d_taskStarted" style="background-color: #bcf7fe; border-radius: 5px; min-height: 40px; font-size: 20px; text-align: center;">
                                <b-col sm="12" lg="12">
                                  <div class="processing-banner">
                                    <div class="spinner"></div>
                                    <div class="processing-text">
                                      {{ StoreLangTranslation.data['task_is_continuing_background'][StoreLang] }}
                                    </div>
                                  </div>
                                </b-col>
                              </b-row>
                              <b-row v-if="d_mlModelList.length > 0">
                                <b-col cols="12">
                                  <span style="font-size: 18px; margin: 0 10px;">{{ StoreLangTranslation.data['machine_learning_models_used'][StoreLang] }} {{': '}} <strong>{{ d_mlModelList.length }}</strong></span>
                                  <b-card no-body header-tag="header">
                                    <b-card-header header-bg-variant="secondary" class="p-1" header-text-variant="dark">
                                      <b-row>
                                        <b-col lg="10">
                                          <small>{{ StoreLangTranslation.data['model_list'][StoreLang] }}</small>
                                          <i class="fa fa-info-circle" style="color:#2492FF;margin-left:5px;" @click="$help('projects_machine_learning_model_list', StoreLang)"> </i>
                                        </b-col>
                                        <b-col lg="2">
                                          <b-dropdown variant="success" size="sm" class="pull-right" style="margin: 5px;">
                                            <b-dropdown-item @click="f_downloadModelListAsExcel()">{{ StoreLangTranslation.data['download_model_list_as_excel'][StoreLang] }}</b-dropdown-item>
                                          </b-dropdown>
                                        </b-col>
                                      </b-row>
                                    </b-card-header>
                                    <div style="overflow:auto; height:520px; border:1px solid #d9e2ec; border-radius:10px; background:#ffffff; box-shadow:0 4px 14px rgba(0,0,0,0.08);">
                                      <table style="margin:0; border-collapse:collapse; width:100%; font-size:13px;">
                                        <thead style="position:sticky; top:0; z-index:2;">
                                          <tr style="background:#263238; color:white;">
                                            <th colspan="4" style="padding:10px; border:1px solid #455a64;">Model Information</th>
                                            <th colspan="3" style="padding:10px; border:1px solid #455a64; background:#1e3a5f;">Main Performance</th>
                                            <th colspan="6" style="padding:10px; border:1px solid #455a64; background:#00695c;">Cross Validation</th>
                                            <th colspan="2" style="padding:10px; border:1px solid #455a64; background:#6a1b9a;">Calibration</th>
                                            <th colspan="3" style="padding:10px; border:1px solid #455a64; background:#ef6c00;">Regression Error</th>
                                            <th colspan="12" style="padding:10px; border:1px solid #455a64; background:#37474f;">Classification Metrics</th>
                                            <th colspan="3" style="padding:10px; border:1px solid #455a64; background:#2e7d32;">Clustering Metrics</th>
                                            <th style="padding:10px; border:1px solid #455a64; background:#b71c1c;">Warning</th>
                                          </tr>

                                          <tr style="background:#f1f5f9; color:#263238;">
                                            <th style="padding:8px; min-width:160px;">Input</th>
                                            <th style="padding:8px;">Output</th>
                                            <th style="padding:8px;">Model</th>
                                            <th style="padding:8px;">Test Size</th>

                                            <th style="padding:8px;">Accuracy</th>
                                            <th style="padding:8px;">R²</th>
                                            <th style="padding:8px;">ROC-AUC</th>

                                            <th style="padding:8px;">CV Accuracy Mean</th>
                                            <th style="padding:8px;">CV Accuracy SD</th>
                                            <th style="padding:8px;">CV R² Mean</th>
                                            <th style="padding:8px;">CV R² SD</th>
                                            <th style="padding:8px;">CV ROC-AUC Mean</th>
                                            <th style="padding:8px;">CV ROC-AUC SD</th>

                                            <th style="padding:8px;">Brier Score</th>
                                            <th style="padding:8px;">Calibration</th>

                                            <th style="padding:8px;">MAE</th>
                                            <th style="padding:8px;">MSE</th>
                                            <th style="padding:8px;">RMSE</th>

                                            <th style="padding:8px;">Precision Binary</th>
                                            <th style="padding:8px;">Precision Micro</th>
                                            <th style="padding:8px;">Precision Macro</th>
                                            <th style="padding:8px;">Precision Weighted</th>

                                            <th style="padding:8px;">Recall Binary</th>
                                            <th style="padding:8px;">Recall Micro</th>
                                            <th style="padding:8px;">Recall Macro</th>
                                            <th style="padding:8px;">Recall Weighted</th>

                                            <th style="padding:8px;">F-Score Binary</th>
                                            <th style="padding:8px;">F-Score Micro</th>
                                            <th style="padding:8px;">F-Score Macro</th>
                                            <th style="padding:8px;">F-Score Weighted</th>

                                            <th style="padding:8px;">Silhouette</th>
                                            <th style="padding:8px;">Calinski-Harabaz</th>
                                            <th style="padding:8px;">Davies-Bouldin</th>

                                            <th style="padding:8px;">Warning</th>
                                          </tr>
                                        </thead>

                                        <tbody>
                                          <template v-for="(model, model_ind) in d_mlModelList">
                                            <tr :style="model_ind % 2 === 0 
                                              ? 'background:#f8fbff; line-height:28px;' 
                                              : 'background:#ffffff; line-height:28px;'">

                                              <td style="padding:8px; border:1px solid #e0e0e0; min-width:160px; font-weight:600;">
                                                <template v-for="(inp, inp_index) in model.input">
                                                  <div>
                                                    {{ inp.label }}
                                                    <span v-if="inp_index !== model.input.length - 1">{{', '}}</span>
                                                  </div>
                                                </template>
                                              </td>

                                              <td style="padding:8px; border:1px solid #e0e0e0;">{{ model.output || '-' }}</td>
                                              <td style="padding:8px; border:1px solid #e0e0e0; font-weight:600; color:#1e3a5f;">{{ model.model || '-' }}</td>
                                              <td style="padding:8px; border:1px solid #e0e0e0;">{{ model.test_size || '-' }}</td>

                                              <td style="padding:8px; border:1px solid #e0e0e0; font-weight:600;">{{ model.accuracy || '-' }}</td>
                                              <td style="padding:8px; border:1px solid #e0e0e0; font-weight:600;">{{ model.r2_score || '-' }}</td>
                                              <td style="padding:8px; border:1px solid #e0e0e0; font-weight:600;">{{ model.roc_auc || '-' }}</td>

                                              <td style="padding:8px; border:1px solid #e0e0e0;">{{ model.cross_validation_accuracy_mean || '-' }}</td>
                                              <td style="padding:8px; border:1px solid #e0e0e0;">{{ model.cross_validation_accuracy_std || '-' }}</td>
                                              <td style="padding:8px; border:1px solid #e0e0e0;">{{ model.cross_validation_r2_mean || '-' }}</td>
                                              <td style="padding:8px; border:1px solid #e0e0e0;">{{ model.cross_validation_r2_std || '-' }}</td>
                                              <td style="padding:8px; border:1px solid #e0e0e0;">{{ model.cross_validation_roc_auc_mean || '-' }}</td>
                                              <td style="padding:8px; border:1px solid #e0e0e0;">{{ model.cross_validation_roc_auc_std || '-' }}</td>

                                              <td style="padding:8px; border:1px solid #e0e0e0;">{{ model.calibration_brier_score || '-' }}</td>
                                              <td style="padding:8px; border:1px solid #e0e0e0;">{{ model.calibration_interpretation || '-' }}</td>

                                              <td style="padding:8px; border:1px solid #e0e0e0;">{{ model.mean_absolute_error || '-' }}</td>
                                              <td style="padding:8px; border:1px solid #e0e0e0;">{{ model.mean_squared_error || '-' }}</td>
                                              <td style="padding:8px; border:1px solid #e0e0e0;">{{ model.root_mean_squared_error || '-' }}</td>

                                              <td style="padding:8px; border:1px solid #e0e0e0;">{{ model.precision_binary || '-' }}</td>
                                              <td style="padding:8px; border:1px solid #e0e0e0;">{{ model.precision_micro || '-' }}</td>
                                              <td style="padding:8px; border:1px solid #e0e0e0;">{{ model.precision_macro || '-' }}</td>
                                              <td style="padding:8px; border:1px solid #e0e0e0;">{{ model.precision_weighted || '-' }}</td>

                                              <td style="padding:8px; border:1px solid #e0e0e0;">{{ model.recall_binary || '-' }}</td>
                                              <td style="padding:8px; border:1px solid #e0e0e0;">{{ model.recall_micro || '-' }}</td>
                                              <td style="padding:8px; border:1px solid #e0e0e0;">{{ model.recall_macro || '-' }}</td>
                                              <td style="padding:8px; border:1px solid #e0e0e0;">{{ model.recall_weighted || '-' }}</td>

                                              <td style="padding:8px; border:1px solid #e0e0e0;">{{ model.fscore_binary || '-' }}</td>
                                              <td style="padding:8px; border:1px solid #e0e0e0;">{{ model.fscore_micro || '-' }}</td>
                                              <td style="padding:8px; border:1px solid #e0e0e0;">{{ model.fscore_macro || '-' }}</td>
                                              <td style="padding:8px; border:1px solid #e0e0e0;">{{ model.fscore_weighted || '-' }}</td>

                                              <td style="padding:8px; border:1px solid #e0e0e0;">{{ model.silhouette_score || '-' }}</td>
                                              <td style="padding:8px; border:1px solid #e0e0e0;">{{ model.calinski_harabaz_score || '-' }}</td>
                                              <td style="padding:8px; border:1px solid #e0e0e0;">{{ model.davies_bouldin_score || '-' }}</td>

                                              <td style="padding:8px; border:1px solid #e0e0e0; font-weight:600; color:#b71c1c;">
                                                {{ model.warning || '-' }}
                                              </td>

                                            </tr>
                                          </template>
                                        </tbody>
                                      </table>
                                    </div>
                                  </b-card>
                                </b-col>
                              </b-row>
                              <b-row v-else>
                                <b-col cols="12">
                                  <template v-if="d_mlTrainLoading">
                                    <b-spinner variant="primary" label="Spinning"></b-spinner>
                                  </template>
                                </b-col>
                              </b-row>
                            </template>
                          </b-tab>

                          <b-tab v-if="['wanalyzer_create_query', 'wanalyzer_credit_count', 'wanalyzer_dataset_stats_query'].indexOf(p_selectedProjectType) !== -1 || (['wanalyzer_dataset_filter'].indexOf(p_selectedProjectType) !== -1 && d_compareEligible)" :active="'analyze_reporting' === d_selectedTabItemId" @click="d_selectedTabItemId = 'analyze_reporting'">
                            <template slot="title">
                              <i class="fa fa-area-chart"></i>
                              {{ StoreLangTranslation.data['report_notes'][StoreLang] }}
                              <i class="fa fa-info-circle" style="color:#2492FF;margin-left:5px;" @click="$help('projects_report_notes', StoreLang)"> </i>
                            </template>
                            <template v-if="'analyze_reporting' === d_selectedTabItemId">
                              <template v-if="d_selectedTabItemId === 'analyze_reporting'">
                                <b-card-header header-bg-variant="white" header-text-variant="dark" style="margin-bottom: 10px;">
                                <b-row>
                                  <b-col sm="12" lg="4"></b-col>
                                  <b-col sm="12" lg="4"> </b-col>
                                  <b-col sm="12" lg="4" style="text-align: right;">
                                    <b-button variant="outline-primary" size="sm" @click="f_copyAllTextClipboard()">
                                      <i class="fa fa-copy"></i>
                                    </b-button>
                                  </b-col>
                                </b-row>
                              </b-card-header>
                                <template v-for="(text_item, text_item_index) in f_reportData.text_list">
                                    <b-row style="border-bottom: solid 1px lightblue; font-size: 14px; padding: 3px;">
                                      <b-col sm="12" lg="11">
                                        <div :id="'text_item_' + text_item_index">
                                          {{ text_item.text }}
                                        </div>
                                      </b-col>
                                      <b-col sm="12" lg="1">
                                        <b-button variant="outline-primary" @click="f_deleteTextItem(text_item_index)" size="sm">
                                          <i class="fa fa-trash"></i>
                                        </b-button>
                                      </b-col>
                                    </b-row>
                                </template>
                              </template>
                            </template>
                          </b-tab>

                          <b-tab v-if="['wanalyzer_create_query', 'wanalyzer_credit_count', 'wanalyzer_dataset_stats_query'].indexOf(p_selectedProjectType) !== -1 || (['wanalyzer_dataset_filter'].indexOf(p_selectedProjectType) !== -1 && d_compareEligible)" :active="'article_template' === d_selectedTabItemId" @click="d_selectedTabItemId = 'article_template'">
                            <template slot="title">
                              <i class="fa fa-area-chart"></i>
                              {{ StoreLangTranslation.data['article_template'][StoreLang] }}
                            </template>
                            <template v-if="'article_template' === d_selectedTabItemId">
                              <template v-if="d_selectedTabItemId === 'article_template'">
                                <b-card-header header-bg-variant="white" header-text-variant="dark" style="margin-bottom: 10px;">
                                <b-row>
                                  <b-col sm="12" lg="4"></b-col>
                                  <b-col sm="12" lg="4"> </b-col>
                                  <b-col sm="12" lg="4" style="text-align: right;">
                                    <b-button variant="outline-primary" size="sm" @click="f_createNewArticle()">
                                      <i class="fa fa-plus"></i>
                                    </b-button>
                                  </b-col>
                                </b-row>
                              </b-card-header>
                                <template v-for="(article_item, article_item_index) in d_articleList.list">
                                    <b-row style="border-bottom: solid 1px lightblue; font-size: 14px; padding: 3px;">
                                      <b-col sm="12" lg="10">
                                        <div :id="'article_item_' + article_item_index">
                                          {{ article_item.name }}
                                        </div>
                                      </b-col>
                                      <b-col sm="12" lg="1">
                                        <b-button variant="outline-primary" @click="f_showArticleEdit(article_item_index)" size="sm">
                                          <i class="fa fa-edit"></i>
                                        </b-button>
                                      </b-col>
                                      <b-col sm="12" lg="1">
                                        <b-button variant="outline-primary" @click="f_deleteArticleItem(article_item_index)" size="sm">
                                          <i class="fa fa-trash"></i>
                                        </b-button>
                                      </b-col>
                                    </b-row>
                                </template>
                              </template>
                            </template>
                          </b-tab>

                          <b-tab v-if="['wanalyzer_create_query', 'wanalyzer_credit_count', 'wanalyzer_dataset_stats_query'].indexOf(p_selectedProjectType) !== -1 || (['wanalyzer_dataset_filter'].indexOf(p_selectedProjectType) !== -1 && d_compareEligible)" :active="'tool_info' === d_selectedTabItemId" @click="d_selectedTabItemId = 'tool_info'">
                            <template slot="title">
                              <i class="fa fa-area-chart"></i>
                              {{ StoreLangTranslation.data['tool_info'][StoreLang] }}
                            </template>
                            <template v-if="'tool_info' === d_selectedTabItemId">
                              <template v-if="d_selectedTabItemId === 'tool_info'">
                                <b-card-header header-bg-variant="white" header-text-variant="dark" style="margin-bottom: 10px;">
                                <b-row>
                                  <b-col sm="12" lg="12">
                                    <strong>Statistical Analyses and Tools</strong>
                                  </b-col>
                                </b-row>
                                </b-card-header>
                                <b-card>
                                  Statistical analysis and ML training procedure were performed on Wistats v3.0 (WisdomEra Corp., Istanbul, Turkey) which uses python programming language statistics and ML libraries (SciPy v1.2.3, scikit-learn v0.24.0, statsmodels v0.9.0). Data distribution analyses were performed with skewness, kurtosis tests. In addition, the Shapiro-Wilk test was used in normality analyses. The test to be used in comparative analyses was decided according to data distribution analyses. Chi-square, Fisher Exact tests were used in comparisons of categorical variables. Kruskal Wallis, One-way ANOVA, T-test, Mann Whitney-U tests were used in comparisons of categorical and numerical data. Pearson and Spearman correlation tests were used in comparisons of numerical and numerical data. Analyses resulting in a p value < 0.05 were considered statistically significant.
                                </b-card>
                                <b-card-header header-bg-variant="white" header-text-variant="dark" style="margin-bottom: 10px;">
                                <b-row>
                                  <b-col sm="12" lg="12">
                                    <strong>Machine Learning Procedure and Pipeline</strong>
                                  </b-col>
                                </b-row>
                                </b-card-header>
                                <b-card>
                                  Statistical analyses were performed before starting the ML model. The ??? parameter was used as the output. Five classification ML models were included as support vector machine (SVM), decision tree (DT), random forest (RF), k-nearest neighbors (KNN), and logistic regression (LR). 30% was taken as the basis of the test size. Many power factors such as area under the curve (auc) value, accuracy rate, sensitivity, precision and F1 score were evaluated to check the power of the ML model. (Figure 1)
                                </b-card>
                                <b-card>
                                  <img src="https://wisdomera-api.wisdomera.io/v1/document/get?__sys__pro__id=6a82ddf7-3e12-4708-8ad5-0335a66d4b23&doc=599d8c12-43af-49e9-a976-12ed66148e64" style="height: 300px;">
                                </b-card>
                              </template>
                            </template>
                          </b-tab>
                          

                        </b-tabs>
                        <!-- <b-tabs>
                          <template v-for="(col, col_ind) in d_project.column_list">
                            <template v-if="col.wai_output">
                              <b-tab :active="col.id === d_selectedColumn" @click="d_selectedColumn = col.id">
                                <template slot="title">
                                  <i class="fa fa-area-chart"></i>
                                  <span v-if="col.id === d_selectedColumn" style="font-weight: bold;">
                                  {{ col.name }}
                                  </span>
                                  <span v-else>
                                  {{ col.name }}
                                  </span>
                                </template>
                                <template v-if="col.id === d_selectedColumn">
                                  {{ col }}
                                </template>
                              </b-tab>
                            </template>
                          </template>
                        </b-tabs> -->
                      </b-col>
                    </b-row>
                  </template>
                </template>
              </b-col>
            </b-row>
        </template>
      </b-tab>


      <b-tab v-if="p_projectPermission && ['wanalyzer_create_query'].indexOf(p_selectedProjectType) !== -1 || (p_projectPermission && ['wanalyzer_credit_count', 'wanalyzer_dataset_filter'].indexOf(p_selectedProjectType) !== -1 && d_projectId)" :active="d_selectedTab === 'auth_assignment'" @click="d_selectedTab = 'auth_assignment'">
        <template slot="title">
          <i class="fa fa-id-badge"></i> {{ StoreLangTranslation.data['auth_assignment'][StoreLang] }}
        </template>
        <template v-if="d_selectedTab === 'auth_assignment'">
          <template v-if="p_projectPermission.auth_data.client_id">
            <b-row style="margin: 20px 3px;">
              <b-col cols="2"></b-col>
              <b-col cols="8">
                <strong style="font-size: 20px;">
                  {{ StoreLangTranslation.data['new_assign'][StoreLang] }}
                </strong>
                <hr/>
                <b-row>
                  <b-col sm="12" lg="12">
                    <strong style="font-size: 20px;">
                      {{ StoreLangTranslation.data['user'][StoreLang] }}
                    </strong>
                  </b-col>
                </b-row>
                <b-row style="min-height: 100px;">
                  <b-col sm="12" lg="6">
                    <b-row>
                      <b-col sm="12" lg="12">
                        <b-input-group>
                          <b-form-input type="text" class="form-control" v-model="d_searchUser" :placeholder="StoreLangTranslation.data['search_user'][StoreLang]"></b-form-input>
                          <b-input-group-append>
                            <b-button variant="secondary" @click="f_searchUser()">
                              <i class="fa fa-search"></i>
                            </b-button>
                            <b-button variant="danger" @click="f_clearSearchUser()">
                              <i class="fa fa-trash"></i>
                            </b-button>
                          </b-input-group-append>
                        </b-input-group>
                      </b-col>
                      <template v-if="d_userSearched">
                        <template v-if="d_filteredUsers.length">
                          <b-col sm="12" lg="12">
                            <b-row v-for="(user, index) in d_filteredUsers" :key="index">
                              <b-col sm="12" lg="12">
                                <span v-if="!d_newAssign.users.some(assignedUser => assignedUser === user.username)" style="cursor: pointer;" @click="f_addUser(user)">
                                  <i class="fa fa-arrow-right"></i>
                                  {{ user.username }}
                                </span>
                              </b-col>
                            </b-row>
                          </b-col>
                        </template>
                        <template v-else>
                          <b-col sm="12" lg="12">
                            <b-row>
                              <b-col sm="12" lg="12">
                                <span style="color: red;">
                                  {{ StoreLangTranslation.data['user_not_found'][StoreLang] }}
                                </span>
                              </b-col>
                            </b-row>
                          </b-col>
                        </template>
                      </template>
                    </b-row>
                  </b-col>
                  <b-col sm="12" lg="6">
                    <b-row v-for="user in d_newAssign.users" :key="user">
                      <b-col sm="12" lg="12">
                        <span style="cursor: pointer; color: green;" @click="f_removeUser(user)">
                          <i class="fa fa-arrow-left"></i>
                          {{ user }}
                        </span>
                      </b-col>
                    </b-row>
                  </b-col>
                </b-row>
                <b-row>
                  <b-col sm="12" lg="12">
                    <strong style="font-size: 20px;">
                      {{ StoreLangTranslation.data['auth'][StoreLang] }}
                    </strong>
                  </b-col>
                </b-row>
                <b-row style="min-height: 100px;">
                  <b-col sm="12" lg="6">
                    <b-row>
                      <b-col sm="12" lg="12">
                        <strong style="font-size: 20px;">
                          <span v-if="!d_newAssign.auths.includes(p_projectPermission.auth_data)" style="cursor: pointer;" @click="f_addAuth(p_projectPermission.auth_data)">
                            <i class="fa fa-arrow-right" style="color: blue;"></i>
                            <span v-if="p_projectPermission.auth_data['data']['0']['34'] && p_projectPermission.auth_data['data']['0']['34']['val']">
                              {{ p_projectPermission.auth_data['data']['0']['34']['val'] }}
                            </span>
                            <span v-else>
                              {{ p_projectPermission.auth_data['data']['0']['2']['val']['value'] == '1' ? p_projectPermission.auth_data['data']['0']['34']['val'] : (p_projectPermission.auth_data['data']['0']['2']['val']['value'] == '0' ? p_projectPermission.auth_data['data']['0']['1']['val'] : (p_projectPermission.auth_data['data']['0']['2']['val']['value'] == '2' ? p_projectPermission.auth_data['data']['0']['1']['val'] : '')) }}
                            </span>
                          </span>
                        </strong>
                      </b-col>
                    </b-row>
                    <b-row v-if="p_creditAuthData.auth_data">
                      <b-col sm="12" lg="12">
                         <strong style="font-size: 20px;">
                          <span v-if="!d_newAssign.auths.includes(p_creditAuthData.auth_data)" style="cursor: pointer;" @click="f_addAuth(p_creditAuthData.auth_data)">
                            <i class="fa fa-arrow-right" style="color: blue;"></i>
                            <span v-if="p_creditAuthData.auth_data['data']['0']['34'] && p_creditAuthData.auth_data['data']['0']['34']['val']">
                              {{ p_creditAuthData.auth_data['data']['0']['34']['val'] }}
                            </span>
                            <span v-else>
                              {{ p_creditAuthData.auth_data['data']['0']['2']['val']['value'] == '1' ? p_creditAuthData.auth_data['data']['0']['34']['val'] : (p_creditAuthData.auth_data['data']['0']['2']['val']['value'] == '0' ? p_creditAuthData.auth_data['data']['0']['1']['val'] : (p_creditAuthData.auth_data['data']['0']['2']['val']['value'] == '2' ? p_creditAuthData.auth_data['data']['0']['1']['val'] : '')) }}
                            </span>
                          </span>
                        </strong>
                      </b-col>
                    </b-row>
                  </b-col>
                  <b-col sm="12" lg="6">
                    <b-row v-for="(assignAuth, assignAuthIndex) in d_newAssign.auths" :key="assignAuth['data']['0']['2']['val']['value'] + '_' + assignAuthIndex">
                      <b-col sm="12" lg="12">
                        <b-row>
                          <b-col sm="12" lg="12">
                            <span style="cursor: pointer; color: green;" @click="f_removeAuth(assignAuth)">
                              <i class="fa fa-arrow-left"></i>
                              {{ assignAuth['data']['0']['2']['val']['value'] == '1' ? assignAuth['data']['0']['34']['val'] : (assignAuth['data']['0']['2']['val']['value'] == '0' ? assignAuth['data']['0']['1']['val'] : (assignAuth['data']['0']['2']['val']['value'] == '2' ? assignAuth['data']['0']['1']['val'] : '')) }}
                            </span>
                          </b-col>
                        </b-row>
                        <b-row>
                          <b-col sm="12" lg="12">
                            <!-- <b-row style="margin: 3px;">
                              <b-col sm="12" lg="4">
                                {{ StoreLangTranslation.data['can_assign_auth'][StoreLang] }}
                              </b-col>
                              <b-col sm="12" lg="8">
                                <b-form-select v-model="d_newAssign['auth_params'][assignAuthIndex]['can_assign_auth']">
                                  <option value="0" selected>
                                    {{ StoreLangTranslation.data['no'][StoreLang] }}
                                  </option>
                                  <option value="1">
                                    {{ StoreLangTranslation.data['yes'][StoreLang] }}
                                  </option>
                                </b-form-select>
                              </b-col>
                            </b-row> -->
                            <!-- <b-row style="margin: 3px;">
                              <b-col sm="12" lg="4">
                                {{ StoreLangTranslation.data['auth_count_create'][StoreLang] }}
                              </b-col>
                              <b-col sm="12" lg="8">
                                <b-form-select v-model="d_newAssign['auth_params'][assignAuthIndex]['auth_count_create']">
                                  <option value="0">
                                    {{ StoreLangTranslation.data['no'][StoreLang] }}
                                  </option>
                                  <option value="1">
                                    {{ StoreLangTranslation.data['yes'][StoreLang] }}
                                  </option>
                                </b-form-select>
                              </b-col>
                            </b-row> -->
                            <b-row v-if="d_newAssign['auth_params'][assignAuthIndex]['auth_count_create'] == '1'" style="margin: 3px;">
                              <b-col sm="12" lg="4">
                                {{ StoreLangTranslation.data['auth_count'][StoreLang] }}
                              </b-col>
                              <b-col sm="12" lg="8">
                                <b-form-input type="number" v-model="d_newAssign['auth_params'][assignAuthIndex]['auth_count']"></b-form-input>
                                <!-- <small>{{'max'}} {{ p_creditAuthData.auth_data['data']['0']['6']['val'] - p_creditAuthData.auth_data['data']['0']['7']['val'] }}   </small> -->
                              </b-col>
                            </b-row>
                          </b-col>
                        </b-row>
                      </b-col>
                    </b-row>
                    <b-row>
                      <b-col sm="12" lg="10">
                      </b-col>
                      <b-col sm="12" lg="2">
                        <b-button variant="primary" @click="f_authAssign()" v-show="d_newAssign.users.length && (d_newAssign.auths.length || d_createAssign.length)">
                          {{ StoreLangTranslation.data['save'][StoreLang] }}
                        </b-button>
                      </b-col>
                    </b-row>
                  </b-col>
                </b-row>
              </b-col>
              <b-col cols="2"></b-col>
            </b-row>
          </template>
          <template v-else>
            <b-spinner variant="primary" label="Spinning"></b-spinner>
          </template>
        </template>
      </b-tab>



    </b-tabs>


    <b-modal v-if="d_showTableCellFullText" id="d_showTableCellFullText" v-model="d_showTableCellFullText" scrollable hide-footer title="Bilgi" centered header-bg-variant="info" header-text-variant="dark">
      <p class="my-4" style="word-wrap: break-word;">
        {{ d_selectedTableCellFullText }}
      </p>
    </b-modal>


    <b-modal v-if="d_showGraphicView" id="d_showGraphicView" v-model="d_showGraphicView" scrollable hide-footer title="Bilgi" centered header-bg-variant="info" header-text-variant="dark" size="xl">
      X: {{ chart_data.labels.length }},
      <select v-model="d_chartSize.chart_type" style="height: 30px; width: 100px;margin-right: 3px;">
        <option value="line">çizgi</option>
        <option value="bar">bar</option>
        <option value="scatter">nokta</option>
      </select>
      <select v-if="d_chartSize.y_mode ==='standart'" v-model="d_chartSize.x_mode" style="height: 30px; width: 100px;margin-right: 3px;">
        <option value="standart">x standart</option>
        <option value="x_ascending">x artan</option>
        <option value="x_descending">x azalan</option>
      </select>
      <select v-if="d_chartSize.x_mode ==='standart'" v-model="d_chartSize.y_mode" style="height: 30px; width: 100px;margin-right: 3px;">
        <option value="standart">y standart</option>
        <option value="y_ascending">y artan</option>
        <option value="y_descending">y azalan</option>
      </select>
      <select v-model="d_chartSize.x_interval_type" style="height: 30px; width: 100px;margin-right: 3px;">
        <option value="all">'x' tüm değerler</option>
        <option value="once_every_x_value">'x' her ... değerde bir</option>
      </select>
      <input v-if="d_chartSize.x_interval_type ==='once_every_x_value'" type="number" v-model="d_chartSize.x_interval" min="1" style="height: 30px; width: 100px;margin-right: 3px;" placeholder="x kaç değerde bir görülecek">
      <!--
        <div class="chart-wrapper" style="height: 100%;">
          <line-view :chart_data="chart_data" style="height:300px;" :height="300" />
        </div>
      -->
      <div v-if="d_showChartView" class="chart-wrapper" style="height: 100%;">
        <template v-if="d_chartSize.chart_type ==='line'">
          <line-view :chart_data="chart_data" :style="'height:' + d_chartSize.height.toString() +'px;'" :height="d_chartSize.height" :width="d_chartSize.width" />
        </template>
        <template v-if="d_chartSize.chart_type ==='bar'">
          <bar-view :chart_data="chart_data" :style="'height:' + d_chartSize.height.toString() +'px;'" :height="d_chartSize.height" :width="d_chartSize.width" />
        </template>
        <template v-if="d_chartSize.chart_type ==='scatter'">
          <scatter-view :chart_data="chart_data" :style="'height:' + d_chartSize.height.toString() +'px;'" :height="d_chartSize.height" :width="d_chartSize.width" />
        </template>
      </div>
    </b-modal>


    <b-modal v-if="d_mainRuleShowModal" id="d_mainRuleShowModal" v-model="d_mainRuleShowModal" scrollable hide-footer title="Ana Kural" centered header-bg-variant="info" header-text-variant="dark" size="xl">
      <div style="min-height: 500px;">
        <wdm-rule-a :data_type="d_mainRule.data_type" :option_data="d_mainRule.option_data" :prepare_data="d_mainRule.prepare_data" :query_list="d_mainRule.query_list" :compile_str_array="d_mainRule.compile_str_array" :compile_str_date="d_mainRule.compile_str_date" :wdmr_change="d_mainRule.wdmr_change" :p_wdmList="d_mainRule.wdm_list" :mother_children="mother_children" :p_wdmParameterSelectData="d_mainRule.wps_data" :p_wdmRuleAsettings="d_mainRule.wra_settings" :compile_str_text="d_mainRule.compile_str_text"></wdm-rule-a>
        <b-row>
          <b-col sm="12" lg="6"></b-col>
          <b-col sm="12" lg="3">
            <b-button variant="outline-primary" size="sm" @click="d_mainRuleShowModal = false">
              <i class="fa fa-send-o"></i> {{ StoreLangTranslation.data['cancel'][StoreLang] }}
            </b-button>
          </b-col>
          <b-col sm="12" lg="3">
            <b-button variant="outline-primary" size="sm" @click="f_acceptMainRule()">
              <i class="fa fa-send-o"></i> {{ StoreLangTranslation.data['save'][StoreLang] }}
            </b-button>
          </b-col>
        </b-row>
      </div>
    </b-modal>

    <b-modal v-if="d_articleList.show" id="d_articleList_show" v-model="d_articleList.show" hide-footer title="Article Edit" centered header-bg-variant="info" header-text-variant="dark" size="xl">      
      <b-row>
        <b-col sm="12" lg="9">
          <b-form-input v-model="d_articleList.list[d_articleList.selected_index].name" required style="font-weight: bold;"></b-form-input>
        </b-col>
        <b-col sm="12" lg="3">
          <template v-if="d_articleSaveLoading">
              <b-spinner variant="success" label="Spinning"></b-spinner> kaydedildi
          </template>
        </b-col>
      </b-row>
      <b-row style="margin: 0px; margin-bottom: 5px; background-color: lightblue;">
        <b-col sm="12" lg="6">
          <i class="fa fa-bold intLink" title="Bold" @click="f_selectedArticleRowStyleChange('bold')"></i>
        </b-col>
        <b-col sm="12" lg="6">
          <i class="fa fa-copy" @click="f_copyArticleDetails('article_details_area')"></i>
        </b-col>
      </b-row>
      <div id="article_details_area" style="height: 700px;overflow: hidden auto;border: 1px solid #0ab8be;box-shadow: 0px 0px 2px 2px #0ab8be; padding: 3px; font-size: 12pt; font-family: 'Times New Roman', Times, serif;">
        <template v-for='(article_item, article_item_ind) in d_articleList.list[d_articleList.selected_index].items'>
          <b-row v-if="article_item.type === 'text'" @click="f_selectArticleItemIndex(d_articleList.selected_index, article_item_ind)" :style="d_articleList.list[d_articleList.selected_index].selected_item_index === article_item_ind ? 'background-color: #ebfff7; border-bottom: solid 1px #cbc9c9;' : 'border-bottom: solid 1px #cbc9c9;'">
            <b-col sm="12" lg="10">
              <div :id="'article_edit_item_' + article_item_ind" v-html="article_item.text" contenteditable="true" :style="article_item.style ? article_item.style + ';padding: 10px; font-size: 12pt;' : 'padding: 10px; font-size: 12pt;'">
              </div>
              <!-- <html-editor :key="article_item_ind" :p_html_text="article_item.text" :p_htmlElementId="'article_html_edit_' + article_item_ind"></html-editor> -->
            </b-col>
            <b-col sm="12" lg="2">
              <template v-if="d_articleList.list[d_articleList.selected_index].selected_item_index === article_item_ind">
                <b-button variant="outline-success" size="sm" @click="f_addNewRowToArticle(d_articleList.selected_index, article_item_ind, 'text')" style="margin-right: 5px;">
                  <i class="fa fa-plus"></i>
                </b-button>
                <b-button variant="outline-danger" size="sm" @click="f_deleteRowOfArticle(d_articleList.selected_index, article_item_ind, 'text')" style="margin-right: 5px;">
                  <i class="fa fa-minus"></i>
                </b-button>
              </template>
            </b-col>
          </b-row>
          <b-row v-if="article_item.type === 'figure'">
            <b-col sm="12" lg="10">
              <template v-if="article_item.figure_src">
                <img :src="article_item.figure_src" style="height: 300px;">
              </template>
            </b-col>
            <b-col sm="12" lg="2">
              <template v-if="d_articleList.list[d_articleList.selected_index].selected_item_index === article_item_ind">
                <b-button variant="outline-success" size="sm" @click="f_addNewRowToArticle(d_articleList.selected_index, article_item_ind, 'text')" style="margin-right: 5px;">
                  <i class="fa fa-plus"></i>
                </b-button>
                <b-button variant="outline-danger" size="sm" @click="f_deleteRowOfArticle(d_articleList.selected_index, article_item_ind, 'text')" style="margin-right: 5px;">
                  <i class="fa fa-minus"></i>
                </b-button>
              </template>
            </b-col>
          </b-row>
        </template>
      </div>
      <b-row>
        <b-col sm="12" lg="6"></b-col>
        <b-col sm="12" lg="3">
          <b-button variant="outline-primary" size="sm" @click="d_articleList.show = false">
            <i class="fa fa-send-o"></i> {{ StoreLangTranslation.data['cancel'][StoreLang] }}
          </b-button>
        </b-col>
        <b-col sm="12" lg="3">
          <b-button variant="outline-primary" size="sm" @click="f_saveArticle()">
            <i class="fa fa-send-o"></i> {{ StoreLangTranslation.data['save'][StoreLang] }}
          </b-button>
        </b-col>
      </b-row>
    </b-modal>

    <b-modal
      v-if="d_excelCorrection.show"
      id="d_excelCorrection_show"
      v-model="d_excelCorrection.show"
      hide-footer
      title="Excel Edit"
      centered
      header-bg-variant="info"
      header-text-variant="dark"
      size="xl"
      class="my-big-modal"
    >

      <!-- HEADER -->
      <b-row class="m-1">
        <b-col cols="6">
          <h3>{{ StoreLangTranslation.data['excel_upload_settings'][StoreLang] }}</h3>
        </b-col>
        <b-col cols="6" class="text-right">
          <b-spinner v-if="d_projectSaveLoading" variant="primary" />
          <b-button
            v-else
            variant="outline-success"
            class="mr-1"
            @click="f_wanalyzerProjectSave('modal')"
          >
            {{ StoreLangTranslation.data['save'][StoreLang] }}
          </b-button>
        </b-col>
      </b-row>

      <b-row class="m-1" v-if="d_excelCorrection.correction_column_list.length">
        <b-col cols="12">
          <strong>{{ StoreLangTranslation.data['correction_suggestions'][StoreLang] }}</strong>
        </b-col>
      </b-row>

      <!-- TABLE -->
      <b-table-simple
        v-if="d_excelCorrection.correction_column_list.length"
        small
        caption-top
        class="correction-table-fixed-header"
      >
        <b-thead head-variant="dark">
          <b-tr>
            <b-th style="width:20px">#</b-th>
            <b-th style="width:120px">{{ StoreLangTranslation.data['column'][StoreLang] }}</b-th>
            <b-th style="width:150px">{{ StoreLangTranslation.data['column_type'][StoreLang] }}</b-th>
            <b-th style="width:80px">{{ StoreLangTranslation.data['number_of_empty_cells'][StoreLang] }}</b-th>
            <b-th style="width:120px">{{ StoreLangTranslation.data['value_to_write_to_empty_cells'][StoreLang] }}</b-th>
            <b-th style="width:200px">{{ StoreLangTranslation.data['numeric_values'][StoreLang] }}</b-th>
            <b-th style="width:300px">{{ StoreLangTranslation.data['option_to_replace'][StoreLang] }}</b-th>
            <b-th style="width:200px">{{ StoreLangTranslation.data['column_incompatible'][StoreLang] }}</b-th>
          </b-tr>
        </b-thead>

        <b-tbody>
          <b-tr
            v-for="(col, col_ind) in d_excelCorrection.correction_column_list"
            :key="col_ind"
            :class="{ 'even-row': col_ind % 2 === 0 }"
          >
            <b-td style="width:20px">{{ col_ind + 1 }}</b-td>

            <b-td style="width:120px">
              <!-- <strong class="text-truncate d-block">{{ col.label }}</strong> -->
              <strong>{{ col.label }}</strong>
            </b-td>

            <b-td :style="{ width: '150px', backgroundColor: d_paramTypeColors[col.param_type]}">
              <b-form-select :key="'col_type_' + col_ind" v-model="col.param_type" size="sm" :style="{backgroundColor: d_paramTypeColors[col.param_type]}">
                <option value="text" style="background-color: white;">{{ StoreLangTranslation.data['type_text'][StoreLang] }}</option>
                <option value="select" style="background-color: white;">{{ StoreLangTranslation.data['type_select'][StoreLang] }}</option>
                <option value="float" style="background-color: white;">{{ StoreLangTranslation.data['type_float'][StoreLang] }}</option>
                <option value="integer" style="background-color: white;">{{ StoreLangTranslation.data['type_integer'][StoreLang] }}</option>
                <option value="datetime" style="background-color: white;">{{ StoreLangTranslation.data['type_datetime'][StoreLang] }}</option>
              </b-form-select>
            </b-td>

            <b-td style="width:80px" class="text-center">{{ col.null_count }}</b-td>

            <b-td style="width:120px">
              <b-form-input v-model="col.value_for_null" size="sm" />
            </b-td>

            <b-td style="width:200px" class="small">
              <template v-if="col.param_type === 'integer' || col.param_type === 'float'">
                <div v-if="col.mean_value"><strong>Ortalama:</strong> {{ (+col.mean_value).toFixed(2) }}</div>
                <div v-if="col.minimum_value || col.maximum_value"><strong>Min / Max:</strong> {{ col.minimum_value || '-' }} / {{ col.maximum_value || '-' }}</div>
                <div v-if="col.standart_deviation"><strong>Standart Sapma:</strong> {{ (+col.standart_deviation).toFixed(2) }}</div>
                <div v-if="col.outliers_interquartile_range">
                  <strong>Alt / Üst (IQR):</strong>
                  {{ (+col.outliers_interquartile_range.lower_bound).toFixed(2) }} /
                  {{ (+col.outliers_interquartile_range.upper_bound).toFixed(2) }}
                </div>
              </template>
              <span v-else>-</span>
            </b-td>

            <b-td style="width:300px">
              <div v-if="col.param_type === 'select'" class="option-box">
                <div v-for="(opt, i) in col.options" :key="i" class="mb-1">
                  <small><strong>{{ opt.label }}</strong> / {{ opt.count }}</small>
                  <b-form-input v-model="opt.correct_label" size="sm" />
                </div>
              </div>
              <span v-else>-</span>
            </b-td>

            <b-td style="width:200px">
              <div class="error-box" v-if="col.incompatible_with_column_type">
                <div v-for="(v, k) in col.incompatible_with_column_type" :key="k">
                  <small>{{ k }} →</small>
                  <b-form-input v-model="v.val" size="sm" class="d-inline-block w-50" />
                </div>
              </div>
              <span v-else>-</span>
            </b-td>
          </b-tr>
        </b-tbody>
      </b-table-simple>
    </b-modal>



    <b-modal v-if="d_wTableShow" id="d_wTableShow" v-model="d_wTableShow" hide-footer title="Dataset Görünümü" centered header-bg-variant="info" header-text-variant="dark" size="xl">
      <template v-if="d_datasetViewLoading">
        <b-spinner variant="primary" label="Spinning"></b-spinner>
      </template>
      <template v-else>
        <w-table2 style="transition: 2s; transform: none;" v-if="d_datasetWTableFilter && d_datasetShow" :key="'dataset_view'" :p_tableDetails="d_datasetWTableFilter"></w-table2>
      </template>
    </b-modal>

    <b-modal v-if="d_oldStatisticResultsModal" id="d_oldStatisticResultsModal_show" v-model="d_oldStatisticResultsModal" hide-footer title="Old Results" centered header-bg-variant="info" header-text-variant="dark" modal-class="modal-90" >
      <template v-if="d_oldResultsLoading">
        <b-spinner variant="primary" label="Spinning"></b-spinner>
      </template>
      <template  v-else>
        <b-row>
          <b-col sm="12" lg="12">
            <div style="overflow-x: hidden; overflow-y: auto; height: 150px;">
              <b-row v-for="(old_result, old_result_index) in d_oldResultList">
                <b-col sm="12" lg="12" @click="f_selectOldResultItem('statistical_analysis', old_result, old_result_index)" :style=" d_selectedOldResultIndex === old_result_index ? 'padding-bottom: 5px; border-bottom: 1px solid whitesmoke; cursor: pointer; background-color: #007BFF; border-radius: 3px 3px 0 0; color: white;' : 'margin-bottom: 5px; border-bottom: 1px solid whitesmoke; cursor: pointer;'">
                  {{ old_result['data']['0']['6']['val'] }}
                </b-col>
              </b-row>
            </div>
          </b-col>
        </b-row>
        <b-row>
          <b-col sm="12" lg="12" style="border-left: 1px solid gray; min-height: 475px;">
            <b-row v-if="d_selectedOldResultItem">
              <b-col sm="12" lg="3">
                <b-row>
                  <b-col cols="12">
                    <b-card-header header-bg-variant="primary" header-text-variant="white" class="p-1">
                      {{ StoreLangTranslation.data['outputs'][StoreLang] }}
                    </b-card-header>
                  </b-col>
                </b-row>
                <div style="overflow-x: hidden; overflow-y: auto; height: 400px;">
                  <template>
                    <template v-for="(stats_item, stats_index) in d_selectedOldResultItem">
                      <template v-for="(analyze_item, analyze_index) in stats_item.analyze_list">
                        <b-row @click="d_selectedOldStatsResultItem = stats_index + '_' + analyze_index" :style="d_selectedOldStatsResultItem === stats_index + '_' + analyze_index ? 'cursor: pointer; margin: 0px; background-color: rgb(227, 246, 255); border-bottom: solid 1px rgb(227, 246, 255);' : 'cursor: pointer; margin: 0px; border-bottom: solid 1px rgb(227, 246, 255);'">
                          <b-col cols="12">
                            <!-- <strong>{{ d_statsOrderList[stats_id + '_' + analyze_index] }} ) </strong>  -->
                            <template v-if="analyze_item.label_html">
                              <div v-html="analyze_item.label_html"></div>
                            </template>
                            <template v-else>
                              {{ analyze_item.label }}
                            </template>
                          </b-col>
                        </b-row>
                      </template>
                    </template>
                  </template>
                </div>
              </b-col>
              <b-col sm="12" lg="9">
                <template v-for="(stats_item, stats_index) in d_selectedOldResultItem">
                  <template v-for="(analyze_item, analyze_index) in stats_item.analyze_list">
                    <template v-if="stats_index + '_' + analyze_index === d_selectedOldStatsResultItem">
                        <div style="overflow-x: hidden; overflow-y: auto; height: 500px;">

                          <wanalyzer-analyze-view v-if="d_statsShow" :key="'analyze_' + d_projectId + '_' + stats_index + '_' + analyze_index" :p_analyzeList="[analyze_item]" :p_authClientId="p_projectPermission ? p_projectPermission.auth_data.client_id : undefined"></wanalyzer-analyze-view>
                        </div>
                    </template>
                  </template>
                </template>
              </b-col>
            </b-row>
            <div v-else style="height: 400px;">
              {{ StoreLangTranslation.data['select_old_statistical_result'][StoreLang] }}
            </div>
          </b-col>
        </b-row>
      </template>
    </b-modal>

    <b-modal v-if="d_oldMlResultsModal" id="d_oldMlResultsModal_show" v-model="d_oldMlResultsModal" hide-footer title="Old Results" centered header-bg-variant="info" header-text-variant="dark" size="xl">
      <template v-if="d_oldResultsLoading">
        <b-spinner variant="primary" label="Spinning"></b-spinner>
      </template>
      <b-row v-else>
        <b-col sm="12" lg="3">
          
          <b-row v-for="(old_result, old_result_index) in d_oldResultList">
            <b-col sm="12" lg="12" @click="f_selectOldResultItem('ml_training', old_result, old_result_index)" :style=" d_selectedOldResultIndex === old_result_index ? 'padding-bottom: 5px; border-bottom: 1px solid whitesmoke; cursor: pointer; background-color: #007BFF; border-radius: 3px 3px 0 0; color: white;' : 'margin-bottom: 5px; border-bottom: 1px solid whitesmoke; cursor: pointer;'">
              {{ old_result['data']['0']['6']['val'] }}
            </b-col>
          </b-row>
        </b-col>

        <b-col sm="12" lg="9" style="border-left: 1px solid gray; min-height: 475px;">
          <b-row v-if="d_oldMlModelList.length > 0">

            <b-col cols="12">
              <span style="font-size: 18px; margin: 0 10px;">{{ StoreLangTranslation.data['machine_learning_models_used'][StoreLang] }} {{': '}} <strong>{{ d_oldMlModelList.length }}</strong></span>
              <b-card no-body header-tag="header">
                <b-card-header header-bg-variant="secondary" class="p-1" header-text-variant="dark">
                  <b-row>
                    <b-col lg="10">
                      <small>{{ StoreLangTranslation.data['model_list'][StoreLang] }}</small>
                    </b-col>
                    <b-col lg="2">
                      <b-dropdown variant="success" size="sm" class="pull-right" style="margin: 5px;">
                        <b-dropdown-item @click="f_downloadModelListAsExcel()">{{ StoreLangTranslation.data['download_model_list_as_excel'][StoreLang] }}</b-dropdown-item>
                      </b-dropdown>
                    </b-col>
                  </b-row>
                </b-card-header>
                    <div style="overflow:auto; height:520px; border:1px solid #d9e2ec; border-radius:10px; background:#ffffff; box-shadow:0 4px 14px rgba(0,0,0,0.08);">
                      <table style="margin:0; border-collapse:collapse; width:100%; font-size:13px;">
                        <thead style="position:sticky; top:0; z-index:2;">
                          <tr style="background:#263238; color:white;">
                            <th colspan="4" style="padding:10px; border:1px solid #455a64;">Model Information</th>
                            <th colspan="3" style="padding:10px; border:1px solid #455a64; background:#1e3a5f;">Main Performance</th>
                            <th colspan="6" style="padding:10px; border:1px solid #455a64; background:#00695c;">Cross Validation</th>
                            <th colspan="2" style="padding:10px; border:1px solid #455a64; background:#6a1b9a;">Calibration</th>
                            <th colspan="3" style="padding:10px; border:1px solid #455a64; background:#ef6c00;">Regression Error</th>
                            <th colspan="12" style="padding:10px; border:1px solid #455a64; background:#37474f;">Classification Metrics</th>
                            <th colspan="3" style="padding:10px; border:1px solid #455a64; background:#2e7d32;">Clustering Metrics</th>
                            <th style="padding:10px; border:1px solid #455a64; background:#b71c1c;">Warning</th>
                          </tr>

                          <tr style="background:#f1f5f9; color:#263238;">
                            <th style="padding:8px; min-width:160px;">Input</th>
                            <th style="padding:8px;">Output</th>
                            <th style="padding:8px;">Model</th>
                            <th style="padding:8px;">Test Size</th>

                            <th style="padding:8px;">Accuracy</th>
                            <th style="padding:8px;">R²</th>
                            <th style="padding:8px;">ROC-AUC</th>

                            <th style="padding:8px;">CV Accuracy Mean</th>
                            <th style="padding:8px;">CV Accuracy SD</th>
                            <th style="padding:8px;">CV R² Mean</th>
                            <th style="padding:8px;">CV R² SD</th>
                            <th style="padding:8px;">CV ROC-AUC Mean</th>
                            <th style="padding:8px;">CV ROC-AUC SD</th>

                            <th style="padding:8px;">Brier Score</th>
                            <th style="padding:8px;">Calibration</th>

                            <th style="padding:8px;">MAE</th>
                            <th style="padding:8px;">MSE</th>
                            <th style="padding:8px;">RMSE</th>

                            <th style="padding:8px;">Precision Binary</th>
                            <th style="padding:8px;">Precision Micro</th>
                            <th style="padding:8px;">Precision Macro</th>
                            <th style="padding:8px;">Precision Weighted</th>

                            <th style="padding:8px;">Recall Binary</th>
                            <th style="padding:8px;">Recall Micro</th>
                            <th style="padding:8px;">Recall Macro</th>
                            <th style="padding:8px;">Recall Weighted</th>

                            <th style="padding:8px;">F-Score Binary</th>
                            <th style="padding:8px;">F-Score Micro</th>
                            <th style="padding:8px;">F-Score Macro</th>
                            <th style="padding:8px;">F-Score Weighted</th>

                            <th style="padding:8px;">Silhouette</th>
                            <th style="padding:8px;">Calinski-Harabaz</th>
                            <th style="padding:8px;">Davies-Bouldin</th>

                            <th style="padding:8px;">Warning</th>
                          </tr>
                        </thead>

                        <tbody>
                          <template v-for="(model, model_ind) in d_mlModelList">
                            <tr :style="model_ind % 2 === 0 
                              ? 'background:#f8fbff; line-height:28px;' 
                              : 'background:#ffffff; line-height:28px;'">

                              <td style="padding:8px; border:1px solid #e0e0e0; min-width:160px; font-weight:600;">
                                <template v-for="(inp, inp_index) in model.input">
                                  <div>
                                    {{ inp.label }}
                                    <span v-if="inp_index !== model.input.length - 1">{{', '}}</span>
                                  </div>
                                </template>
                              </td>

                              <td style="padding:8px; border:1px solid #e0e0e0;">{{ model.output || '-' }}</td>
                              <td style="padding:8px; border:1px solid #e0e0e0; font-weight:600; color:#1e3a5f;">{{ model.model || '-' }}</td>
                              <td style="padding:8px; border:1px solid #e0e0e0;">{{ model.test_size || '-' }}</td>

                              <td style="padding:8px; border:1px solid #e0e0e0; font-weight:600;">{{ model.accuracy || '-' }}</td>
                              <td style="padding:8px; border:1px solid #e0e0e0; font-weight:600;">{{ model.r2_score || '-' }}</td>
                              <td style="padding:8px; border:1px solid #e0e0e0; font-weight:600;">{{ model.roc_auc || '-' }}</td>

                              <td style="padding:8px; border:1px solid #e0e0e0;">{{ model.cross_validation_accuracy_mean || '-' }}</td>
                              <td style="padding:8px; border:1px solid #e0e0e0;">{{ model.cross_validation_accuracy_std || '-' }}</td>
                              <td style="padding:8px; border:1px solid #e0e0e0;">{{ model.cross_validation_r2_mean || '-' }}</td>
                              <td style="padding:8px; border:1px solid #e0e0e0;">{{ model.cross_validation_r2_std || '-' }}</td>
                              <td style="padding:8px; border:1px solid #e0e0e0;">{{ model.cross_validation_roc_auc_mean || '-' }}</td>
                              <td style="padding:8px; border:1px solid #e0e0e0;">{{ model.cross_validation_roc_auc_std || '-' }}</td>

                              <td style="padding:8px; border:1px solid #e0e0e0;">{{ model.calibration_brier_score || '-' }}</td>
                              <td style="padding:8px; border:1px solid #e0e0e0;">{{ model.calibration_interpretation || '-' }}</td>

                              <td style="padding:8px; border:1px solid #e0e0e0;">{{ model.mean_absolute_error || '-' }}</td>
                              <td style="padding:8px; border:1px solid #e0e0e0;">{{ model.mean_squared_error || '-' }}</td>
                              <td style="padding:8px; border:1px solid #e0e0e0;">{{ model.root_mean_squared_error || '-' }}</td>

                              <td style="padding:8px; border:1px solid #e0e0e0;">{{ model.precision_binary || '-' }}</td>
                              <td style="padding:8px; border:1px solid #e0e0e0;">{{ model.precision_micro || '-' }}</td>
                              <td style="padding:8px; border:1px solid #e0e0e0;">{{ model.precision_macro || '-' }}</td>
                              <td style="padding:8px; border:1px solid #e0e0e0;">{{ model.precision_weighted || '-' }}</td>

                              <td style="padding:8px; border:1px solid #e0e0e0;">{{ model.recall_binary || '-' }}</td>
                              <td style="padding:8px; border:1px solid #e0e0e0;">{{ model.recall_micro || '-' }}</td>
                              <td style="padding:8px; border:1px solid #e0e0e0;">{{ model.recall_macro || '-' }}</td>
                              <td style="padding:8px; border:1px solid #e0e0e0;">{{ model.recall_weighted || '-' }}</td>

                              <td style="padding:8px; border:1px solid #e0e0e0;">{{ model.fscore_binary || '-' }}</td>
                              <td style="padding:8px; border:1px solid #e0e0e0;">{{ model.fscore_micro || '-' }}</td>
                              <td style="padding:8px; border:1px solid #e0e0e0;">{{ model.fscore_macro || '-' }}</td>
                              <td style="padding:8px; border:1px solid #e0e0e0;">{{ model.fscore_weighted || '-' }}</td>

                              <td style="padding:8px; border:1px solid #e0e0e0;">{{ model.silhouette_score || '-' }}</td>
                              <td style="padding:8px; border:1px solid #e0e0e0;">{{ model.calinski_harabaz_score || '-' }}</td>
                              <td style="padding:8px; border:1px solid #e0e0e0;">{{ model.davies_bouldin_score || '-' }}</td>

                              <td style="padding:8px; border:1px solid #e0e0e0; font-weight:600; color:#b71c1c;">
                                {{ model.warning || '-' }}
                              </td>

                            </tr>
                          </template>
                        </tbody>
                      </table>
                    </div>
                </b-card>
            </b-col>
          </b-row>
          <div v-else style="height: 400px;">
            {{ StoreLangTranslation.data['select_old_machine_learning_train_result'][StoreLang] }}
          </div>
        </b-col>

      </b-row>
    </b-modal>


  </div>
</template>

<script>
import {
  default as HtmlEditor
} from '@/wam/components/widgets/HtmlEditor';
import { ClsRule } from '@/wam/modules/rule';
import { ClsIndexDb } from '@/wam/modules/index_db';
import { ClsHtml } from '@/wam/modules/html_functions';
import LineView from '@/components/chart/LineView';
import ScatterView from '@/components/chart/ScatterView';
import BarView from '@/components/chart/BarView';
import {
  default as TimeLine
} from '@/components/widgets/TimeLine';
import {
  default as WTable2
} from '@/components/widgets/WTable2';
import {
  default as WanalyzerAnalyzeView
} from '@/components/widgets/WanalyzerAnalyzeView';
import {
  default as RuleQuery
} from '@/wam/components/rule/RuleQuery';
import {
  default as WdmRuleA
} from '@/wam/components/rule/WdmRuleA';
import {
  default as WanalyzerProjectColumn
} from '@/wam/components/wanalyzer/WanalyzerProjectColumn';
import moment from "moment";
import { ServiceFunctions } from '@/wam/modules/service';
import { data as operator_list } from '@/wam/options/operator_list';
import { data as stats_wdm } from '@/wam/options/stats_wdm';
import { mapGetters } from 'vuex';
export default {
  name: 'WanalyzerDatasetAnalyze',
  computed: {
    ...mapGetters({
      StoreLangTranslation: 'StoreLangTranslation',
      StoreDevice: 'StoreDevice',
      StoreUser: 'StoreUser',
      StoreLoading: 'StoreLoading',
      StoreModal: 'StoreModal',
      StoreLang: 'StoreLang',
    })
  },
  components: {
    WTable2,
    WanalyzerAnalyzeView,
    TimeLine,
    LineView,
    BarView,
    ScatterView,
    WdmRuleA,
    RuleQuery,
    WanalyzerProjectColumn,
    HtmlEditor,
  },
  props: {
    p_projectId: {
      type: String,
      required: false
    },
    p_statsId: {
      type: String,
      required: false
    },
    p_selectedProjectType: {
      type: String,
      required: false
    },
    p_projectPermission: {
      type: Object,
      required: false
    },
    f_getUserAuthorizationList: {
      type: Function,
      required: false
    },
    f_getThisUserAuth: {
      type: Function,
      required: false
    },
    p_fullScreen: {
      type: Boolean,
      required: false
    },
    p_scopeList: {
      type: Array,
      required: false
    },
    p_selectedProjectIndex: {
      type: Number,
      required: false
    },
    p_projectList: {
      type: Object,
      required: false
    },
    p_datasetList: {
      type: Object,
      required: false
    },
    p_creditAuthData: {
      type: Object,
      required: false
    },
    p_datasetAdmin: {
      type: Boolean,
      required: false
    },
    f_getDatasetProjects: {
      type: Function,
      required: false
    },
  },
  data: () => {
    return {
      d_variablesShow: true,
      d_addTotalRow: 'no',
      d_analyze_cross_columns_by_two_grouping: 'no',
      d_statsOrderList: {},
      d_taskStarted: false,
      d_statsServiceId: '',
      d_mlServiceId: '',
      d_selectedStatisticsMethod: 'selected_variables_descriptive',
      d_articleSaveLoading: false,
      d_excelCorrection: {
        'correction_column_list': [],
        'show': false,
        'column_type': 'clear',
        'column_design': 'create_new_column_types',
        'dataset_type': 'clear',
      },
      d_articleList: {'list': [], 'selected_index': '', 'show': false},
      f_reportData: {'text_list': []},
      d_comparedStatistics: false,
      d_backupProjectPermission: '',
      d_columnList: [],
      d_columnListLoading: false,
      d_mainRuleShowModal: false,
      d_prepareRuleNew: {
        'date_ability': '',
        'wdmr_change': { 'rule': 0 },
        'data_type': '',
        'option_data': {},
        'prepare_data': {},
        'query_list': [],
        'compile_str_date': [],
        'compile_str_text': [],
        'compile_str_array': [],
        'wra_settings': {
          'mode': 'param',
          'options': [
            { 'label': 'PARAM', 'value': 'param' },
            { 'label': 'PARAM & QUERY', 'value': 'param_query' }
          ]
        },
        'wps_data': [{
          'operation': '',
          'selected_value': '',
          'loc': [],
          'val_list': [],
          'selected_wdm': '',
          'd_level': 0,
          'd_level_count': 0,
          'significant': 'true'
        }],
        'wdm_list': []
      },
      d_timerControlProjectUpdate: { 'timer': 0, 'status': 'passive', 'max': 30000, 'interval': 5000, 'check_count_after_not_continue': 0 },
      d_timerControlResult: { 'timer': 0, 'status': 'passive', 'max': 30000, 'interval': 5000, 'check_count_after_not_continue': 0 },
      d_projectDataQueryLoading: false,
      d_projectSaveLoading: false,
      d_selectedTab: 'data',
      d_autoLoading: false,
      d_projectColumnListLoading: false,
      d_datasetViewLoading: false,
      d_statsViewLoading: false,
      d_datasetWTable: '',
      d_datasetWTableFilter: '',
      d_statsShow: true,
      d_datasetShow: true,
      d_selectedStatsResultItem: '',
      d_selectedTabItemId: '',
      d_statisticResults: {},
      d_selectedColumn: '',
      d_operatorList: operator_list,
      d_statsWdm: stats_wdm,
      d_showChartView: true,
      d_showGraphicView: false,
      d_chartSize: {
        'height': 0,
        'width': 0,
        'x_mode': 'standart',
        'y_mode': 'standart',
        'x_interval_type': 'all',
        'x_interval': 1,
        'chart_type': ''
      },
      chart_data: {},
      d_resetChartData: {},
      d_tableShow: true,
      d_tablePagination: {
        'start': 0,
        'end': 100,
        'current': 1,
        'perpage': 100,
        'all_count': 0
      },
      d_searchTextRow: '',
      d_fullScreen: false,
      d_statsList: {
        'analyze_list': [],
        'all_count': 0,
        'filter_stats': [],
        'filter_analyze_types': [],
        'selected_columns': []
      },
      d_paramTypeColors: {
        'text': '#f7f3ff',
        'select': '#ffe5e5',
        'float': '#e5f0ff',
        'integer': '#e8ffe5',
        'datetime': '#fff3e0',
      },
      d_projectId: '',
      d_statsId: '',
      d_filterData: {
        'selected_columns': [],
        'selected_stats': '',
        'selected_p_value': '',
        'selected_analyze_types': '',
        'user_score_list': '',
        'pagination': {
          'start': 0,
          'end': 1,
          'current': 1,
          'perpage': 1,
          'all_count': 0
        },
      },
      d_timeLineYearMonthMode: { 'year': 0, 'month': 0 },
      d_timeLineLeftToRight: [],
      mother_children: {
        'change_status': 0,
        'forceUpdate': 0
      },
      d_timeLineMode: false,
      d_isThereInputColumn: false,
      d_selectedTableCellFullText: '',
      d_showTableCellFullText: false,
      d_analyzeContinuing: false,
      d_sqlName: '',
      d_showSqlName: true,
      d_clientIdShow: true,
      d_mainRule: {},
      d_project: { 'details': '', 'column_list': [] },
      d_resetProject: { 'details': '', 'column_list': [] },
      d_clientId: '',
      d_idType: '',
      d_wdmrId: '',
      d_selectScope: '',
      d_projectLocalScope: '',
      d_selectedModeTab: 'detailed_mode',
      d_firstInputIndex: '',
      d_firstOutputIndex: '',
      d_orderedColumnIndexList: [],
      d_compareEligible: true,
      d_wTableShow: false,
      d_excelFile: null,
      d_excelFileName: '',
      d_excelFileBase64: '',
      d_excelFileCreditEligible: false,
      d_excelFileCredit: 0,
      d_approveCredit: '',
      d_user: '',
      d_colorList: [
        {'code': '#50b309', 'type': 'green'},
        {'code': '#095bb3', 'type': 'blue'},
        {'code': '#b3092e', 'type': 'red'},
        {'code': '#b39c09', 'type': 'yellow'},
        {'code': '#09b36f', 'type': 'green'},
        {'code': '#091ab3', 'type': 'blue'},
        {'code': '#7509b3', 'type': 'purple'},
        {'code': '#095eb3', 'type': 'blue'},
        {'code': '#9709b3', 'type': 'pink'},
        {'code': '#09b331', 'type': 'green'},
        {'code': '#09b3a2', 'type': 'blue'},
        {'code': '#1ab309', 'type': 'green'},
        {'code': '#8eb309', 'type': 'yellow'},
        {'code': '#b37509', 'type': 'orange'},
        {'code': '#b31709', 'type': 'red'},
        {'code': '#b35309', 'type': 'orange'},
        {'code': '#5309b3', 'type': 'purple'},
        {'code': '#b30964', 'type': 'pink'},
        {'code': '#a809b3', 'type': 'purple'},
        {'code': '#b38e09', 'type': 'yellow'},
        {'code': '#0986b3', 'type': 'blue'},
        {'code': '#7509b3', 'type': 'purple'},
        {'code': '#b3094d', 'type': 'pink'},
        {'code': '#a2b309', 'type': 'yellow'},
        {'code': '#0964b3', 'type': 'blue'},
        {'code': '#b34d09', 'type': 'orange'},
        {'code': '#b34d09', 'type': 'green'},
        {'code': '#09b39f', 'type': 'blue'},
        {'code': '#b30956', 'type': 'pink'},
        {'code': '#b3091a', 'type': 'red'},
        {'code': '#b3091a', 'type': 'purple'},
        {'code': '#09b364', 'type': 'green'},
        {'code': '#6cb309', 'type': 'green'},
        {'code': '#4409b3', 'type': 'purple'},
        {'code': '#aab309', 'type': 'yellow'},
        {'code': '#b37209', 'type': 'yellow'},
        {'code': '#0942b3', 'type': 'blue'},
        {'code': '#b3092e', 'type': 'pink'},
        {'code': '#b32e09', 'type': 'orange'},
        {'code': '#b32e09', 'type': 'blue'},
        {'code': '#83b309', 'type': 'yellow'},
        {'code': '#7809b3', 'type': 'purple'},
        {'code': '#09b35b', 'type': 'green'},
        {'code': '#aab309', 'type': 'yellow'},
        {'code': '#b3096c', 'type': 'pink'},
        {'code': '#b36c09', 'type': 'orange'},
        {'code': '#b32e09', 'type': 'orange'},
        {'code': '#b32e09', 'type': 'blue'},
        {'code': '#b3098e', 'type': 'pink'},
        {'code': '#09b333', 'type': 'green'},
        {'code': '#b37709', 'type': 'yellow'},
      ],
      d_selectedOutput: '',
      d_selectedOutputParamType: '',
      d_mlModelList: [],
      d_mlTrainLoading: false,
      d_selectedOutputTrueOption: '',

      d_userAuthorizationListLoading: false,
      d_searchUser: '',
      d_searchAuth: '',
      d_newAssign: {
        'users': [],
        'auths': [],
        'auth_params': []
      },
      d_createAssign: [],
      d_filteredUsers: [],
      d_filteredAuths: {
        'auth_type_list': []
      },
      d_userSearched: false,
      d_authSearched: false,
      d_userSearchLoading: false,
      d_fileUploadLoading: false,
      d_oldResultList: [],
      d_oldResultsLoading: false,
      d_oldStatisticResultsModal: false,
      d_oldMlResultsModal: false,
      d_selectedOldResultItem: '',
      d_selectedOldStatsResultItem: '',
      d_selectedOldResultIndex: '',
      d_oldMlModelList: [],
      d_machineLearningMultiInputCombinationType: 'all_inputs_together', // create_permutations, all_inputs_together
    }
  },
  created () {
    ClsIndexDb.f_startIndexDb('layer_tree', 'wdm_list');
    this.d_user = JSON.parse(localStorage.getItem('user'));
    let local_data = JSON.parse(localStorage.getItem('analyze_report_data'));
    if (local_data) {
      this.f_reportData = local_data;
    }
    localStorage.removeItem('selected_project_id')

    // console.log('this.p_projectPermission ', this.p_projectPermission);
    if (this.p_projectId) {
      this.d_projectId = this.p_projectId;
    } else if (!this.p_projectId) {
      if (this.$route.query.project_id !== undefined) {
        this.d_projectId = this.$route.query.project_id;
      }
    }
    // project id local storage set edilmesinin nedeni: bir background servis çalıştırıldığında fonksiyon otomatik dönmeye devam ediyor. Fonksiyonu durdurmak için aktif projenin local storagedaki proje id olması zorunluluğunu koyduk. Dolayısıyla artık servis devam ederken proje değiştirilirse fonksiyon sorguya devam etmiyor. Böylece proje bazlı arka plan işlemi tanımlanabilmiş oldu. Başka projeye geçilse de sorun olmuyor. Servis başlatılan projeye dönüldüğünde çıktılar alınabiliyor.
    localStorage.setItem('selected_project_id', this.d_projectId);
    this.d_statsServiceId = this.f_manageBackgroundService('stats_services', '', this.d_projectId, 'check');
    if (this.d_statsServiceId) {
      this.f_wanalyzerProjectStatisticsResultByServiceId();
    }
    this.d_mlServiceId = this.f_manageBackgroundService('ml_services', '', this.d_projectId, 'check');
    if (this.d_mlServiceId) {
      this.f_wanalyzerMlTrainByServiceId();
    }

    if (this.p_selectedProjectType === 'wanalyzer_create_query') {
      this.d_selectedTab = 'general_settings';
      this.d_selectedTabItemId = 'dataset_view';
      this.d_selectedModeTab = 'detailed_mode';
      
      if (this.d_projectId) {
        // this.f_wanalyzerProjectDetailsColumnsWaiGet();
        this.f_wanalyzerProjectDatasetGet('dataset_table');
        this.f_wanalyzerProjectColumnDataList();
      }

    } else if (this.p_selectedProjectType === 'wanalyzer_dataset_filter') {
      if (this.p_datasetAdmin) {
        this.d_selectedTab = 'general_settings';
        this.d_selectedTabItemId = 'dataset_view';
        this.d_selectedModeTab = 'detailed_mode';
      } else {
        this.d_selectedTab = 'dataset_filter';
        this.d_selectedTabItemId = 'dataset_view';
        this.d_selectedModeTab = 'detailed_mode';
      }
      // this.d_comparedStatistics = true;
      if (this.d_projectId) {
        if (this.p_datasetAdmin) {
          this.f_wanalyzerProjectDatasetGet('dataset_table');
          this.f_wanalyzerProjectColumnDataList();
        } else {
          this.f_wanalyzerProjectDetailsColumnsWaiGet();
        }
      }
    } else if (this.p_selectedProjectType === 'wanalyzer_dataset_stats_query') {
      this.d_selectedTab = 'dataset_filter';
      this.d_selectedTabItemId = '';
      this.d_selectedModeTab = 'detailed_mode';
      this.f_wanalyzerProjectDetailsColumnsWaiGet();
    } else if (this.p_selectedProjectType === 'wanalyzer_credit_count') {
      this.d_selectedTab = 'general_settings';
      this.d_selectedTabItemId = 'dataset_view';
      this.d_selectedModeTab = 'detailed_mode';
      if (this.d_projectId) {
        // this.f_wanalyzerProjectDetailsColumnsWaiGet();
        this.f_wanalyzerProjectDatasetGet('dataset_table');
        this.f_wanalyzerProjectColumnDataList();
      }

    }
    this.f_getArticleList();
  },
  methods: {
    f_statsResultName: function (item) {
      if (!item || !item.data || !item.data.general) return '';

      const g = item.data.general;

      let baseName = '';
      let suffix = '';

      /* -------------------------------
       * 1️⃣ REGRESSION – NUMERIC DEP
       * ------------------------------- */
      if (
        g.one_or_multi_independent_one_dependent_numeric &&
        g.one_or_multi_independent_one_dependent_numeric.val &&
        g.one_or_multi_independent_one_dependent_numeric.val.value
      ) {
        const type = g.one_or_multi_independent_one_dependent_numeric.val.value;

        if (type === 'linear_regression') {
          baseName = this.StoreLang === 'tr'
            ? 'Lineer regresyon analizi'
            : 'Linear regression analysis';
        }

        if (type === 'logistic_regression') {
          baseName = this.StoreLang === 'tr'
            ? 'Lojistik regresyon analizi'
            : 'Logistic regression analysis';
        }

        const sel =
          g.one_or_multi_independent_one_dependent_numeric_selected &&
          g.one_or_multi_independent_one_dependent_numeric_selected[type] &&
          g.one_or_multi_independent_one_dependent_numeric_selected[type].detail &&
          g.one_or_multi_independent_one_dependent_numeric_selected[type].detail.oomiodn_variable_selection &&
          g.one_or_multi_independent_one_dependent_numeric_selected[type].detail.oomiodn_variable_selection.val &&
          g.one_or_multi_independent_one_dependent_numeric_selected[type].detail.oomiodn_variable_selection.val[0];

        if (sel) {
          if (sel.value === '1') {
            suffix = this.StoreLang === 'tr'
              ? ' (tüm değişkenler)'
              : ' (all predictors)';
          }
          if (sel.value === '2') {
            suffix = this.StoreLang === 'tr'
              ? ' (anlamlı değişkenler)'
              : ' (significant predictors)';
          }
        }

        return baseName + suffix;
      }

      /* -----------------------------------
       * 2️⃣ REGRESSION – CATEGORICAL DEP
       * ----------------------------------- */
      if (
        g.one_or_multi_independent_one_dependent_categorical &&
        g.one_or_multi_independent_one_dependent_categorical.val &&
        g.one_or_multi_independent_one_dependent_categorical.val.value
      ) {
        baseName = this.StoreLang === 'tr'
          ? 'Lojistik regresyon analizi'
          : 'Logistic regression analysis';

        const sel =
          g.one_or_multi_independent_one_dependent_categorical_selected &&
          g.one_or_multi_independent_one_dependent_categorical_selected.logistic_regression &&
          g.one_or_multi_independent_one_dependent_categorical_selected.logistic_regression.detail &&
          g.one_or_multi_independent_one_dependent_categorical_selected.logistic_regression.detail.oomiodc_variable_selection &&
          g.one_or_multi_independent_one_dependent_categorical_selected.logistic_regression.detail.oomiodc_variable_selection.val &&
          g.one_or_multi_independent_one_dependent_categorical_selected.logistic_regression.detail.oomiodc_variable_selection.val[0];

        if (sel) {
          if (sel.value === '1') {
            suffix = this.StoreLang === 'tr'
              ? ' (tüm değişkenler)'
              : ' (all predictors)';
          }
          if (sel.value === '2') {
            suffix = this.StoreLang === 'tr'
              ? ' (anlamlı değişkenler)'
              : ' (significant predictors)';
          }
        }

        return baseName + suffix;
      }

      /* -------------------------------
       * 3️⃣ CROSS COLUMNS
       * ------------------------------- */
      if (
        g.analyze_type &&
        g.analyze_type.val &&
        g.analyze_type.val.value === 'cross_columns'
      ) {
        return this.StoreLang === 'tr'
          ? 'Karşılaştırmalı analiz'
          : 'Comparative analysis';
      }

      return '';
    },
    f_cancelService: function () {
      this.d_taskStarted = false;
      this.d_mlTrainLoading = false;      
      this.d_statsServiceId = '';
      this.d_mlServiceId = '';
      this.d_statsViewLoading = false;
      this.f_manageBackgroundService('stats_services', '', this.d_projectId, 'remove');
      this.f_manageBackgroundService('ml_services', '', this.d_projectId, 'remove');
    },
    f_variablesListShow: function () {
      if (this.d_variablesShow) {
        this.d_variablesShow = false;
      } else {
        this.d_variablesShow = true;
      }
      this.$forceUpdate();
    },
    f_checkShowAnalyzeItem: function (analyze_item) {
      let res = false;
      if (analyze_item.text_list && analyze_item.text_list.length > 0) {
        res = true;
      }
      if (analyze_item.table_list && analyze_item.table_list.length > 0) {
        res = true;
      }
      if (analyze_item.parameters && Object.keys(analyze_item.parameters).length > 0) {
        res = true;
      }
      return res;
    },
    f_selectOldResultItem: function (result_type, old_result, old_result_index) {
      let result_json = JSON.parse(old_result['data']['0']['3']['val']);
      if (result_type == 'statistical_analysis') {
        this.d_selectedOldResultItem = result_json[this.d_projectId];
      } else if (result_type == 'ml_training') {
        this.d_oldMlModelList = result_json;
      }
      this.d_selectedOldResultIndex = old_result_index;
      this.d_selectedOldStatsResultItem = '';
      // console.log(result_json)
    },
    f_copyArticleDetails: function (element_id) {
      this.d_articleList.list[this.d_articleList.selected_index].selected_item_index = '';
      this.$forceUpdate();
      setTimeout(function () {
        ClsHtml.f_copyHtmlAsClipboard(element_id);
      }.bind(this), 250)

    },
    f_saveArticle: function () {
      for (let i in this.d_articleList.list[this.d_articleList.selected_index].items) {
        let item_data = this.d_articleList.list[this.d_articleList.selected_index].items[i];
        let html_element_id = 'article_edit_item_' + i;
        let article_el = document.getElementById(html_element_id);
        if (article_el) {
          if (item_data.type === 'text') {
            this.d_articleList.list[this.d_articleList.selected_index].items[i].text = article_el.innerHTML;
          }
        }
      }
      localStorage.setItem('article_list', JSON.stringify(this.d_articleList));
      this.d_articleSaveLoading = true;
      setTimeout(function () {
        this.d_articleSaveLoading = false;
      }.bind(this), 1000)
    },
    f_getArticleList: function () {
      let local_data = JSON.parse(localStorage.getItem('article_list'));
      if (local_data) {
        local_data.show = false;
        this.d_articleList = local_data;
      }
    },
    f_deleteArticleItem: function (article_item_index) {
      let local_data = JSON.parse(localStorage.getItem('article_list'));
      if (local_data) {
        this.d_articleList.list.splice(article_item_index, 1);
        localStorage.setItem('article_list', JSON.stringify(this.d_articleList));
        alert(this.StoreLangTranslation.data['operation_completed'][this.StoreLang]);
      }
    },
    f_addNewRowToArticle: function (article_selected_index, article_item_index, item_type='text') {
      if (item_type === 'text') {
        let new_item = {'type': 'text', 'text': 'new'};
        this.d_articleList.list[article_selected_index].items.splice(article_item_index + 1, 0, new_item);
      }
      this.$forceUpdate();
    },
    f_selectedArticleRowStyleChange: function (style_type) {
      if (this.d_articleList.list[this.d_articleList.selected_index].selected_item_index !== undefined && this.d_articleList.list[this.d_articleList.selected_index].selected_item_index !== '') {
        let item_data = this.d_articleList.list[this.d_articleList.selected_index].items[this.d_articleList.list[this.d_articleList.selected_index].selected_item_index];
        if (item_data.style) {
          if (style_type === 'bold') {
            if (item_data.style.indexOf('font-weight') !== -1) {
              item_data.style = item_data.style.replace('font-weight: bold;', '');
            } else {
              item_data.style += 'font-weight: bold;'
            }
          }
        } else {
          item_data.style = 'font-weight: bold;'
        }
        this.$forceUpdate();
      }
    },
    f_deleteRowOfArticle: function (article_selected_index, article_item_index) {
      if (confirm('deletion')) {
        this.d_articleList.list[article_selected_index].items.splice(article_item_index, 1);
        this.$forceUpdate();
      }
    },
    f_selectArticleItemIndex: function (article_selected_index, article_item_index) {
      this.d_articleList.list[article_selected_index].selected_item_index = article_item_index;
      this.$forceUpdate();
    },
    f_showArticleEdit: function (article_item_index) {
      this.d_articleList.selected_index = article_item_index;
      // console.log('f_showArticleEdit');
      this.d_articleList.show = true;
      this.$forceUpdate();
    },
    f_createNewArticle: function () {
      let new_article_data = {
        'name': 'new article',
        'items': [
          {'type': 'text', 'text': 'Caption', 'style': 'font-weight: bold;'},
          {'type': 'text', 'text': 'Name Surname, Department, Institution, City, Country', 'style': 'font-weight: bold;'},
          {'type': 'text', 'text': 'Corresponding Author:', 'style': 'font-weight: bold;'},
          {'type': 'text', 'text': '<div>Dr. Name Surname</div><div>Your Institution</div><div>Your Department</div><div>Your Postal Code</div><div>City - Country</div><div>E-mail: Your Email</div>'},
          {'type': 'text', 'text': 'Abstract', 'style': 'font-weight: bold;'},
          {'type': 'text', 'text': 'Aim', 'style': 'font-weight: bold;'},
          {'type': 'text', 'text': ''},
          {'type': 'text', 'text': 'Methods', 'style': 'font-weight: bold;'},
          {'type': 'text', 'text': ''},
          {'type': 'text', 'text': 'Results', 'style': 'font-weight: bold;'},
          {'type': 'text', 'text': ''},
          {'type': 'text', 'text': 'Conclusion', 'style': 'font-weight: bold;'},
          {'type': 'text', 'text': ''},
          {'type': 'text', 'text': 'Key words', 'style': 'font-weight: bold;'},
          {'type': 'text', 'text': ''},
          {'type': 'text', 'text': 'Introduction', 'style': 'font-weight: bold;'},
          {'type': 'text', 'text': ''},
          {'type': 'text', 'text': 'Materials and Methods', 'style': 'font-weight: bold;'},
          {'type': 'text', 'text': 'Patients', 'style': 'font-weight: bold;'},
          {'type': 'text', 'text': 'A total of ???100 cases who applied to ???Your Department of Your Hospitals in ???Your Country were included in this study. It was planned to conduct analyses in ??? groups.' , 'style': ''},
          {'type': 'text', 'text': 'Study Design', 'style': 'font-weight: bold;'},
          {'type': 'text', 'text': 'This study is a national, multicenter, retrospective study. The study was approved by the ??? ethics committee. Various clinical and laboratory findings, shown in the descriptive table (Table 1), that may be related to ??? were also prepared for use in the analyses.  Statistical analysis and ML modeling studies were performed on ??? groups. We performed ML training with each ???parameter 1, ???parameter 2,  as multi-combination analysis.'},
          {'type': 'text', 'text': 'Statistical Analyses and Tools', 'style': 'font-weight: bold;'},
          {'type': 'text', 'text': 'Statistical analysis and ML training procedure were performed on Wistats v3.0 (WisdomEra Corp., Istanbul, Turkey) which uses python programming language statistics and ML libraries (SciPy v1.2.3, scikit-learn v0.24.0, statsmodels v0.9.0). Data distribution analyses were performed with skewness, kurtosis tests. In addition, the Shapiro-Wilk test was used in normality analyses. The test to be used in comparative analyses was decided according to data distribution analyses. Chi-square, Fisher Exact tests were used in comparisons of categorical variables. Kruskal Wallis, One-way ANOVA, T-test, Mann Whitney-U tests were used in comparisons of categorical and numerical data. Pearson and Spearman correlation tests were used in comparisons of numerical and numerical data. Analyses resulting in a p value < 0.05 were considered statistically significant.'},
          {'type': 'text', 'text': 'Machine Learning Procedure and Pipeline', 'style': 'font-weight: bold;'},
          {'type': 'text', 'text': 'Statistical analyses were performed before starting the ML model. The ??? parameter was used as the output. Five classification ML models were included as support vector machine (SVM), decision tree (DT), random forest (RF), k-nearest neighbors (KNN), and logistic regression (LR). 30% was taken as the basis of the test size. Many power factors such as area under the curve (auc) value, accuracy rate, sensitivity, precision and F1 score were evaluated to check the power of the ML model. (Figure 1)'},
          {'type': 'text', 'text': 'Deploying The Best Decision Support Algorithms on Web Application', 'style': 'font-weight: bold;'},
          {'type': 'text', 'text': 'Among the developed algorithms, it was decided that the ML model with the highest power could be used, and the algorithm installation was carried out on the WisdomEra-WAI data analytics web template platform, which is on the cloud infrastructure. In this application, we introduce many decision support algorithms that we have worked on and will link them to our articles. On the front end of this application, the choice of surgery type can be predicted with input parameters (Figure 2). Our algorithms can be integrated into decision support systems on a service basis by the application. Thus, we can transform decision support algorithms into products and offer them to the use of the specialists and others'},
          {'type': 'text', 'text': 'Results', 'style': 'font-weight: bold;'},
          {'type': 'text', 'text': 'Statistical Results', 'style': 'font-weight: bold;'},
          {'type': 'text', 'text': ''},
          {'type': 'text', 'text': 'Machine Learning Model Training Results', 'style': 'font-weight: bold;'},
          {'type': 'text', 'text': ''},
          {'type': 'text', 'text': 'Discussion', 'style': 'font-weight: bold;'},
          {'type': 'text', 'text': 'Principal Findings', 'style': 'font-weight: bold;'},
          {'type': 'text', 'text': ''},
          {'type': 'text', 'text': 'Results in the Context of What is Known', 'style': 'font-weight: bold;'},
          {'type': 'text', 'text': ''},
          {'type': 'text', 'text': 'Strengths and Limitations', 'style': 'font-weight: bold;'},
          {'type': 'text', 'text': ''},
          {'type': 'text', 'text': 'Research Implications', 'style': 'font-weight: bold;'},
          {'type': 'text', 'text': ''},
          {'type': 'text', 'text': 'Conclusions', 'style': 'font-weight: bold;'},
          {'type': 'text', 'text': ''},
          {'type': 'text', 'text': 'Conflict of Interest', 'style': 'font-weight: bold;'},
          {'type': 'text', 'text': 'None of the authors has any potential financial conflict of interest related to this manuscript.'},
          {'type': 'text', 'text': 'Acknowledgments', 'style': 'font-weight: bold;'},
          {'type': 'text', 'text': 'We would like to thank the ??? for data preprocessing and data analytics support.'},
          {'type': 'text', 'text': 'References', 'style': 'font-weight: bold;'},
          {'type': 'text', 'text': ''},
          {'type': 'text', 'text': 'Table 1. Case Characteristics and Comparative Results Between Groups', 'style': 'font-weight: bold;'},
          {'type': 'table', 'text': '', 'table': []},
          {'type': 'text', 'text': 'Table 2 Examples of machine learning models with different input combinations by XXX', 'style': 'font-weight: bold;'},
          {'type': 'table', 'text': '', 'table': []},
          {'type': 'text', 'text': 'Table 3. Number of Machine Learning Models Based On Accuracy Rate Groups', 'style': 'font-weight: bold;'},
          {'type': 'table', 'text': '', 'table': []},
          {'type': 'text', 'text': 'Figure 1. Machine Learning Procedure and Pipeline', 'style': 'font-weight: bold;'},
          {'type': 'figure', 'text': '', 'table': [], 'figure': '', 'figure_src': 'https://wisdomera-api.wisdomera.io/v1/document/get?__sys__pro__id=6a82ddf7-3e12-4708-8ad5-0335a66d4b23&doc=599d8c12-43af-49e9-a976-12ed66148e64'},
          {'type': 'text', 'text': 'Figure 2. Case based visualization of data distribution and correlation from minimum to maximum values', 'style': 'font-weight: bold;'},
          {'type': 'figure', 'text': '', 'table': [], 'figure': '', 'figure_src': ''},
        ]
      }
      this.d_articleList.list.push(new_article_data);
      localStorage.setItem('article_list', JSON.stringify(this.d_articleList));
      alert(this.StoreLangTranslation.data['operation_completed'][this.StoreLang]);
    },
    f_authAssign: function () {
      let payloadAuthList = [];
      let general_det = true;
      for (let assigningAuthIndex = 0; assigningAuthIndex < this.d_newAssign.auths.length; assigningAuthIndex++) {
        let det = false;
        if (this.d_newAssign.auth_params[assigningAuthIndex]['auth_count_create'] === '1') {
          if (parseInt(this.d_newAssign.auth_params[assigningAuthIndex]['auth_count']) > 0 && parseInt(this.d_newAssign.auth_params[assigningAuthIndex]['auth_count']) <= parseInt(this.p_creditAuthData.auth_data['data']['0']['6']['val']) - parseInt(this.p_creditAuthData.auth_data['data']['0']['7']['val']) ) {
            det = true;
          } else {
            det = false;
            general_det = false;
            alert(this.StoreLangTranslation.data['check_auth_count'][this.StoreLang])
          }
        } else {
          det = true;
        }
        if (det) {
          let payloadAuthListItem = {
            'auth_code': '',
            'auth_id': '',
            'auth_type': '',
            'auth_count_create': '',
            'can_assign_auth': '1',
            'auth_count': '0',
            'auth_count_type': '0',
            'start_date': '',
            'end_date': '',
            'auth_label': '',
            'auth_label_lang': '',
            'auth_client_id': this.d_newAssign.auths[assigningAuthIndex]['client_id']
          };
          // ekrandaki input parametrelerinden gelen veriler
          if (this.d_newAssign.auth_params[assigningAuthIndex]['auth_count_create'] == '1') {
            payloadAuthListItem['auth_count_create'] = this.d_newAssign.auth_params[assigningAuthIndex]['auth_count_create'];
            payloadAuthListItem['auth_count_type'] = '2' //yetki sayısının üzerine eklenecek şekilde
          } else {
            payloadAuthListItem['auth_count_type'] = '0' //yetki adedi yok şeklinde
          }
          if (this.d_newAssign.auth_params[assigningAuthIndex]['auth_count']) {
            payloadAuthListItem['auth_count'] = this.d_newAssign.auth_params[assigningAuthIndex]['auth_count'];
          }
          // if (this.d_newAssign.auth_params[assigningAuthIndex]['can_assign_auth']) {
          //   payloadAuthListItem['can_assign_auth'] = this.d_newAssign.auth_params[assigningAuthIndex]['can_assign_auth'];
          // }
          // admin için yetki adet tipi aktifleştirilirse burası da açılacak ki oradaki inputtan alınsın
          // if (this.d_newAssign.auth_params[assigningAuthIndex]['auth_count_type']) {
          //   payloadAuthListItem['auth_count_type'] = this.d_newAssign.auth_params[assigningAuthIndex]['auth_count_type'];
          // }
          // if (this.d_newAssign.auth_params[assigningAuthIndex]['start_date']) {
          //   payloadAuthListItem['start_date'] = this.d_newAssign.auth_params[assigningAuthIndex]['start_date'];
          // }
          // if (this.d_newAssign.auth_params[assigningAuthIndex]['end_date']) {
          //   payloadAuthListItem['end_date'] = this.d_newAssign.auth_params[assigningAuthIndex]['end_date'];
          // }
          // auth dokümanı içerisinden gelen veriler
          if (this.d_newAssign.auths[assigningAuthIndex]['data']['0']['1'] && this.d_newAssign.auths[assigningAuthIndex]['data']['0']['1']['val']) {
            payloadAuthListItem['auth_code'] = this.d_newAssign.auths[assigningAuthIndex]['data']['0']['1']['val'];
          }
          if (this.d_newAssign.auths[assigningAuthIndex]['data']['0']['10'] && this.d_newAssign.auths[assigningAuthIndex]['data']['0']['10']['val']) {
            payloadAuthListItem['auth_id'] = this.d_newAssign.auths[assigningAuthIndex]['data']['0']['10']['val'];
          }
          if (this.d_newAssign.auths[assigningAuthIndex]['data']['0']['2'] && this.d_newAssign.auths[assigningAuthIndex]['data']['0']['2']['val'] && this.d_newAssign.auths[assigningAuthIndex]['data']['0']['2']['val']['value']) {
            payloadAuthListItem['auth_type'] = this.d_newAssign.auths[assigningAuthIndex]['data']['0']['2']['val']['value'];
          }
          if (this.d_newAssign.auths[assigningAuthIndex]['data']['0']['34'] && this.d_newAssign.auths[assigningAuthIndex]['data']['0']['34']['val']) {
            payloadAuthListItem['auth_label'] = this.d_newAssign.auths[assigningAuthIndex]['data']['0']['34']['val'];
          }
          if (this.d_newAssign.auths[assigningAuthIndex]['data']['0']['34'] && this.d_newAssign.auths[assigningAuthIndex]['data']['0']['34']['lang']) {
            payloadAuthListItem['auth_label_lang'] = this.d_newAssign.auths[assigningAuthIndex]['data']['0']['34']['lang'];
          }
          if (this.d_newAssign.auths[assigningAuthIndex]['data']['0']['11'] && this.d_newAssign.auths[assigningAuthIndex]['data']['0']['11']['val']) {
            payloadAuthListItem['old_owner'] = this.d_newAssign.auths[assigningAuthIndex]['data']['0']['11']['val'];
          }
          payloadAuthList.push(payloadAuthListItem);
        }
      }
      if (payloadAuthList.length > 0 && general_det) {
        let query = '';
        let data = {
          'auth_list': payloadAuthList,
          'assigning_username_list': this.d_newAssign.users,
        };
        // console.log(data);
        ServiceFunctions.authorization_assign_to_user(query, data)
          .then(resp => {
            if (resp.data.status_code.substring(resp.data.status_code.length - 3, resp.data.status_code.length) == '000') {
              // console.log(resp.data);
              if (this.f_getUserAuthorizationList) {
                this.f_getUserAuthorizationList();
                this.d_newAssign = {
                  'users': [],
                  'auths': [],
                  'auth_params': []
                }
              }
              let assigned = true;
              let unassigned_labels = [];
              for (let list_item_index in resp.data.list) {
                if (resp.data.list[list_item_index]['assigned'] === 'false') {
                  assigned = false;
                  unassigned_labels.push(resp.data.list[list_item_index]['label'])
                }
              }
              if (assigned) {
                alert(this.StoreLangTranslation.data['auth_assign_success_message'][this.StoreLang])
              } else {
                let unassigned_msg = '';
                for (let a in unassigned_labels) {
                  if (a != 0) {
                    unassigned_msg += '\n';
                  }
                  unassigned_msg += unassigned_labels[a];
                }
                alert(this.StoreLangTranslation.data['auth_assign_unsuccess_message'][this.StoreLang] + unassigned_msg)
              }
            } else {
              let txt = 'status_code = ' + resp.data.status_code + '\n';
              txt += 'status_message = ' + resp.data.status_message;
              alert(txt);
            }
          });
      }
    },
    f_searchUser: function () {
      if (this.d_searchUser) {
        this.d_userSearchLoading = true;
        const file_type = 'username';
        const match_type = 'include';
        const search_text = this.d_searchUser;
        let query = 'field_type=' + file_type + '&match_type=' + match_type;
        let data = {
          'search_text': search_text
        };
        
        ServiceFunctions.user_search(query, data)
          .then(resp => {
            this.d_userSearched = true;
            this.d_filteredUsers = [];
            this.d_userSearchLoading = false;
            if (resp.data.status_code.substring(resp.data.status_code.length - 3, resp.data.status_code.length) == '000') {
              // console.log(resp.data);
              this.d_filteredUsers = resp.data.list;
            }
          });
      } else {
        alert(this.StoreLangTranslation.data['username_cannot_be_empty'][this.StoreLang]);
      }
    },
    f_removeUser: function (user) {
      let removeIndex = this.d_newAssign.users.indexOf(user);
      if (removeIndex !== -1) {
        this.d_newAssign.users.splice(removeIndex, 1);
      }
    },
    f_removeAuth: function (auth) {
      let removeIndex = this.d_newAssign.auths.indexOf(auth);
      if (removeIndex !== -1) {
        this.d_newAssign.auth_params.splice(removeIndex, 1);
        this.d_newAssign.auths.splice(removeIndex, 1);
      }
    },
    f_clearSearchUser: function () {
      this.d_userSearched = false;
      this.d_searchUser = '';
    },
    f_clearSearchAuth: function () {
      this.d_authSearched = false;
      this.d_searchAuth = '';
    },
    f_addUser: function (user) {
      this.d_newAssign.users.push(user.username);
    },
    f_addAuth: function (auth) {
      let params = {
        'can_assign_auth': '0',
        'auth_count_create': '0',
        'auth_count': '0',
        'auth_count_type': '0',
        'start_date': '',
        'end_date': '' 
      }
      if (auth['client_id'].endsWith('_wanalyzer_credit_count')) {
        params['auth_count_create'] = '1';
        params['can_assign_auth'] = '0';
      } else {
        params['auth_count_create'] = '0';
        params['can_assign_auth'] = '1';
      }
      this.d_newAssign.auth_params.push(params)
      this.d_newAssign.auths.push(auth);
    },
    f_clickMachineLearningTraining: function () {
      this.d_selectedTabItemId = 'machine_learning_training';
      if (this.d_selectedOutput) {
        this.d_project.column_list[this.d_selectedOutput].use_as_stats = 'no';
      }
    },
    f_downloadDocument: function (base64_file, base64_file_name) {
      // console.log("base64_file ", base64_file);
      // console.log("base64_file_name ", base64_file_name);
      function base64ToArrayBuffer(base64) {
        var binaryString = window.atob(base64);
        var binaryLen = binaryString.length;
        var bytes = new Uint8Array(binaryLen);
        for (var i = 0; i < binaryLen; i++) {
          var ascii = binaryString.charCodeAt(i);
          bytes[i] = ascii;
        }
        return bytes;
      }

      var saveByteArray = (function () {
        var a = document.createElement("a");
        document.body.appendChild(a);
        a.style = "display: none";
        return function (data, name) {
          var blob = new Blob(data, { type: "octet/stream" }),
            url = window.URL.createObjectURL(blob);
          a.href = url;
          a.download = name;
          a.click();
          window.URL.revokeObjectURL(url);
        };
      }());
      var sampleBytes = base64ToArrayBuffer(base64_file);
      saveByteArray([sampleBytes], base64_file_name);
    },
    f_downloadTableAsExcel: function (table_data) {
      let query = '';
      let data = {};
      data.table_header = table_data.table_header;
      data.table = table_data.table;
      ServiceFunctions.table_to_excel(query, data)
        .then(resp => {
          if (resp.data.file) {
            this.f_downloadDocument(resp.data.file, resp.data.file_name)
          } else {
            let txt = 'status_code = ' + resp.data.status_code + '\n';
            txt += 'status_message = ' + resp.data.status_message;
            alert(txt);
          }
        });
    },
    f_downloadModelListAsExcel: function () {
      let new_table_data = {
        'table_header': [
          {'label': 'input'},
          {'label': 'output'},
          {'label': 'model'},
          {'label': 'test_size'},

          {'label': 'accuracy'},
          {'label': 'r2_score'},
          {'label': 'roc_auc'},

          {'label': 'cross_validation_accuracy_mean'},
          {'label': 'cross_validation_accuracy_std'},
          {'label': 'cross_validation_r2_mean'},
          {'label': 'cross_validation_r2_std'},
          {'label': 'cross_validation_roc_auc_mean'},
          {'label': 'cross_validation_roc_auc_std'},

          {'label': 'calibration_brier_score'},
          {'label': 'calibration_interpretation'},

          {'label': 'mean_absolute_error'},
          {'label': 'mean_squared_error'},
          {'label': 'root_mean_squared_error'},

          {'label': 'warning'},

          {'label': 'precision_binary'},
          {'label': 'precision_micro'},
          {'label': 'precision_macro'},
          {'label': 'precision_weighted'},

          {'label': 'recall_binary'},
          {'label': 'recall_micro'},
          {'label': 'recall_macro'},
          {'label': 'recall_weighted'},

          {'label': 'fscore_binary'},
          {'label': 'fscore_micro'},
          {'label': 'fscore_macro'},
          {'label': 'fscore_weighted'},

          {'label': 'silhouette_score'},
          {'label': 'calinski_harabaz_score'},
          {'label': 'davies_bouldin_score'}
        ],
        'table': []
      };

      for (let i in this.d_mlModelList) {
        let new_row = [];
        let model = this.d_mlModelList[i];

        let input_label = '';
        for (let k in model['input']) {
          input_label += model['input'][k].label;
          if (parseInt(k) !== model['input'].length - 1) {
            input_label += ' ';
          }
        }

        new_row.push({'val': {'label': input_label}});
        new_row.push({'val': {'label': model['output']}});
        new_row.push({'val': {'label': model['model']}});
        new_row.push({'val': {'label': model['test_size']}});

        new_row.push({'val': {'label': model['accuracy']}});
        new_row.push({'val': {'label': model['r2_score']}});
        new_row.push({'val': {'label': model['roc_auc']}});

        new_row.push({'val': {'label': model['cross_validation_accuracy_mean']}});
        new_row.push({'val': {'label': model['cross_validation_accuracy_std']}});
        new_row.push({'val': {'label': model['cross_validation_r2_mean']}});
        new_row.push({'val': {'label': model['cross_validation_r2_std']}});
        new_row.push({'val': {'label': model['cross_validation_roc_auc_mean']}});
        new_row.push({'val': {'label': model['cross_validation_roc_auc_std']}});

        new_row.push({'val': {'label': model['calibration_brier_score']}});
        new_row.push({'val': {'label': model['calibration_interpretation']}});

        new_row.push({'val': {'label': model['mean_absolute_error']}});
        new_row.push({'val': {'label': model['mean_squared_error']}});
        new_row.push({'val': {'label': model['root_mean_squared_error']}});

        new_row.push({'val': {'label': model['warning']}});

        new_row.push({'val': {'label': model['precision_binary']}});
        new_row.push({'val': {'label': model['precision_micro']}});
        new_row.push({'val': {'label': model['precision_macro']}});
        new_row.push({'val': {'label': model['precision_weighted']}});

        new_row.push({'val': {'label': model['recall_binary']}});
        new_row.push({'val': {'label': model['recall_micro']}});
        new_row.push({'val': {'label': model['recall_macro']}});
        new_row.push({'val': {'label': model['recall_weighted']}});

        new_row.push({'val': {'label': model['fscore_binary']}});
        new_row.push({'val': {'label': model['fscore_micro']}});
        new_row.push({'val': {'label': model['fscore_macro']}});
        new_row.push({'val': {'label': model['fscore_weighted']}});

        new_row.push({'val': {'label': model['silhouette_score']}});
        new_row.push({'val': {'label': model['calinski_harabaz_score']}});
        new_row.push({'val': {'label': model['davies_bouldin_score']}});

        new_table_data.table.push(new_row);
      }

      this.f_downloadTableAsExcel(new_table_data);
    },
    f_mlTrain: function () {
      this.d_mlTrainLoading = true;
      this.d_mlModelList = [];
      let ml_data = {
        "data": {
          "general": {
            "model_selection": {"val": {"value": "all"}},
            "output_variable_type": {"val": {"value": this.d_selectedOutputParamType}},
            "multi_input_combination_type": {"val": {"value": this.d_machineLearningMultiInputCombinationType}},
            "test_size": {"val": "30"}, // info olarak test size yüzde30 olarak belirlendi yazılsın
            "selected_input_variables": {}
          }
        }
      }

      if (this.d_selectedOutputParamType == 'categorical') {
        ml_data['data']['general']['categorical_output_variable'] = {"val": {"value": this.d_selectedOutput}}
        ml_data['data']['general']['true_output_option'] = {"val": ""}
        ml_data['data']['general']['categorical_parameter_usage_type'] = {"val": {"value": "auto"}}
        if (this.d_selectedOutputTrueOption) {
          ml_data['data']['general']['true_output_option'] = {"val": this.d_selectedOutputTrueOption};
        }
      } else if (this.d_selectedOutputParamType == 'numeric') {
        ml_data['data']['general']['numeric_output_variable'] = {"val": {"value": this.d_selectedOutput}}
        ml_data['data']['general']['numeric_parameter_usage_type'] = {"val": {"value": "auto"}}
      }
      for (let i in this.d_project.column_list) {
        if (this.d_project.column_list[i].use_as_stats === 'yes') {
          let param_type = ''
          let param_type_usage = ''
          if (['select', 'radiogroup'].indexOf(this.d_project.column_list[i].param_type) !== -1) {
            param_type = 'categorical';
            param_type_usage = 'auto';
          } else if (['date', 'datetime', 'time'].indexOf(this.d_project.column_list[i].param_type) !== -1) {
            param_type = 'categorical';
            param_type_usage = 'selected';
          } else if (['integer', 'float'].indexOf(this.d_project.column_list[i].param_type) !== -1) {
            param_type = 'numeric';
            param_type_usage = 'auto';
          } else if (this.d_project.column_list[i].stats_data_type){
            param_type = this.d_project.column_list[i].stats_data_type;
            param_type_usage = 'selected';
          } else {
            console.log('d_project.column_list[i].param_type ',this.d_project.column_list[i].param_type);
          }
          ml_data['data']['general']['selected_input_variables'][i] = {
            "name": {"value": String(i)},
            "detail": {
              "param_type_usage": {"val": {"value": param_type_usage} },
              "option_group_type": {"val": {"value": "standard_mode"} },
              "parameter_type": {"val": {"value": param_type} }
            }
          }
        }
      }
      let column_count = 0;
      for (let i in this.d_project.column_list) {
        if (this.d_project.column_list[i].use_as_stats === 'yes') {
          column_count ++;
        }
      }
      let combination_res = 0;
      for (let i = 2; i <= column_count; i ++) {
        combination_res += this.f_combination(column_count, i)
      }
      let query = '';
      query += 'project_id=' + this.d_projectId;
      if (this.p_projectPermission && this.p_projectPermission.auth_data) {
        query += '&auth_client_id=' + this.p_projectPermission.auth_data.client_id;
      }
      let data = {};
      data.ml_data = ml_data
      data.frd_usage_count = 5 * (column_count + combination_res);
      // console.log(data);
      ServiceFunctions.wanalyzer_machinelearning_train(query, data)
        .then(resp => {
          if (resp.data.status_code.substring(resp.data.status_code.length - 3, resp.data.status_code.length) == '000') {
            if (resp.data.credit_eligible === '0') {
              alert(this.StoreLangTranslation.data['not_enough_credit'][this.StoreLang])
            } else {
              if (resp.data.user_credit_auth_data) {
                this.p_creditAuthData.auth_data = resp.data.user_credit_auth_data;
              }
              // servis id değeri ile arka planda sonucu timer ile izlemeye başlanıyor.
              this.d_mlServiceId = resp.data.service_id;
              this.d_taskStarted = true;
              this.f_manageBackgroundService('ml_services', this.d_mlServiceId, this.d_projectId, 'add');
              setTimeout(function () {
                this.f_wanalyzerMlTrainByServiceId();
              }.bind(this), 10000)
            }
          } else {
            this.d_taskStarted = false;
            this.d_mlTrainLoading = false;
            let txt = 'status_code = ' + resp.data.status_code + '\n';
            txt += 'status_message = ' + resp.data.status_message;
            alert(txt);
          }
        });
    },
    f_manageBackgroundService: function (service_type, service_id, project_id, process_type) {
      // service_type = ml_services or stats_services
      // localstorage yapısı: keyler ml_services or stats_services. liste formatında.
      // Yapı = [{'service_id': '', 'project_id': ''}]
      // process_type => 'remove': listeden eleman silinir. 'add': listeye yeni eleman eklenir. 'check': listede varsa true döner.
      /*
        service_id zorunlu değil

        check:

        service_id verilmişse → eşleşme varsa service_id döner, yoksa false

        service_id verilmemişse → ilgili project_id için bulunan service_id döner, yoksa false

        add:

        Aynı project_id için kayıt varsa update eder

        remove:

        service_id verilmişse → birebir siler

        verilmemişse → project_id’ye ait tüm kayıtları siler
      */

      if (!service_type || !project_id || !process_type) {
        return false;
      }

      let stored_list = localStorage.getItem(service_type);
      let service_list = [];

      try {
        service_list = stored_list ? JSON.parse(stored_list) : [];
        if (!Array.isArray(service_list)) service_list = [];
      } catch (e) {
        service_list = [];
      }

      switch (process_type) {

        /* ================= CHECK ================= */
        case 'check':
          if (service_id) {
            const found = service_list.find(
              item => item.project_id === project_id && item.service_id === service_id
            );
            return found ? found.service_id : false;
          } else {
            const found = service_list.find(
              item => item.project_id === project_id
            );
            return found ? found.service_id : false;
          }

        /* ================= ADD ================= */
        case 'add':
          if (!service_id) return false;

          const index = service_list.findIndex(
            item => item.project_id === project_id
          );

          if (index === -1) {
            service_list.push({
              service_id: service_id,
              project_id: project_id
            });
          } else {
            // aynı project için service güncelle
            service_list[index].service_id = service_id;
          }

          localStorage.setItem(service_type, JSON.stringify(service_list));
          return true;

        /* ================= REMOVE ================= */
        case 'remove':
          if (service_id) {
            service_list = service_list.filter(
              item => !(item.project_id === project_id && item.service_id === service_id)
            );
          } else {
            // service_id yoksa projeye ait her şeyi sil
            service_list = service_list.filter(
              item => item.project_id !== project_id
            );
          }

          localStorage.setItem(service_type, JSON.stringify(service_list));
          return true;

        default:
          return false;
      }

    },

    f_wanalyzerMlTrainByServiceId: function () {
      if (this.d_mlServiceId && localStorage.getItem('selected_project_id') === this.d_projectId) {
        this.d_taskStarted = true;
        this.d_mlTrainLoading = true;
        let query = 'project_id=' + this.d_projectId;
        query += '&service_id=' + this.d_mlServiceId;
        if (this.p_projectPermission && this.p_projectPermission.auth_data) {
          query += '&auth_client_id=' + this.p_projectPermission.auth_data.client_id;
        }
        let data = {'ml_data': ''};
        ServiceFunctions.wanalyzer_machinelearning_train(query, data)
          .then(resp => {
            if (resp.data.status_code.substring(resp.data.status_code.length - 3, resp.data.status_code.length) == '000') {
              // istatistik sonuçları dolduysa sonuç tamamlanmıştır.
              if (resp.data.model_list.length > 0) {
                this.d_taskStarted = false;
                this.d_mlTrainLoading = false;
                this.f_manageBackgroundService('ml_services', '', this.d_projectId, 'remove');
                this.d_mlServiceId = '';
                this.d_mlModelList = resp.data.model_list;
              } else {
                // bu durumda timer devam ediyor.
                this.d_timerControlResult.interval += 5000;
                if (this.d_timerControlResult.interval > this.d_timerControlResult.max) {
                  this.d_timerControlResult.interval = this.d_timerControlResult.max;
                }
                setTimeout(function () {
                  this.f_wanalyzerMlTrainByServiceId();
                }.bind(this), this.d_timerControlResult.interval);

              }
            } else {
              // hata alırsak istatistik modelini siliyoruz. Çünkü hata alındığında sürekli aynı hatayı vermeye devam eder.
              this.d_taskStarted = false;
              this.d_mlTrainLoading = false;
              this.f_manageBackgroundService('ml_services', '', this.d_projectId, 'remove');
              let txt = 'status_code = ' + resp.data.status_code + '\n';
              txt += 'status_message = ' + resp.data.status_message;
              alert(txt);
            }
          })
          .catch(err => {
            this.d_timerControlResult.interval += 5000;
            if (this.d_timerControlResult.interval > this.d_timerControlResult.max) {
              this.d_timerControlResult.interval = this.d_timerControlResult.max;
            }
            setTimeout(function () {
              this.f_wanalyzerMlTrainByServiceId();
            }.bind(this), this.d_timerControlResult.interval);
          });
      }
    },
    f_removeExcel: function () {
      this.d_excelFileCredit = 0;
      this.d_excelFile = null;
      this.d_excelFileBase64 = '';
      this.d_excelFileName = '';
      this.d_excelFileCreditEligible = false;
      this.d_approveCredit = '';
      this.$refs.excelFileInput.reset();
    },
    f_checkExcelFileCredit: function () {
      this.d_fileUploadLoading = true;
      let query = '';
      let data = {'excel_file': this.d_excelFileBase64, 'project_id': this.d_projectId};
      ServiceFunctions.excel_calculate_credit(query, data)
        .then(resp => {
          this.d_fileUploadLoading = false;
          if (resp.data.status_code.substring(resp.data.status_code.length - 3, resp.data.status_code.length) == '000') {
            this.d_excelFileCreditEligible = resp.data.eligible;
            if (!this.d_excelFileCreditEligible) {
              this.d_excelFileCredit = 0;
              this.d_excelFile = null;
              this.d_excelFileBase64 = '';
              this.d_excelFileName = '';
              this.d_approveCredit = '';
              this.$refs.excelFileInput.reset();
              // this.$bvToast.toast(this.StoreLangTranslation.data['not_enough_credit'][this.StoreLang], {
              //   title: this.StoreLangTranslation.data['invalid_file_type'][this.StoreLang],
              //   variant: 'danger',
              //   solid: true,
              // });
              alert(this.StoreLangTranslation.data[resp.data.eligible_message][this.StoreLang])
            } else {
              this.d_excelFileCredit = resp.data.excel_calculate_credit;
            }
          } else {
            let txt = 'status_code = ' + resp.data.status_code + '\n';
            txt += 'status_message = ' + resp.data.status_message;
            alert(txt);
          }
        });

    },
    f_handleFileUpload: function (event) {
      this.d_excelCorrection.correction_column_list = [];
      const file = event.target.files[0];
      if (file) {
        if (file.name.endsWith('.xls') || file.name.endsWith('.xlsx')) {
          const max_size_bytes = 50 * 1024 * 1024;
          if (file.size > max_size_bytes) {
            alert(this.StoreLangTranslation.data['file_size_is_not_eligible'][this.StoreLang] + ' (max 50mb)');
            this.d_excelFileCreditEligible = false;
            this.d_excelFile = null;
            this.d_excelFileBase64 = '';
            this.d_excelFileName = '';
            this.d_excelFileCredit = 0;
            this.d_approveCredit = '';
            this.$refs.excelFileInput.reset();
          } else {
            this.d_excelFileName = file.name;

            var vm = this;
            var reader = new FileReader();
            reader.addEventListener('load', function () {
              vm.d_excelFileBase64 = reader.result;
              vm.$forceUpdate();
              if (['wanalyzer_dataset_filter'].indexOf(vm.p_selectedProjectType) !== -1 && vm.p_datasetAdmin) {
                // vm.f_checkExcelFileCredit();
              } else {
                vm.f_checkExcelFileCredit();
              }
            }, false);
            reader.readAsDataURL(file);
          }

        } else {
          this.d_excelFileCreditEligible = false;
          this.d_excelFile = null;
          this.d_excelFileBase64 = '';
          this.d_excelFileName = '';
          this.d_excelFileCredit = 0;
          this.d_approveCredit = '';
          this.$refs.excelFileInput.reset();
          this.$bvToast.toast(this.StoreLangTranslation.data['upload_only_excel_file'][this.StoreLang], {
            title: this.StoreLangTranslation.data['invalid_file_type'][this.StoreLang],
            variant: 'danger',
            solid: true,
          });
        }

      } else {
        this.d_excelFileName = '';
      }
    },
    f_sumLastColumns: function (table) {
      let sum = 0;
      for (let row_index in table) {
        if (row_index != 0) {
          sum += table[row_index][table[row_index].length - 1]
        }
      }
      return sum;
    },
    f_copyAllTextClipboard: function () {
      // console.log('div_element_id: ', div_element_id);
      let new_text = '';
      for (let i in this.f_reportData.text_list) {
        let div_element_id = 'text_item_' + i;
        new_text += document.getElementById(div_element_id).innerText;
        new_text += '\n';
      }
      navigator.clipboard.writeText(new_text);
      alert(this.StoreLangTranslation.data['operation_completed'][this.StoreLang]);
    },
    f_getReportData: function (txt) {
      let local_data = JSON.parse(localStorage.getItem('analyze_report_data'));
      if (local_data) {
        this.f_reportData = local_data;
      }
    },
    f_addReportText: function (txt) {
      let local_data = JSON.parse(localStorage.getItem('analyze_report_data'));
      if (local_data) {
        this.f_reportData = local_data;
      } else {
        this.f_reportData = {
          'text_list': []
        }
      }
      let det = false;
      for (let i in this.f_reportData.text_list) {
        if (this.f_reportData.text_list[i].text === txt) {
          det = true;
          alert(this.StoreLangTranslation.data['already_added'][this.StoreLang]);
          break;
        }
      }
      if (!det) {
        this.f_reportData.text_list.push({'text': txt, 'type': 'general'});
      }
      localStorage.setItem('analyze_report_data', JSON.stringify(this.f_reportData));
    },
    f_deleteTextItem: function (txt_index) {
      let local_data = JSON.parse(localStorage.getItem('analyze_report_data'));
      if (local_data) {
        this.f_reportData = local_data;
        this.f_reportData.text_list.splice(txt_index, 1);
        localStorage.setItem('analyze_report_data', JSON.stringify(this.f_reportData));
        alert(this.StoreLangTranslation.data['operation_completed'][this.StoreLang]);
      }
    },
    f_selectLocation: function (location_index) {
      if (this.p_projectPermission.location_list[location_index].selected) {
        this.p_projectPermission.location_list[location_index].selected = 0;
        for (let server_index in this.p_projectPermission.location_list[location_index].server_list) {
          this.p_projectPermission.location_list[location_index].server_list[server_index].selected = 0;
        }
      } else {
        this.p_projectPermission.location_list[location_index].selected = 1;
        for (let server_index in this.p_projectPermission.location_list[location_index].server_list) {
          this.p_projectPermission.location_list[location_index].server_list[server_index].selected = 1;
        }
      }
      this.$forceUpdate();
    },
    f_selectServer: function (location_index, server_index) {
      if (this.p_projectPermission.location_list[location_index].server_list[server_index].selected) {
        this.p_projectPermission.location_list[location_index].server_list[server_index].selected = 0;
      } else {
        this.p_projectPermission.location_list[location_index].server_list[server_index].selected = 1;
      }
      this.$forceUpdate();
    },
    f_acceptMainRule: function () {
      let parenthesis_control = ClsRule.f_controlParanthesisDesign(this.d_mainRule.compile_str_array);
      // console.log('parenthesis_control : ', parenthesis_control);
      if (parenthesis_control) {
        if (this.d_mainRule.wra_settings.mode === 'param') {
          ClsRule.f_paramToQuery(this.d_mainRule.query_list, this.d_mainRule.compile_str_array, this.d_mainRule.wps_data);
        }
        this.p_projectPermission.main_rule_algorithm_set = {
          'query_list': this.d_mainRule.query_list,
          'compile_str_array': this.d_mainRule.compile_str_array,
          'compile_str_date': this.d_mainRule.compile_str_date,
          'compile_str_text': this.d_mainRule.compile_str_text
        };
        this.d_mainRuleShowModal = false;
      } else {
        alert(this.StoreLangTranslation.data['please_check_parenthesis'][this.StoreLang]);
      }
    },
    f_editMainRuleAlgorithm: function () {
      this.d_mainRule = JSON.parse(JSON.stringify(this.d_prepareRuleNew));
      for (let i in this.p_projectPermission.layer_list) {
        let wdm_name = this.p_projectPermission.layer_list[i]['layer']['name'][this.StoreLang];
        let wdm_key = this.p_projectPermission.layer_list[i]['layer']['value'];
        let new_wdm_item = {'type': wdm_key, 'value': wdm_key, 'label': wdm_name};
        this.d_mainRule.wdm_list.push(new_wdm_item);
      }
      if (this.p_projectPermission.main_rule_algorithm_set && this.p_projectPermission.main_rule_algorithm_set.query_list && this.p_projectPermission.main_rule_algorithm_set.query_list.length > 0) {
        this.d_mainRule.compile_str_array = JSON.parse(JSON.stringify(this.p_projectPermission.main_rule_algorithm_set.compile_str_array));
        this.d_mainRule.compile_str_date = JSON.parse(JSON.stringify(this.p_projectPermission.main_rule_algorithm_set.compile_str_date));
        this.d_mainRule.compile_str_text = JSON.parse(JSON.stringify(this.p_projectPermission.main_rule_algorithm_set.compile_str_text));
        this.d_mainRule.query_list = JSON.parse(JSON.stringify(this.p_projectPermission.main_rule_algorithm_set.query_list));
      }
      this.d_mainRuleShowModal = true;
    },
    f_layerTreeWdmGetOld: function (layer_tree_type, layer_list) {
      // Katman ağaçlarına ait wdm veri modelleri getiriliyor.
      // this.d_projectDataQueryLoading = true;
      // layer_list = [
      //   {
      //     "layer": {"name": {"en": "patient", "tr": "hasta"}, "value": "1"},
      //     "parameter_usage_type": {"name": {"en": "all", "tr": "hepsi"}, "value": "0"},
      //     "parameter_list": ""
      //   },
      //   {
      //     "layer": {"name": {"en": "patient / visit", "tr": "hasta / başvuru"}, "value": "2"},
      //     "parameter_usage_type": {"name": {"en": "all", "tr": "hepsi"}, "value": "0"},
      //     "parameter_list": ""
      //   },
      //   {
      //     "layer": {"name": {"en": "patient / visit / diagnosis", "tr": "hasta / başvuru / tanı"}, "value": "3"},
      //     "parameter_usage_type": {"name": {"en": "all", "tr": "hepsi"}, "value": "0"},
      //     "parameter_list": ""
      //   }
      // ],
      let query = '';
      let data = {'wdm_list': []};
      for (let i in layer_list) {
        let wdm_key = layer_list[i]['layer']['value'];
        data.wdm_list.push({'layer_tree_type': layer_tree_type, 'key': wdm_key});
      }
      ServiceFunctions.layer_tree_wdm_get(query, data)
        .then(resp => {
          if (resp.data.status_code.substring(resp.data.status_code.length - 3, resp.data.status_code.length) == '000') {
            if (resp.data.list) {
              localStorage.setItem('wdm_list', JSON.stringify(resp.data.list));
            }
          } else {
            let txt = 'status_code = ' + resp.data.status_code + '\n';
            txt += 'status_message = ' + resp.data.status_message;
            alert(txt);
            // this.d_projectDataQueryLoading = false;
          }
        });
    },
    f_layerTreeWdmGet: function (layer_tree_type, layer_list) {
      // Katman ağaçlarına ait wdm veri modelleri getiriliyor.
      // this.d_projectDataQueryLoading = true;
      // layer_list = [
      //   {
      //     "layer": {"name": {"en": "patient", "tr": "hasta"}, "value": "1"},
      //     "parameter_usage_type": {"name": {"en": "all", "tr": "hepsi"}, "value": "0"},
      //     "parameter_list": ""
      //   },
      //   {
      //     "layer": {"name": {"en": "patient / visit", "tr": "hasta / başvuru"}, "value": "2"},
      //     "parameter_usage_type": {"name": {"en": "all", "tr": "hepsi"}, "value": "0"},
      //     "parameter_list": ""
      //   },
      //   {
      //     "layer": {"name": {"en": "patient / visit / diagnosis", "tr": "hasta / başvuru / tanı"}, "value": "3"},
      //     "parameter_usage_type": {"name": {"en": "all", "tr": "hepsi"}, "value": "0"},
      //     "parameter_list": ""
      //   }
      // ],
      let query = '';
      let data = {'wdm_list': []};
      for (let i in layer_list) {
        let wdm_key = layer_list[i]['layer']['value'];
        data.wdm_list.push({'layer_tree_type': layer_tree_type, 'key': wdm_key});
      }
      ServiceFunctions.layer_tree_wdm_get(query, data)
        .then(resp => {
          if (resp.data.status_code.substring(resp.data.status_code.length - 3, resp.data.status_code.length) == '000') {
            if (resp.data.list) {
              let new_data_list = [];
              for (let i in resp.data.list) {
                let new_item = {
                  'id': i,
                  'data': resp.data.list[i]
                };
                new_data_list.push(new_item);
              }
              ClsIndexDb.f_setIndexDb('layer_tree', 'wdm_list', new_data_list);
              // localStorage.setItem('wdm_list', JSON.stringify(resp.data.list));
            }
          } else {
            let txt = 'status_code = ' + resp.data.status_code + '\n';
            txt += 'status_message = ' + resp.data.status_message;
            alert(txt);
            // this.d_projectDataQueryLoading = false;
          }
        });
    },
    f_createRuleAlgorithm: function (use_column_object) {
      let query_compile_str_array = ["("];
      let any_rule_columns_filled = false;
      let rule_data = {
        "query_list": [],
        "compile_str_array": [],
        "compile_str_text": [],
        "compile_str_date": []
      };
      for (let i in use_column_object.column_list) {
        if (['is_not_null'].indexOf(use_column_object.column_list[i].operation.value) !== -1) {
          let new_field_data = {
              "loc": [
                {"label": "Genel", "value": "general", "type": "group"},
                {"label": use_column_object.column_list[i].name, "value": use_column_object.column_list[i].index, "type": use_column_object.column_list[i].param_type}
              ],
              "using_data_if_not_reaching_record_data": "true",
              "val_list": [],
              "values": [],
              "significant": "true",
              "value_type": use_column_object.column_list[i].param_type,
              "operation": ""
          };
          let new_query_data = {
            "time_of_value": "any_value",
            "data_type": "old_recorded_data",
            "compile_str_array": ["(", 0, ")"],
            "fields": [],
            "compile_str": "",
            "significant": "true",
            "date": "1",
            "type": {"value": use_column_object.column_list[i].index, "label": use_column_object.column_list[i].name }
          };
          new_query_data.fields.push(new_field_data);
          rule_data.query_list.push(new_query_data);
          if (any_rule_columns_filled) {
            query_compile_str_array.push('and');
          }
          query_compile_str_array.push(rule_data.query_list.length - 1);
          any_rule_columns_filled = true;
        } else if (['is_null'].indexOf(use_column_object.column_list[i].operation.value) !== -1) {
          let new_field_data = {
              "loc": [
                {"label": "Genel", "value": "general", "type": "group"},
                {"label": use_column_object.column_list[i].name, "value": use_column_object.column_list[i].index, "type": use_column_object.column_list[i].param_type}
              ],
              "using_data_if_not_reaching_record_data": "true",
              "val_list": [],
              "values": [],
              "significant": "false",
              "value_type": use_column_object.column_list[i].param_type,
              "operation": ""
          };
          let new_query_data = {
            "time_of_value": "any_value",
            "data_type": "old_recorded_data",
            "compile_str_array": ["(", 0, ")"],
            "fields": [],
            "compile_str": "",
            "significant": "true",
            "date": "1",
            "type": {"value": use_column_object.column_list[i].index, "label": use_column_object.column_list[i].name }
          };
          new_query_data.fields.push(new_field_data);
          rule_data.query_list.push(new_query_data);
          if (any_rule_columns_filled) {
            query_compile_str_array.push('and');
          }
          query_compile_str_array.push(rule_data.query_list.length - 1);
          any_rule_columns_filled = true;
        } else {
          if (['select', 'radiogroup'].indexOf(use_column_object.column_list[i].param_type) !== -1) {
            if (['=', '<>'].indexOf(use_column_object.column_list[i].operation.value) !== -1) {
              if (use_column_object.column_list[i].selected_items && use_column_object.column_list[i].selected_items.length > 0) {
                let values_list = [];
                for (let op_index in use_column_object.column_list[i].selected_items) {
                  values_list.push(use_column_object.column_list[i].selected_items[op_index].value);
                }
                let new_field_data = {
                    "loc": [
                      {"label": "Genel", "value": "general", "type": "group"},
                      {"label": use_column_object.column_list[i].name, "value": use_column_object.column_list[i].index, "type": use_column_object.column_list[i].param_type}
                    ],
                    "using_data_if_not_reaching_record_data": "true",
                    "val_list": use_column_object.column_list[i].selected_items,
                    "values": values_list,                    
                    "significant": "true",
                    "value_type": use_column_object.column_list[i].param_type,
                    "operation": use_column_object.column_list[i].operation.value
                };
                let new_query_data = {
                  "time_of_value": "any_value",
                  "data_type": "old_recorded_data",
                  "compile_str_array": ["(", 0, ")"],
                  "fields": [],
                  "compile_str": "",
                  "significant": "true",
                  "date": "1",
                  "type": {"value": use_column_object.column_list[i].index, "label": use_column_object.column_list[i].name }
                };
                new_query_data.fields.push(new_field_data);
                rule_data.query_list.push(new_query_data);
                if (any_rule_columns_filled) {
                  query_compile_str_array.push('and');
                }
                query_compile_str_array.push(rule_data.query_list.length - 1);
                any_rule_columns_filled = true;
              }
            }
          } else {
            if (use_column_object.column_list[i].selected) {
              let values_list = [];
              values_list.push(use_column_object.column_list[i].selected);
              let new_field_data = {
                  "loc": [
                    {"label": "Genel", "value": "general", "type": "group"},
                    {"label": use_column_object.column_list[i].name, "value": use_column_object.column_list[i].index, "type": use_column_object.column_list[i].param_type}
                  ],
                  "using_data_if_not_reaching_record_data": "true",
                  "val_list": values_list,
                  "values": values_list,
                  "significant": "true",
                  "value_type": use_column_object.column_list[i].param_type,
                  "operation": use_column_object.column_list[i].operation.value
              };
              let new_query_data = {
                "time_of_value": "any_value",
                "data_type": "old_recorded_data",
                "compile_str_array": ["(", 0, ")"],
                "fields": [],
                "compile_str": "",
                "significant": "true",
                "date": "1",
                "type": {"value": use_column_object.column_list[i].index, "label": use_column_object.column_list[i].name }
              };
              new_query_data.fields.push(new_field_data);
              rule_data.query_list.push(new_query_data);
              if (any_rule_columns_filled) {
                query_compile_str_array.push('and');
              }
              query_compile_str_array.push(rule_data.query_list.length - 1);
              any_rule_columns_filled = true;
            }
          }
        }
      }
      if (any_rule_columns_filled) {
        query_compile_str_array.push(')');
        rule_data.compile_str_array = query_compile_str_array;
      }
      return rule_data;
    },
    f_wanalyzerProjectDatasetGet: function (table_type='') {
      this.d_datasetViewLoading = true;
      this.d_compareEligible = true;
      let query = 'project_id=' + this.d_projectId ;
      if (this.p_projectPermission && this.p_projectPermission.auth_data) {
        query += '&auth_client_id=' + this.p_projectPermission.auth_data.client_id;
      }

      let wai_columns = 'yes';
      if (['wanalyzer_create_query', 'wanalyzer_credit_count'].indexOf(this.p_selectedProjectType) !== -1) {
        // wanalyzer_create_query modunda tüm kolonlara yetkilidir.
        wai_columns = 'no';
      }
      let data = {
        'pagination': '',
        'filter_rule': {},
        'wai_columns': wai_columns
      };
      if (table_type === 'dataset_filter_table') {
        this.d_datasetWTableFilter = '';
        data.filter_rule = this.f_createRuleAlgorithm(this.d_project);
      } else if (table_type === 'dataset_table') {
        this.d_datasetWTable = '';
        data.filter_rule = {};
      }
      ServiceFunctions.wanalyzer_project_dataset_get(query, data)
        .then(resp => {
          this.d_datasetViewLoading = false;
          if (resp.data.status_code.substring(resp.data.status_code.length - 3, resp.data.status_code.length) == '000') {
            if (table_type === 'dataset_filter_table') {
              this.d_datasetWTableFilter = resp.data.wtable;
            } else if (table_type === 'dataset_table') {
              this.d_datasetWTable = resp.data.wtable;
            }
            // console.log(this.d_datasetWTable);
            if (['wanalyzer_dataset_filter', 'wanalyzer_create_query'].indexOf(this.p_selectedProjectType) !== -1) {
              // this.d_selectedTabItemId = 'dataset_view';
            }
            // this.f_datasetShowRefresh();
          } else {
            let txt = 'status_code = ' + resp.data.status_code + '\n';
            txt += 'status_message = ' + resp.data.status_message;
            alert(txt);
          }
        });
    },
    f_wanalyzerProjectColumnDataList: function () {
      this.d_columnListLoading = true;
      let query = 'project_id=' + this.d_projectId ;
      let data = {};
      ServiceFunctions.wanalyzer_project_column_data_list(query, data)
        .then(resp => {
          if (resp.data.status_code.substring(resp.data.status_code.length - 3, resp.data.status_code.length) == '000') {
            this.d_columnList = resp.data.list;
            // Kolon listesi kaydolduğunda dataset filter alanındaki kolonlarında güncellenmesini sağlıyoruz.
            this.f_wanalyzerProjectDetailsColumnsWaiGet();
          } else {
            this.d_columnListLoading = false;
            let txt = 'status_code = ' + resp.data.status_code + '\n';
            txt += 'status_message = ' + resp.data.status_message;
            alert(txt);
          }
        });
    },
    f_wanalyzerProjectDetailsColumnsWaiGet: function () {
      this.d_projectColumnListLoading = true;
      let query = 'project_id=' + this.d_projectId ;
      let column_type = 'wai';
      if (this.p_projectPermission && this.p_projectPermission.auth_data) {
        column_type = 'all';
        query += '&auth_client_id=' + this.p_projectPermission.auth_data.client_id;
      }
      query += '&column_type=' + column_type;
      let data = {};
      ServiceFunctions.wanalyzer_project_details_columns_wai_get(query, data)
        .then(resp => {
          this.d_columnListLoading = false;
          this.d_projectColumnListLoading = false;
          if (resp.data.status_code.substring(resp.data.status_code.length - 3, resp.data.status_code.length) == '000') {
            for (let i in resp.data.auth_detail_item) {
              this.p_projectPermission[i] = resp.data.auth_detail_item[i];
            }
            if (this.p_projectPermission && this.p_projectPermission.layer_tree_list_set && this.p_projectPermission.layer_tree_list_set.value) {
              this.f_layerTreeWdmGet(this.p_projectPermission.layer_tree_list_set.value, this.p_projectPermission.layer_list);
            }
            if (this.p_projectPermission) {
              this.d_backupProjectPermission = JSON.parse(JSON.stringify(this.p_projectPermission));
            }
            if (this.p_projectPermission && this.p_projectPermission.wanalyzer_project_scope) {
              this.d_selectScope = this.p_projectPermission.wanalyzer_project_scope;
              this.d_projectLocalScope = this.p_projectPermission.wanalyzer_project_scope;
            }
            this.$forceUpdate();
            this.d_project.details = resp.data.details;
            for (let i in resp.data.column_list) {
              if (!this.d_selectedColumn) {
               if (resp.data.column_list[i].wai_output) {
                this.d_selectedColumn = resp.data.column_list[i].id;
               } 
              }
              resp.data.column_list[i].operation = {
                'value': '=',
                'translation': {
                  'tr': 'eşittir',
                  'en': 'equal to'
                }
              };
              if (resp.data.column_list[i].param_type === 'select' || resp.data.column_list[i].param_type === 'radiogroup') {
                resp.data.column_list[i].selected_items = [];
              } else if (resp.data.column_list[i].param_type === 'integer' || resp.data.column_list[i].param_type === 'float') {
                resp.data.column_list[i].selected = '';
              }
            }
            this.d_project.column_list = resp.data.column_list;

            // this.d_project.column_list[0].compare_eligible = '0';
            // console.log(this.d_project.column_list);
            // if (this.d_selectedModeTab === 'graph_mode') {
            if (true) {
              let columns = {
                'wai_input': [],
                'wai_output': []
              };
              let all_columns = [];
              // console.log(resp.data.column_list)
              for (let i in this.d_project.column_list) {
                if (this.d_project.column_list[i].wai_output === 1) {
                  if (columns.wai_output.length == 0) {
                    this.d_project.column_list[i].use_as_stats = 'yes';
                    this.d_firstOutputIndex = parseInt(i);
                  }
                  columns.wai_output.push(i)
                } else if (this.d_project.column_list[i].wai_input === 1) {
                  if (!this.d_isThereInputColumn) {
                    this.d_isThereInputColumn = true;
                  }
                  if (columns.wai_input.length == 0) {
                    this.d_project.column_list[i].multi_dimension_order = '1';
                    this.d_project.column_list[i].use_as_stats = 'yes';
                    this.d_firstInputIndex = parseInt(i);
                  }
                  columns.wai_input.push(i)
                }
                all_columns.push(i)
              }
              if (this.d_selectedModeTab == 'detailed_mode') {
                this.d_orderedColumnIndexList = all_columns;
              } else {
                this.d_orderedColumnIndexList = [...columns.wai_input, ...columns.wai_output];
              }
              // this.d_project.column_list = [...columns.wai_input, ...columns.wai_output];
              // console.log(this.d_project.column_list)
              if (this.d_firstOutputIndex === '') {
                this.d_selectedModeTab == 'detailed_mode';
                // this.d_comparedStatistics = false;
                this.d_selectedStatisticsMethod = 'selected_variables_descriptive';
              } else if (this.d_firstOutputIndex !== '') {
                this.d_selectedModeTab == 'graph_mode';
                this.d_selectedStatisticsMethod = 'selected_variables_combinations_compare';
                // this.d_comparedStatistics = true;
              }
            } 
            // else {
            //   let indexes = [];
            //   for (let i in this.d_project.column_list) {
            //     indexes.push(i);
            //   }
            //   this.d_orderedColumnIndexList = indexes;
            // }
            this.d_resetProject = JSON.parse(JSON.stringify(this.d_project));
            if (this.d_autoLoading || this.d_selectedModeTab === 'graph_mode') {
              this.f_wanalyzerServicesTrigger();
            }
            this.f_controlAndCreateTimer();
          } else {
            let txt = 'status_code = ' + resp.data.status_code + '\n';
            txt += 'status_message = ' + resp.data.status_message;
            alert(txt);
          }
        });
    },
    f_wanalyzerDataQuery: function (process_type) {
      if (confirm(this.StoreLangTranslation.data[process_type][this.StoreLang]) + ' ? ') {
        this.d_projectDataQueryLoading = true;
        let query = 'project_id=' + this.d_projectId;
        query += '&process_type=' + process_type;
        let data = {};
        ServiceFunctions.wanalyzer_data_query(query, data)
          .then(resp => {
            if (resp.data.status_code.substring(resp.data.status_code.length - 3, resp.data.status_code.length) == '000') {
              // İlk proje güncelleme durumu takibini 10 saniye sonra tetikliyoruz. Çünkü direkt tetiklediğimizde, henüz durumu continuing olmamış oluyor.
              this.d_timerControlProjectUpdate.status = 'active';
              setTimeout(function () {
                this.f_wanalyzerProjectDetailsGet();
              }.bind(this), 10000)
            } else {
              let txt = 'status_code = ' + resp.data.status_code + '\n';
              txt += 'status_message = ' + resp.data.status_message;
              alert(txt);
              this.d_projectDataQueryLoading = false;
            }
          });
      }
    },
    f_wanalyzerProjectDetailsGet: function () {

      let query = 'project_id=' + this.d_projectId ;
      let column_type = 'wai';
      if (['wanalyzer_create_query'].indexOf(this.p_selectedProjectType) !== -1) {
        column_type = 'all';
      }
      query += '&column_type=' + column_type;
      let data = {};
      ServiceFunctions.wanalyzer_project_details_columns_wai_get(query, data)
        .then(resp => {
          if (resp.data.status_code.substring(resp.data.status_code.length - 3, resp.data.status_code.length) == '000') {
            this.d_project.details = resp.data.details;
            this.f_controlAndCreateTimer();
          } else {
            let txt = 'status_code = ' + resp.data.status_code + '\n';
            txt += 'status_message = ' + resp.data.status_message;
            alert(txt);
            this.d_projectDataQueryLoading = false;
          }
        });
    },
    f_controlAndCreateTimer: function () {
      // console.log('this.d_project.details  : ', this.d_project.details);
      // console.log('f_controlAndCreateTimer : ');
      let data_updating_status = '';
      try {
        data_updating_status = this.d_project.details.data_updating_status;
      } catch (err) {}
      // console.log('data_updating_status                                            : ', data_updating_status);
      // console.log('this.d_timerControlProjectUpdate.status                         : ', this.d_timerControlProjectUpdate.status);
      // console.log('this.d_timerControlProjectUpdate.interval                       : ', this.d_timerControlProjectUpdate.interval);
      // console.log('this.d_timerControlProjectUpdate.check_count_after_not_continue : ', this.d_timerControlProjectUpdate.check_count_after_not_continue);
      if (data_updating_status === 'continuing') {
        this.d_projectDataQueryLoading = true;
        this.d_timerControlProjectUpdate.status = 'active';
        this.d_timerControlProjectUpdate.interval += 5000;
        if (this.d_timerControlProjectUpdate.interval > this.d_timerControlProjectUpdate.max) {
          this.d_timerControlProjectUpdate.interval = this.d_timerControlProjectUpdate.max;
          // maksimum intervale ulaşınca bu döngüde artık dataseti her timer döngüsü tamamlandığında getiriyoruz.
          this.f_wanalyzerProjectDatasetGet('dataset_table');
        }
        setTimeout(function () {
          this.f_wanalyzerProjectDetailsGet();
        }.bind(this), this.d_timerControlProjectUpdate.interval)

      } else {
        if (this.d_timerControlProjectUpdate.status === 'active') {
          if (this.d_timerControlProjectUpdate.check_count_after_not_continue >= 2) {
            this.d_timerControlProjectUpdate.timer = 0;
            this.d_timerControlProjectUpdate.interval = 0;
            this.d_timerControlProjectUpdate.check_count_after_not_continue = 0;
            this.d_timerControlProjectUpdate.status = 'passive';
            // window.clearInterval(this.d_timerControlProjectUpdate.timer);
            this.f_wanalyzerProjectDatasetGet('dataset_table');
            this.f_wanalyzerServicesTrigger();
            this.d_projectDataQueryLoading = false;
          } else {
            this.d_timerControlProjectUpdate.check_count_after_not_continue += 1;
            // 5 saniye sonra yeniden projeyi kontrol ediyoruz.
            setTimeout(function () {
              this.f_wanalyzerProjectDetailsGet();
            }.bind(this), 5000)
          }
        }
      }
    },
    f_projectSaveEligibleCheck: function () {
      let disable_status = false;
      // console.log('this.p_projectPermission.wanalyzer_project_name : ', this.p_projectPermission.wanalyzer_project_name);
      // console.log('this.p_projectPermission.case_limit_count_set   : ', this.p_projectPermission.case_limit_count_set);
      // console.log('this.p_projectPermission.case_limit_count       : ', this.p_projectPermission.case_limit_count);

      if (this.p_projectPermission && !this.p_projectPermission.wanalyzer_project_name) {
        // console.log('1');
        disable_status = true;
      }
      if (['wanalyzer_create_query'].indexOf(this.p_selectedProjectType) !== -1) {
        if (!disable_status) {
          if (this.p_projectPermission.case_limit_count_set && this.p_projectPermission.case_limit_count) {
            if (parseInt(this.p_projectPermission.case_limit_count_set) > parseInt(this.p_projectPermission.case_limit_count)) {
              // console.log('2');
              disable_status = true;
            }
          }
        }

        // Ana kural sorgusu oluşturmak zorunlu. Çünkü filtresiz veri çekimine izin verilmemesi gerekiyor.
        if (!disable_status) {
          let query_list = [];
          try {
            query_list = this.p_projectPermission.main_rule_algorithm_set.query_list;
          } catch(err){}
          if (!query_list) {
            disable_status = true;
          } else {
            if (query_list.length === 0) {
              disable_status = true;
            }
          }
        }

        if (!disable_status) {
          let location_list = JSON.parse(JSON.stringify(this.p_projectPermission.location_list))
          let new_location_list = [];
          for (let i in location_list) {
            if (location_list[i].selected) {
              let new_loc = {
                'label': location_list[i]['name'][this.StoreLang],
                'value': location_list[i]['value'],
                'server_list': []
              }
              if (location_list[i].server_list && location_list[i].server_list.length > 0) {
                for (let server_index in location_list[i].server_list) {
                  if (location_list[i].server_list[server_index].selected) {
                    let new_server_item = {
                      'value': location_list[i].server_list[server_index].value,
                      'label': location_list[i].server_list[server_index].name[this.StoreLang],
                    }
                    new_loc.server_list.push(new_server_item);
                  }
                }
              }
              // console.log('new_loc.server_list: ', new_loc.server_list);
              // sunucu seçimi zorunlu hale getirildi.
              if (new_loc.server_list.length > 0) {
                new_location_list.push(new_loc);
              }
            }
          }
          if (new_location_list.length === 0) {
            disable_status = true;
          }
        }

      } else if (['wanalyzer_credit_count'].indexOf(this.p_selectedProjectType) !== -1) {
        if (this.d_projectId) {
          disable_status = false;
        } else if (!this.d_excelFileCreditEligible) {
          disable_status = true;
        }
        if ((this.d_excelFileCreditEligible && !this.d_approveCredit) || this.d_fileUploadLoading) {
          disable_status = true;
        }
      } else if (['wanalyzer_dataset_filter'].indexOf(this.p_selectedProjectType) !== -1 && this.p_datasetAdmin) {
        if (this.d_projectId) {
          disable_status = false;
        }
        if (this.d_fileUploadLoading || !this.d_project.details.name) {
          disable_status = true;
        } 
      }

      // console.log('disable_status ', disable_status);
      return disable_status;
    },
    f_wanalyzerColumnSave: function () {
      let query = 'project_id=' + this.p_projectPermission.wanalyzer_project_id;
      let data = {
        'column_list': this.d_columnList,
      };
      // console.log('this.d_columnList ', this.d_columnList);
      ServiceFunctions.wanalyzer_project_column_save(query, data)
        .then(resp => {
          if (resp.data.status_code.substring(resp.data.status_code.length - 3, resp.data.status_code.length) == '000') {
            //
          } else {
            let txt = 'status_code = ' + resp.data.status_code + '\n';
            txt += 'status_message = ' + resp.data.status_message;
            alert(txt);
          }
        });
    },
    f_wanalyzerProjectSave: function (call_from) {
      if (['wanalyzer_credit_count'].indexOf(this.p_selectedProjectType) !== -1) {
        this.d_projectSaveLoading = true;
        let new_project = false;
        let query = '';
        if (this.d_projectId) {
          query += 'project_id=' + this.d_projectId;
          if (this.p_projectPermission.auth_data && this.p_projectPermission.auth_data.client_id) {
            query += '&user_auth_client_id=' + this.p_projectPermission.auth_data.client_id;
          }
        } else {
          new_project = true;
          if (this.p_projectPermission.auth_data && this.p_projectPermission.auth_data.client_id) {
            query += 'user_auth_client_id=' + this.p_projectPermission.auth_data.client_id;
          }
        }
        this.p_projectPermission.wanalyzer_project_scope = this.d_projectLocalScope
        let data = {
          'project_name': this.p_projectPermission.wanalyzer_project_name,
          'scope': this.p_projectPermission.wanalyzer_project_scope,
        };
        if (this.d_excelFileCreditEligible) {
          if (query) {
            query += '&';
          }
          query += 'column_design=' + this.d_excelCorrection.column_design;
          query += '&column_type=' + this.d_excelCorrection.column_type;
          query += '&dataset_type=' + this.d_excelCorrection.dataset_type;
          data['excel_file'] = this.d_excelFileBase64;
          data['correction_column_list'] = this.d_excelCorrection.correction_column_list;
        }
        ServiceFunctions.wanalyzer_project_save(query, data)
          .then(resp => {
            this.d_projectSaveLoading = false;
            if (resp.data.status_code.substring(resp.data.status_code.length - 3, resp.data.status_code.length) == '000') {
              // if (this.f_getUserAuthorizationList) {
              //   this.f_getUserAuthorizationList();
              // }

              // if (this.f_getThisUserAuth) {
              //   let usr_project_auth_cl_id = this.d_user.username + '_' + this.p_projectPermission.wanalyzer_project_id + '_edit';
              //   let usr_credit_auth_cl_id = this.d_user.username + '_wanalyzer_credit_count';
              //   this.f_getThisUserAuth([usr_project_auth_cl_id, usr_credit_auth_cl_id]);
              // }
              if (resp.data.user_credit_auth_data) {
                this.p_creditAuthData.auth_data = resp.data.user_credit_auth_data;
              }
              if (resp.data.user_auth_data) {
                this.p_projectPermission.auth_data = resp.data.user_auth_data;

              }
              if (resp.data.project_id && !this.d_projectId) {
                if (!this.p_projectPermission.wanalyzer_project_id) {
                  this.p_projectPermission.name.en = resp.data.user_auth_data.data['0']['34']['val'];
                  this.p_projectPermission.name.tr = resp.data.user_auth_data.data['0']['34']['val'];
                  this.p_projectPermission.wanalyzer_project_name = resp.data.user_auth_data.data['0']['34']['val'];
                  this.p_projectPermission.wanalyzer_project_create_date = resp.data.user_auth_data.created_at;
                }
                // if (this.f_getUserAuthorizationList) {
                //   this.f_getUserAuthorizationList();
                // }
                this.p_projectPermission.wanalyzer_project_id = resp.data.project_id;
                let new_query = {
                  'path': this.$route.path,
                  'query': {
                    'project_id': this.p_projectPermission.wanalyzer_project_id,
                    'project_type': this.p_selectedProjectType
                  }
                };
                this.$router.push(new_query);
                this.d_projectId = this.p_projectPermission.wanalyzer_project_id;
              }
              this.f_wanalyzerProjectDetailsColumnsWaiGet();
              this.f_wanalyzerProjectColumnDataList();
              this.f_wanalyzerProjectDatasetGet('dataset_table');
              this.p_projectList['wanalyzer_credit_count'][this.p_selectedProjectIndex] = this.p_projectPermission;
              if (this.p_projectPermission.wanalyzer_project_scope) {
                this.d_selectScope = this.p_projectPermission.wanalyzer_project_scope;
              }
              this.f_getScopes();
              // ilk yükleme sırasındaki analizi ekrana yansıtıyoruz. Daha sonraki leri yansıtmıyoruz. Daha sonrakiler değişmiş kolon adlarıyla geliyor. Dolayısıyla excel ile kolon adı arasındaki eşleştirmenin kaybolmaması için ilk correction_column_list seçilmesi ve sürekli bunun üzerinden güncelleme yapılması gerekiyor. Fakat daha sonra ekranda değişimlerin de ayrıca görüntülenmesi istenirse yeni gelen correction column list gösterilecek bir kurgu yapılabilir.
              if (this.d_excelCorrection.correction_column_list.length === 0 && resp.data.excel_response && resp.data.excel_response.result && resp.data.excel_response.result.correction_column_list) {
                this.d_excelCorrection.correction_column_list = resp.data.excel_response.result.correction_column_list;
              }
              if (call_from === 'modal' && resp.data.excel_response && resp.data.excel_response.result && resp.data.excel_response.result.correction_column_list) {
                this.d_excelCorrection.show = false;
              } else {
                this.d_excelCorrection.show = true;
              }
              // if (new_project) {
              //   this.d_selectedTab = 'column_list';
              //   alert(this.StoreLangTranslation.data['process_completed_and_column_page'][this.StoreLang])
              // } else {
              //   alert(this.StoreLangTranslation.data['process_completed'][this.StoreLang])
              // }
              // this.d_excelFileCreditEligible = false;
              // this.d_excelFile = null;
              // this.d_excelFileBase64 = '';
              // this.d_excelFileName = '';
              // this.d_excelFileCredit = 0;
              // this.d_approveCredit = '';
              // this.$refs.excelFileInput.reset();
               
            } else {
              let txt = 'status_code = ' + resp.data.status_code + '\n';
              txt += 'status_message = ' + resp.data.status_message;
              alert(txt);
            }
          });
        
      } else if (['wanalyzer_dataset_filter'].indexOf(this.p_selectedProjectType) !== -1 && this.p_datasetAdmin) {
        this.d_projectSaveLoading = true;
        let query = '';
        if (this.d_projectId) {
          query += 'project_id=' + this.d_projectId;
          
        } 
        // this.p_projectPermission.wanalyzer_project_scope = this.d_projectLocalScope
        let data = {
          'project_name': this.d_project.details.name,
          'scope': '',
          'wai_columns': 'yes',
          // 'project_name': this.p_projectPermission.wanalyzer_project_name,
          // 'scope': this.p_projectPermission.wanalyzer_project_scope,
        };
        if (query) {
          query += '&';
        }
        query += 'column_design=' + this.d_excelCorrection.column_design;
        query += '&column_type=' + this.d_excelCorrection.column_type;
        query += '&dataset_type=' + this.d_excelCorrection.dataset_type;
        data['excel_file'] = this.d_excelFileBase64;
        data['correction_column_list'] = this.d_excelCorrection.correction_column_list;
        ServiceFunctions.wanalyzer_project_save(query, data)
          .then(resp => {
            this.d_projectSaveLoading = false;
            if (resp.data.status_code.substring(resp.data.status_code.length - 3, resp.data.status_code.length) == '000') {
              // if (this.p_datasetAdmin && this.f_getDatasetProjects) {
              //   this.f_getDatasetProjects();
              // }
              if (resp.data.project_id && !this.d_projectId) {
                
                // this.p_projectPermission.wanalyzer_project_id = resp.data.project_id;
                this.d_projectId = resp.data.project_id;
                let new_query = {
                  'path': this.$route.path,
                  'query': {
                    // 'project_id': this.p_projectPermission.wanalyzer_project_id,
                    'project_id': this.d_projectId,
                    'project_type': this.p_selectedProjectType
                  }
                };
                this.$router.push(new_query);
                // this.d_projectId = this.p_projectPermission.wanalyzer_project_id;
              }
              this.f_wanalyzerProjectDetailsColumnsWaiGet();
              this.f_wanalyzerProjectColumnDataList();
              this.f_wanalyzerProjectDatasetGet('dataset_table');
              this.p_datasetList['wanalyzer_dataset_filter'][this.p_selectedProjectIndex] = this.p_projectPermission;
              // this.p_projectList['wanalyzer_credit_count'][this.p_selectedProjectIndex] = this.p_projectPermission;
              // if (this.p_projectPermission.wanalyzer_project_scope) {
              //   this.d_selectScope = this.p_projectPermission.wanalyzer_project_scope;
              // }
              // this.f_getScopes();
              
              if (this.d_excelCorrection.correction_column_list.length === 0 && resp.data.excel_response && resp.data.excel_response.result && resp.data.excel_response.result.correction_column_list) {
                this.d_excelCorrection.correction_column_list = resp.data.excel_response.result.correction_column_list;
              }
              if (call_from === 'modal' && resp.data.excel_response && resp.data.excel_response.result && resp.data.excel_response.result.correction_column_list) {
                this.d_excelCorrection.show = false;
              } else {
                this.d_excelCorrection.show = true;
              }
               
            } else {
              let txt = 'status_code = ' + resp.data.status_code + '\n';
              txt += 'status_message = ' + resp.data.status_message;
              alert(txt);
            }
          });
        
      } else {
        // aşağıda ana katmanın değiştirilme durumu kontrol ediliyor.
        // ana katman değiştirildiğinde, kolon verileri içindeki ana katman key de değiştirilerek kaydediliyor.
        if (this.d_backupProjectPermission.main_layer && this.p_projectPermission.wanalyzer_project_id) {
          if (this.d_backupProjectPermission.main_layer !== this.p_projectPermission.main_layer) {
            if (this.d_columnList.length > 0) {
              for (let col_index in this.d_columnList) {
                if (this.d_columnList[col_index].type === 'wdm') {
                  if (this.d_columnList[col_index].layer_rules) {
                    let col_layer_key = Object.keys(this.d_columnList[col_index].layer_rules)[0];
                    this.d_columnList[col_index].layer_rules[this.p_projectPermission.main_layer] = JSON.parse(JSON.stringify(this.d_columnList[col_index].layer_rules[col_layer_key]))
                    this.$delete(this.d_columnList[col_index].layer_rules, col_layer_key);
                  }
                }
              }
              this.f_wanalyzerColumnSave();
            }
          }
        }
        let case_limit_warning_type = '';
        // maksimum satır limiti kontrolü yapılıyor.
        if (this.p_projectPermission.case_limit_count_set && this.p_projectPermission.case_limit_count) {
          if (this.p_projectPermission.case_limit_count_set > this.p_projectPermission.case_limit_count) {
            case_limit_warning_type = 'case_limit_max_value';
          }
        } else {
          this.p_projectPermission.case_limit_count_set = this.p_projectPermission.case_limit_count;
        }
        if (case_limit_warning_type) {
          alert(this.StoreLangTranslation.data[case_limit_warning_type][this.StoreLang]);
        } else {
          this.d_projectSaveLoading = true;
          let query = '';
          if (this.d_projectId) {
            query += 'project_id=' + this.d_projectId;
            if (this.p_projectPermission.auth_data && this.p_projectPermission.auth_data.client_id) {
              query += '&user_auth_client_id=' + this.p_projectPermission.auth_data.client_id;
            }
          } else {
            if (this.p_projectPermission.auth_data && this.p_projectPermission.auth_data.client_id) {
              query += 'user_auth_client_id=' + this.p_projectPermission.auth_data.client_id;
            }
          }
          let location_list = JSON.parse(JSON.stringify(this.p_projectPermission.location_list))
          let new_location_list = [];
          for (let i in location_list) {
            if (location_list[i].selected) {
              let new_loc = {
                'label': location_list[i]['name'][this.StoreLang],
                'value': location_list[i]['value'],
                'server_list': []
              }
              if (location_list[i].server_list && location_list[i].server_list.length > 0) {
                for (let server_index in location_list[i].server_list) {
                  if (location_list[i].server_list[server_index].selected) {
                    let new_server_item = {
                      'value': location_list[i].server_list[server_index].value,
                      'label': location_list[i].server_list[server_index].name[this.StoreLang],
                    }
                    new_loc.server_list.push(new_server_item);
                  }
                }
              }
              new_location_list.push(new_loc);
            }
          }

          // let use_main_rule = JSON.parse(JSON.stringify());
          // console.log('this.p_projectPermission.main_rule_algorithm : ', this.p_projectPermission.main_rule_algorithm);
          // if (this.p_projectPermission.main_rule_algorithm && this.p_projectPermission.main_rule_algorithm.query_list.length > 0) {
          //   use_main_rule.compile_str_array.push('and');
          //   for (let q_index in this.p_projectPermission.main_rule_algorithm.query_list) {
          //     let q_data = this.p_projectPermission.main_rule_algorithm.query_list[q_index];
          //     use_main_rule.query_list.push(q_data);
          //   }
          //   for (let compile_index in this.p_projectPermission.main_rule_algorithm.compile_str_array) {
          //     if (typeof this.p_projectPermission.main_rule_algorithm.compile_str_array[compile_index] === 'number') {
          //       let compile_use = parseInt(this.p_projectPermission.main_rule_algorithm.compile_str_array[compile_index]);
          //       let calculated_query_compile_index = compile_use + this.p_projectPermission.main_rule_algorithm_set.query_list.length;
          //       use_main_rule.compile_str_array.push(calculated_query_compile_index);
          //     } else {
          //       use_main_rule.compile_str_array.push(this.p_projectPermission.main_rule_algorithm.compile_str_array[compile_index]);
          //     }
          //   }
          // }

          // console.log('use_main_rule ', use_main_rule);
          this.p_projectPermission.wanalyzer_project_scope = this.d_projectLocalScope
          let data = {
            'project_name': this.p_projectPermission.wanalyzer_project_name,
            'scope': this.p_projectPermission.wanalyzer_project_scope,
            'case_limit_count_set': this.p_projectPermission.case_limit_count_set,
            'location_list': new_location_list,
            'main_rule_algorithm': this.p_projectPermission.main_rule_algorithm_set,
          };
          if (this.p_projectPermission.main_layer) {
            for (let i in this.p_projectPermission.layer_list) {
              if (this.p_projectPermission.layer_list[i].layer.value === this.p_projectPermission.main_layer) {
                data.main_layer = {
                  'value': this.p_projectPermission.main_layer,
                  'label': this.p_projectPermission.layer_list[i].layer.name[this.StoreLang]
                };
                break
              }
            }
          }
          if (this.p_projectPermission.layer_tree_list_set) {
            data.layer_tree = {
              'value': this.p_projectPermission.layer_tree_list_set.value,
              'label': this.p_projectPermission.layer_tree_list_set.name[this.StoreLang]
            };
          }
          ServiceFunctions.wanalyzer_project_save(query, data)
            .then(resp => {
              this.d_projectSaveLoading = false;
              if (resp.data.status_code.substring(resp.data.status_code.length - 3, resp.data.status_code.length) == '000') {
                if (resp.data.project_id && !this.d_projectId) {
                  if (this.f_getUserAuthorizationList) {
                    this.f_getUserAuthorizationList();
                  }
                  // if (this.f_getThisUserAuth) {
                  //   this.f_getThisUserAuth();
                  // }
                  this.p_projectPermission.wanalyzer_project_id = resp.data.project_id;
                  let new_query = {
                    'path': this.$route.path,
                    'query': {
                      'project_id': this.p_projectPermission.wanalyzer_project_id,
                      'project_type': this.p_selectedProjectType
                    }
                  };
                  this.$router.push(new_query);
                  this.d_projectId = this.p_projectPermission.wanalyzer_project_id;
                  this.f_wanalyzerProjectDetailsColumnsWaiGet();
                  this.f_wanalyzerProjectColumnDataList();
                }
                this.p_projectList['wanalyzer_create_query'][this.p_selectedProjectIndex] = this.p_projectPermission;
                if (this.p_projectPermission.wanalyzer_project_scope) {
                  this.d_selectScope = this.p_projectPermission.wanalyzer_project_scope;
                }
                this.f_getScopes();
              } else {
                let txt = 'status_code = ' + resp.data.status_code + '\n';
                txt += 'status_message = ' + resp.data.status_message;
                alert(txt);
              }
            });
        }
      }
    },
    f_deleteSelectedItem: function (col_index, selected_item_ind) {
      this.d_project.column_list[col_index].selected_items.splice(selected_item_ind, 1);
      this.$forceUpdate();
      if (this.d_autoLoading || this.d_selectedModeTab === 'graph_mode') {
        this.f_wanalyzerServicesTrigger();
      }
    },
    f_wanalyzerServicesTrigger: function () {
      this.f_wanalyzerProjectStatisticsAnalyzeList();
      if (['wanalyzer_dataset_filter', 'wanalyzer_create_query'].indexOf(this.p_selectedProjectType) !== -1) {
        this.f_wanalyzerProjectDatasetGet('dataset_filter_table');
      }
    },
    f_selectOperationForColumn: function (col_index, operation) {
      this.d_project.column_list[col_index].operation = operation;
      // null yönetiminde değerlerin seçili olması gerekmiyor.
      if (['is_null', 'is_not_null'].indexOf(operation.value) !== -1) {
        if (this.d_project.column_list[col_index].selected_items && this.d_project.column_list[col_index].selected_items.length > 0) {
          this.d_project.column_list[col_index].selected_items = [];
        }
        if (this.d_project.column_list[col_index].selected) {
          this.d_project.column_list[col_index].selected = '';
        }
      }
      this.$forceUpdate();
      if (this.d_autoLoading || this.d_selectedModeTab === 'graph_mode') {
        this.f_wanalyzerServicesTrigger();
      }
    },
    f_resetProjectData: function () {
      this.d_project = JSON.parse(JSON.stringify(this.d_resetProject));
      this.$forceUpdate();
      if (this.d_autoLoading) {
        this.f_wanalyzerServicesTrigger();
      }
    },
    f_statsShowRefresh: function () {
      this.d_statsShow = false;
      setTimeout(function () {
        this.d_statsShow = true;
        this.$forceUpdate();
      }.bind(this), 1);
    },
    f_datasetShowRefresh: function () {
      this.d_datasetShow = false;
      setTimeout(function () {
        this.d_datasetShow = true;
        this.$forceUpdate();
      }.bind(this), 1);
    },
    f_addToColumnSelectedItems: function (rule_type, col_ind, opt) {
      if (opt) {
        if (!this.d_project.column_list[col_ind].selected_items) {
          this.d_project.column_list[col_ind].selected_items = [];
        }
        let det = false;
        for (let i in this.d_project.column_list[col_ind].selected_items) {
          if (this.d_project.column_list[col_ind].selected_items[i].value === opt.value) {
            det = true;
            break;
          }
        }
        if (!det) {
          this.d_project.column_list[col_ind].selected_items.push(opt);
        }
      } else {
        this.d_project.column_list[col_ind].selected_items.splice(0, this.d_project.column_list[col_ind].selected_items.length);
      }
      if (this.d_autoLoading || this.d_selectedModeTab === 'graph_mode') {
        this.f_wanalyzerServicesTrigger();
      }
    },
    f_wanalyzerProjectStatsResultList: function () {
      this.d_statsList.analyze_list = [];
      let query = 'project_id=' + this.d_projectId ;
      query += '&stats_id=' + this.d_statsId ;
      let data = {
        'selected_columns': this.d_filterData.selected_columns,
        'selected_stats': this.d_filterData.selected_stats,
        'selected_p_value': this.d_filterData.selected_p_value,
        'selected_analyze_types': this.d_filterData.selected_analyze_types,
        'user_score_list': this.d_filterData.user_score_list,
        'pagination': this.d_filterData.pagination,
      };
      ServiceFunctions.wanalyzer_project_stats_result_list(query, data)
        .then(resp => {
          if (resp.data.status_code.substring(resp.data.status_code.length - 3, resp.data.status_code.length) == '000') {
            this.d_statsList.analyze_list = resp.data.analyze_list;
            this.d_statsList.all_count = resp.data.all_count;
            this.d_statsList.filter_stats = resp.data.filter_stats;
            this.d_statsList.filter_analyze_types = resp.data.filter_analyze_types;
            this.d_statsList.selected_columns = resp.data.selected_columns;
            this.d_statsList.stats_name = resp.data.stats_name;
            this.d_statsList.stats_info = resp.data.stats_info;
            this.d_statsList.last_update_time_of_project_cases = resp.data.last_update_time_of_project_cases;
            this.d_filterData.pagination.all_count = resp.data.all_count;
          } else {
            let txt = 'status_code = ' + resp.data.status_code + '\n';
            txt += 'status_message = ' + resp.data.status_message;
            alert(txt);
          }
        });
    },
    f_calculateChartWidth: function (chart) {
      if (chart.labels) {
        if (chart.labels.length > 5 && chart.labels.length <= 10) {
          return 800;
        } else if (chart.labels.length > 10) {
          return 1000;
        } else {
          return 500;
        }
      } else {
        return 500;
      }
    },
    f_showChartData: function (chart_data) {
      let new_chart_data = {
        backgroundColor: "#fff",
        labels: chart_data.labels ? chart_data.labels : [],
        datasets: []
      };
      for (let d in chart_data.datasets) {
        let new_dataset = {}
        if (chart_data.datasets[d].label !== undefined) {
          new_dataset.label = chart_data.datasets[d].label;
        }
        if (chart_data.datasets[d].lineTension !== undefined) {
          new_dataset.lineTension = chart_data.datasets[d].lineTension;
        }
        if (chart_data.datasets[d].borderColor !== undefined) {
          new_dataset.borderColor = chart_data.datasets[d].borderColor;
        }
        if (chart_data.datasets[d].backgroundColor !== undefined) {
          new_dataset.backgroundColor = chart_data.datasets[d].backgroundColor;
        }
        if (chart_data.datasets[d].showLine !== undefined) {
          new_dataset.showLine = chart_data.datasets[d].showLine;
        }
        if (chart_data.datasets[d].data !== undefined) {
          new_dataset.data = chart_data.datasets[d].data;
        }
        new_chart_data.datasets.push(new_dataset);
      }
      this.chart_data = JSON.parse(JSON.stringify(new_chart_data));
      this.d_resetChartData = JSON.parse(JSON.stringify(this.chart_data));
      this.d_chartSize.chart_type = chart_data.type;
      this.d_chartSize.x_mode = 'standart';
      this.d_chartSize.y_mode = 'standart';
      this.d_chartSize.x_interval_type = 'all';
      this.d_chartSize.height = window.innerHeight - 200;
      this.d_chartSize.width = window.innerWidth - 100;
      this.d_showGraphicView = true;
    },
    f_calculateChartHeight: function (chart) {
      if (chart.labels) {
        if (chart.labels.length > 5 && chart.labels.length <= 10) {
          return 400;
        } else if (chart.labels.length > 10) {
          return 500;
        } else {
          return 250;
        }
      } else {
        return 250;
      }
    },
    f_calculateChartStyle: function (chart) {
      let style = '';
      if (chart.labels) {
        if (chart.labels.length > 5 && chart.labels.length <= 10) {
          if (chart.datasets.length > 5 && chart.datasets.length <= 10) {
            return 'position: relative; height:600px; width:1200px;';
          } else if (chart.datasets.length > 10) {
            return 'position: relative; height:800px; width:1600px;';
          } else {
            return 'position: relative; height:400px; width:800px;';
          }
        } else if (chart.labels.length > 10) {
          if (chart.datasets.length > 5 && chart.datasets.length <= 10) {
            return 'position: relative; height:700px; width:1400px;';
          } else if (chart.datasets.length > 10) {
            return 'position: relative; height:900px; width:1800px;';
          } else {
            return 'position: relative; height:500px; width:1000px;';
          }
        } else {
          if (chart.datasets.length > 5 && chart.datasets.length <= 10) {
            return 'position: relative; height:450px; width:900px;';
          } else if (chart.datasets.length > 10) {
            return 'position: relative; height:650px; width:1300px;';
          } else {
            return 'position: relative; height:250px; width:500px;';
          }
        }
      } else {
        return 'position: relative; height:250px; width:500px;';
      }
    },
    f_calculateTableTdStyle: function (r_index, c_index) {
      let style = 'min-width: 100px; text-align: center; border: solid 1px #c3d8d8; font-size: 12px;';
      if (r_index === 0 || c_index === 0) {
        style += ' font-weight: bold; font-size: 10px;';
      }
      /*
        if (r_index === 0) {
          style += 'position: sticky; z-index: 1000; top: 0; background-color: #00bcd4;';
        }
        if (c_index === 0) {
          style += 'position: sticky; left: 0;';
        }
      */
      return style;
    },
    f_tableShow: function () {
      this.d_tableShow = false;
      setTimeout(function () {
        this.d_tableShow = true;
        this.$forceUpdate();
      }.bind(this), 1000);
    },
    f_calculateTableStyle: function () {
      let style = '';
      if (this.d_fullScreen) {
        style = 'overflow-x: auto;';
      } else {
        style = 'overflow-x: auto;';
      }
      return style;
    },
    f_searchCrossRows: function (row, row_index, rows_length) {
      // if (this.d_searchTextRow && row_index !== 0 && row_index !== rows_length - 1) {
      if (this.d_searchTextRow && row_index !== 0) {
        let text_list = this.d_searchTextRow.split(',');
        for (let i in text_list) {
          text_list[i] = text_list[i].replace(/ /g, "");
        }
        for (let t in text_list) {
          if (text_list[t]) {
            if (row[0].toLocaleLowerCase().indexOf(text_list[t].toLocaleLowerCase()) !== -1) {
              return true;
            }
          }
        }
      } else {
        if (row_index >= this.d_tablePagination.start && row_index <= this.d_tablePagination.end) {
          return true;
        }
      }
      return false;
    },
    f_searchCrossColumns: function (col_index, first_row, col_length) {
      // if (this.d_searchTextColumn && col_index !== 0 && col_index !== col_length - 1) {
      if (this.d_searchTextColumn && col_index !== 0) {
        let text_list = this.d_searchTextColumn.split(',');
        for (let i in text_list) {
          text_list[i] = text_list[i].replace(/ /g, "");
        }
        for (let t in text_list) {
          if (text_list[t]) {
            if (first_row[col_index].toLocaleLowerCase().indexOf(text_list[t].toLocaleLowerCase()) !== -1) {
              return true;
            }
          }
        }
        return false;
      } else {
        return true;
      }
    },
    f_dateFormat: function (date, date_type='year-month-day') {
      if (date) {
        if (date_type === 'year-month-day') {
          if (this.StoreLang === 'tr') {
            let x = moment(date, "YYYY-MM-DD hh:mm:ss").format("DD/MM/YYYY");
            return x;
          } else {
            let x = moment(date, "YYYY-MM-DD hh:mm:ss").format("YYYY/MM/DD");
            return x;
          }
        } else if (date_type === 'year-month-day hh:mm') {
          if (this.StoreLang === 'tr') {
            let x = moment(date, "YYYY-MM-DD hh:mm:ss").format("DD/MM/YYYY hh:mm");
            return x;
          } else {
            let x = moment(date, "YYYY-MM-DD hh:mm:ss").format("YYYY/MM/DD hh:mm");
            return x;
          }
        }
      } else {
        return "";
      }
    },
    f_controlWaiOutputMode: function (col, output_show_type) {
      let show_outpul_col = false;
      if (col.wai_output === 1) {
        if (output_show_type === 'right') {
          if (col.style === undefined || (col.style && (col.style.waiLocation === undefined || col.style.waiLocation === 'right_any_location'))) {
            show_outpul_col = true;
          }
        } else if (output_show_type === 'bottom') {
          if (col.style && col.style.waiLocation === 'bottom_as_card') {
            show_outpul_col = true;
          }
        }
      }
      return show_outpul_col;
    },
    f_showTextAsModal: function (text) {
      this.d_selectedTableCellFullText = text.toString();
      this.d_showTableCellFullText = true;
    },
    f_calculateColumnStyle: function (column_data) {
      let column_style = 'width: 100%; padding: 3px;';
      // let column_style = 'width: 100%; padding: 3px; text-align: center;';
      // console.log('column_data.style : ', column_data.style);
      if (column_data.style && column_data.style.backgroundColor) {
        column_style += 'background: ' + column_data.style.backgroundColor + ';';
      }
      if (column_data.style && column_data.style.color) {
        column_style += 'color: ' + column_data.style.color + ';';
      }
      if (column_data.style && column_data.style.fontSize) {
        column_style += 'font-size: ' + column_data.style.fontSize + 'px;';
      }
      return column_style;
    },
    f_resetForm: function () {
      this.d_clientId = '';
      this.d_wdmrId = '';
      this.d_project.details = '';
      this.d_project.column_list = [];
      this.f_wanalyzerProjectStatsResultList();
    },
    f_selectOrNotColumnForStatsAnalyze: function () {
      if (this.d_selectedModeTab !== 'graph_mode') {
        let is_there_any_selected = false;
        for (let col_index in this.d_project.column_list) {
          if (this.d_project.column_list[col_index].use_as_stats === 'yes') {
            is_there_any_selected = true;
            break;
          }
        }
        for (let col_index in this.d_project.column_list) {
          if (is_there_any_selected) {
            this.d_project.column_list[col_index].use_as_stats = 'no';
          } else {
            if (['wanalyzer_create_query'].indexOf(this.p_selectedProjectType) !== -1 || this.d_project.column_list[col_index].compare_eligible !== '0') {
              this.d_project.column_list[col_index].use_as_stats = 'yes';
            }
          }
        }
        this.$forceUpdate();
      }
    },
    f_selectColumnUseAsStats: function (col_index) {
      if (this.d_selectedModeTab === 'graph_mode') {
        if (!this.d_statsViewLoading) {
          let refresh = true;
          if (this.d_project.column_list[col_index].wai_output === 1) {
            // output seçimli için
            if (this.d_project.column_list[col_index].use_as_stats === 'yes') {
              refresh = false
            } else {
              for (let index in this.d_project.column_list) {
                if (this.d_project.column_list[index].wai_output === 1 && this.d_project.column_list[index].use_as_stats === 'yes' && parseInt(index) !== col_index) {
                  this.d_project.column_list[index].use_as_stats = 'no';
                }
              }
              this.d_project.column_list[col_index].use_as_stats = 'yes';
            }
          } else {
            // input seçimi için
            if (this.d_project.column_list[col_index].use_as_stats === 'yes') {
              let find = false;
              for (let index in this.d_project.column_list) {
                if (this.d_project.column_list[index].wai_output !== 1 && this.d_project.column_list[index].wai_input === 1 && this.d_project.column_list[index].use_as_stats === 'yes' && parseInt(index) !== col_index) {
                  if (this.d_project.column_list[index].multi_dimension_order >this.d_project.column_list[col_index].multi_dimension_order) {
                    this.d_project.column_list[index].multi_dimension_order --;
                  }
                  find = true;
                }
              }
              if (find) {
                this.d_project.column_list[col_index].use_as_stats = 'no';
                this.d_project.column_list[col_index].multi_dimension_order = '';
              } else {
                refresh = false
              }
            } else {
              let multi_dimension_order_index = '1';
              for (let index in this.d_project.column_list) {
                if (this.d_project.column_list[index].wai_output !== 1 && this.d_project.column_list[index].wai_input === 1 && this.d_project.column_list[index].use_as_stats === 'yes' && parseInt(index) !== col_index) {
                  if (this.d_project.column_list[index].multi_dimension_order && parseInt(this.d_project.column_list[index].multi_dimension_order) > parseInt(multi_dimension_order_index)) {
                    multi_dimension_order_index = String(this.d_project.column_list[index].multi_dimension_order);
                  }
                }
              }
              multi_dimension_order_index = String(parseInt(multi_dimension_order_index) + 1)
              this.d_project.column_list[col_index].use_as_stats = 'yes';
              this.d_project.column_list[col_index].multi_dimension_order = multi_dimension_order_index;
            }
          }
          if (refresh) {
            this.f_wanalyzerServicesTrigger();
            // console.log(this.d_project.column_list)
          }
        } else {
          alert(this.StoreLangTranslation.data['continuing'][this.StoreLang])
        }
      } else {
        if (this.d_project.column_list[col_index].use_as_stats === 'yes') {
          this.d_project.column_list[col_index].use_as_stats = 'no';
        } else {
          if (['wanalyzer_create_query'].indexOf(this.p_selectedProjectType) !== -1 || this.d_project.column_list[col_index].compare_eligible !== '0') {
            this.d_project.column_list[col_index].use_as_stats = 'yes';
          }
        }
      }
      this.$forceUpdate();
    },
    f_wanalyzerProjectStatisticsAnalyzeList: function () {
      if (!this.d_statsViewLoading) {
        this.d_statsOrderList = {};
        this.d_selectedStatsResultItem = '';
        let target_stats_list = []; // hedeflenen istatistik listesi eklenip servise gönderilir.
        /*

          this.d_selectedModeTab:
            iki farklı değer alabilir.
            graph_mode    : Bu durumda sadece multidimensional analiz gerçekleştirilir. graph_modeda sadece karşılaştırmalı analiz ve multi dimension analiz gerçekleştirilebilir.
            detailed_mode : Bu durumda tanımlayıcı ya da karşılaştırmalı analizler gerçekleştirilir.

          this.d_selectedStatisticsMethod
            üç farklı değer alabilir.
            1. selected_variables_descriptive: Bu durumda sadece seçilen değerlerle karşılaştımalı analiz yapılır.
            2. selected_variables_combinations_compare:  Bu durumda seçilen değişkenlerle kombinasyonlar üretilerek karşılaştırmalı analizler yapılır.
            3. selected_multi_input_and_one_output_variable: Bu durumda seçilen çoklu girdi ile tek bir girdi arasında karşılaştırmalar yapılır.

        */
        let is_there_eligible_column_to_analyze = false;
        let rule_algo = this.f_createRuleAlgorithm(this.d_project);
        if (this.d_selectedModeTab === 'graph_mode') {
          let stats_multi_dimension = this.f_prepareStatsData('cross_columns', 'multi_dimension', '');
          stats_multi_dimension.rule_algoritm = rule_algo;
          for (let i in this.d_project.column_list) {
            if (['select', 'integer', 'float', 'radiogroup'].indexOf(this.d_project.column_list[i].param_type) !== -1 || this.d_project.column_list[i].stats_data_type) {
              let use_column = false;
              if (['wanalyzer_create_query', 'wanalyzer_credit_count'].indexOf(this.p_selectedProjectType) !== -1) {
                use_column = true;
              } else if (['wanalyzer_dataset_stats_query', 'wanalyzer_dataset_filter'].indexOf(this.p_selectedProjectType) !== -1) {
                if (this.d_project.column_list[i].wai_output || this.d_project.column_list[i].wai_input) {
                  use_column = true;
                }
              }
              // console.log('use_column ', use_column);
              // console.log('this.d_project.column_list[i].use_as_stats ', this.d_project.column_list[i].use_as_stats);
              if (use_column) {
                if (this.d_project.column_list[i].use_as_stats === 'yes') {
                  is_there_eligible_column_to_analyze = true;
                  // Çıktı kolonları farklı bir değişkeneü, girdi parametreleri farklı bir değişkene ekleniyor.
                  if (this.d_project.column_list[i].wai_output) {
                    stats_multi_dimension['data']['general']['selected_column_parameters'][this.d_project.column_list[i].index] = {
                      'name': {'value': this.d_project.column_list[i].index, 'label': this.d_project.column_list[i].name, 'param_type': this.d_project.column_list[i].param_type},
                      'detail': {
                          "column_param_type_usage": {"val": {"value": "auto"} },
                          "is_weight_column_for_mean_dependent": {"val": {"value": "no"} }
                      }
                    }
                    stats_multi_dimension['data']['general']['column_parameter_list'] = {
                      "param_type": this.d_project.column_list[i].param_type,
                      "value": this.d_project.column_list[i].index,
                      "label": this.d_project.column_list[i].name
                    }
                  } else {
                    // girdi parametreleri ekleniyor.
                    stats_multi_dimension['data']['general']['selected_row_parameters'][this.d_project.column_list[i].index] = {
                      'name': {'value': this.d_project.column_list[i].index, 'label': this.d_project.column_list[i].name, 'param_type': this.d_project.column_list[i].param_type},
                      'detail': {
                          "multi_dimension_order": {"val": this.d_project.column_list[i].multi_dimension_order },
                          "row_param_type_usage": {"val": {"value": "auto"} },
                      }
                    }
                    stats_multi_dimension['data']['general']['row_parameter_list'] = {
                      "param_type": this.d_project.column_list[i].param_type,
                      "value": this.d_project.column_list[i].index,
                      "label": this.d_project.column_list[i].name
                    }
                  }
                }
              }
            }
          }
          if (is_there_eligible_column_to_analyze) {
            target_stats_list.push(stats_multi_dimension);
          }
        } else {
          // detay modunda 3 farklı şekilde istatistik analizi yapılabilir.
          if (this.d_selectedStatisticsMethod === 'selected_variables_descriptive') {
            let stats_data_descriptive = {
              'rule_algoritm': '',
              'data': {
                'general': {
                  'analyze_type': {'val': {'value': 'detailed_descriptive_stats'}},
                  'column_selection_type': {'val': {'value': 'manuel_column_selection'}},
                  'selected_columns': {},
                  'descriptive_stats': {
                    'mean': {'name': {'value': 'mean'}, 'detail': {}},
                    'frequency': {'name': {'value': 'frequency'}, 'detail': {}},
                    'outliers_interquartile_range': {'name': {'value': 'outliers_interquartile_range'}, 'detail': {}},
                  }
                }
              }
            };
            stats_data_descriptive.rule_algoritm = rule_algo;
            for (let i in this.d_project.column_list) {
              // console.log('this.d_project.column_list[i].param_type ', this.d_project.column_list[i].param_type);
              // console.log('this.d_project.column_list[i].wai_output ', this.d_project.column_list[i].wai_output);
              if (['select', 'integer', 'float', 'radiogroup'].indexOf(this.d_project.column_list[i].param_type) !== -1 || this.d_project.column_list[i].stats_data_type) {
                let use_column = false;
                if (['wanalyzer_create_query', 'wanalyzer_credit_count'].indexOf(this.p_selectedProjectType) !== -1) {
                  use_column = true;
                } else if (['wanalyzer_dataset_stats_query', 'wanalyzer_dataset_filter'].indexOf(this.p_selectedProjectType) !== -1) {
                  if (this.d_project.column_list[i].wai_output || this.d_project.column_list[i].wai_input) {
                    use_column = true;
                  }
                }
                // console.log('use_column ', use_column);
                // console.log('this.d_project.column_list[i].use_as_stats ', this.d_project.column_list[i].use_as_stats);
                if (use_column) {
                  if (this.d_project.column_list[i].use_as_stats === 'yes') {
                    is_there_eligible_column_to_analyze = true;

                    if (this.d_project.column_list[i].stats_data_type == 'categorical') {
                      stats_data_descriptive['data']['general']['selected_columns'][this.d_project.column_list[i].index] = {
                        'name': {'value': this.d_project.column_list[i].index, 'label': this.d_project.column_list[i].name},
                        'detail': {
                            "param_type_usage": {"val": {"value": "selected"} },
                            "column_param_type": {"val": {"value": "categorical"} },
                            "option_group_type": {"val": {"value": "standard_mode"} },
                            "selected_column_timeline_mode": {"val": {"value": "no"} }
                        }
                      }
                    } else if (this.d_project.column_list[i].stats_data_type == 'numeric') {
                      stats_data_descriptive['data']['general']['selected_columns'][this.d_project.column_list[i].index] = {
                        'name': {'value': this.d_project.column_list[i].index, 'label': this.d_project.column_list[i].name},
                        'detail': {
                            "param_type_usage": {"val": {"value": "selected"} },
                            "column_param_type": {"val": {"value": "numeric"} },
                            "option_group_type": {"val": {"value": "standard_mode"} },
                            "selected_column_timeline_mode": {"val": {"value": "no"} }
                        }
                      }
                    } else {
                      stats_data_descriptive['data']['general']['selected_columns'][this.d_project.column_list[i].index] = {
                        'name': {'value': this.d_project.column_list[i].index, 'label': this.d_project.column_list[i].name},
                        'detail': {
                            "param_type_usage": {"val": {"value": "auto"} },
                            "option_group_type": {"val": {"value": "standard_mode"} },
                            "selected_column_timeline_mode": {"val": {"value": "no"} }
                        }
                      }
                    }
                  }
                }
              }
            }
            if (is_there_eligible_column_to_analyze) {
              target_stats_list.push(stats_data_descriptive);
            }
          } else if (this.d_selectedStatisticsMethod === 'selected_variables_combinations_compare') {
            // Burada değişkenler arasında otomatik kombinasyonlar üretilir.
            let stats_auto_1 = this.f_prepareStatsData('cross_columns', 'auto_1', '')
            if (this.d_analyze_cross_columns_by_two_grouping === 'yes') {
              stats_auto_1['data']['general']['auto_combination_cross_analysis'] = {'val': {'value': 'yes'}};
            }
            stats_auto_1.rule_algoritm = rule_algo;
            for (let i in this.d_project.column_list) {
              // console.log('this.d_project.column_list[i].param_type ', this.d_project.column_list[i].param_type);
              // console.log('this.d_project.column_list[i].wai_output ', this.d_project.column_list[i].wai_output);
              if (['select', 'integer', 'float', 'radiogroup'].indexOf(this.d_project.column_list[i].param_type) !== -1 || this.d_project.column_list[i].stats_data_type) {
                let use_column = false;
                if (['wanalyzer_create_query', 'wanalyzer_credit_count'].indexOf(this.p_selectedProjectType) !== -1) {
                  use_column = true;
                } else if (['wanalyzer_dataset_stats_query', 'wanalyzer_dataset_filter'].indexOf(this.p_selectedProjectType) !== -1) {
                  if (this.d_project.column_list[i].wai_output || this.d_project.column_list[i].wai_input) {
                    use_column = true;
                  }
                }
                // console.log('use_column ', use_column);
                // console.log('this.d_project.column_list[i].use_as_stats ', this.d_project.column_list[i].use_as_stats);
                if (use_column) {
                  if (this.d_project.column_list[i].use_as_stats === 'yes') {
                    is_there_eligible_column_to_analyze = true;
                    if (this.d_project.column_list[i].stats_data_type == 'categorical') {
                      stats_auto_1['data']['general']['selected_columns'][this.d_project.column_list[i].index] = {
                        'name': {'value': this.d_project.column_list[i].index, 'label': this.d_project.column_list[i].name},
                        'detail': {
                            "param_type_usage": {"val": {"value": "selected"} },
                            "column_param_type": {"val": {"value": "categorical"} },
                            "option_group_type": {"val": {"value": "standard_mode"} },
                            "selected_column_timeline_mode": {"val": {"value": "no"} }
                        }
                      }
                    } else if (this.d_project.column_list[i].stats_data_type == 'numeric') {
                      stats_auto_1['data']['general']['selected_columns'][this.d_project.column_list[i].index] = {
                        'name': {'value': this.d_project.column_list[i].index, 'label': this.d_project.column_list[i].name},
                        'detail': {
                            "param_type_usage": {"val": {"value": "selected"} },
                            "column_param_type": {"val": {"value": "numeric"} },
                            "option_group_type": {"val": {"value": "standard_mode"} },
                            "selected_column_timeline_mode": {"val": {"value": "no"} }
                        }
                      }
                    } else {
                      stats_auto_1['data']['general']['selected_columns'][this.d_project.column_list[i].index] = {
                        'name': {'value': this.d_project.column_list[i].index, 'label': this.d_project.column_list[i].name},
                        'detail': {
                            "param_type_usage": {"val": {"value": "auto"} },
                            "option_group_type": {"val": {"value": "standard_mode"} },
                            "selected_column_timeline_mode": {"val": {"value": "no"} }
                        }
                      }
                    }
                  }
                }
              }
            }
            if (is_there_eligible_column_to_analyze) {
              target_stats_list.push(stats_auto_1);
            }
          } else if (this.d_selectedStatisticsMethod === 'selected_multi_input_and_one_output_variable') {
            // Burada seçilen değişkenler ile seçilen tek bir ana değişken arasında kombinasyon analizi yapılır.
            for (let i in this.d_project.column_list) {
              // console.log('this.d_project.column_list[i].param_type ', this.d_project.column_list[i].param_type);
              // console.log('this.d_project.column_list[i].wai_output ', this.d_project.column_list[i].wai_output);
              if (['select', 'integer', 'float', 'radiogroup'].indexOf(this.d_project.column_list[i].param_type) !== -1 || this.d_project.column_list[i].stats_data_type) {
                let use_column = false;
                if (['wanalyzer_create_query', 'wanalyzer_credit_count'].indexOf(this.p_selectedProjectType) !== -1) {
                  use_column = true;
                } else if (['wanalyzer_dataset_stats_query', 'wanalyzer_dataset_filter'].indexOf(this.p_selectedProjectType) !== -1) {
                  if (this.d_project.column_list[i].wai_output || this.d_project.column_list[i].wai_input) {
                    use_column = true;
                  }
                }
                // console.log('use_column ', use_column);
                // console.log('this.d_project.column_list[i].use_as_stats ', this.d_project.column_list[i].use_as_stats);
                if (use_column) {
                  if (this.d_project.column_list[i].use_as_stats === 'yes') {
                    // her bir girdi değişkeni ile çıktı arasında ayrı istatistik veri modeli üretiliyor.
                    let stats_auto_new_1 = this.f_prepareStatsData('cross_columns', 'auto_1', '')
                    if (this.d_analyze_cross_columns_by_two_grouping === 'yes') {
                      stats_auto_new_1['data']['general']['auto_combination_cross_analysis'] = {'val': {'value': 'yes'}};
                    }
                    stats_auto_new_1.rule_algoritm = rule_algo;
                    // girdi değişkenini ekliyoruz.
                    let input_col = this.d_project.column_list[i];
                    if (input_col.stats_data_type == 'categorical') {
                      stats_auto_new_1['data']['general']['selected_columns'][input_col.index] = {
                        'name': {'value': input_col.index, 'label': input_col.name},
                        'detail': {
                            "param_type_usage": {"val": {"value": "selected"} },
                            "column_param_type": {"val": {"value": "categorical"} },
                            "option_group_type": {"val": {"value": "standard_mode"} },
                            "selected_column_timeline_mode": {"val": {"value": "no"} }
                        }
                      }
                    } else if (input_col.stats_data_type == 'numeric') {
                      stats_auto_new_1['data']['general']['selected_columns'][input_col.index] = {
                        'name': {'value': input_col.index, 'label': input_col.name},
                        'detail': {
                            "param_type_usage": {"val": {"value": "selected"} },
                            "column_param_type": {"val": {"value": "numeric"} },
                            "option_group_type": {"val": {"value": "standard_mode"} },
                            "selected_column_timeline_mode": {"val": {"value": "no"} }
                        }
                      }
                    } else {
                      stats_auto_new_1['data']['general']['selected_columns'][input_col.index] = {
                        'name': {'value': input_col.index, 'label': input_col.name},
                        'detail': {
                            "param_type_usage": {"val": {"value": "auto"} },
                            "option_group_type": {"val": {"value": "standard_mode"} },
                            "selected_column_timeline_mode": {"val": {"value": "no"} }
                        }
                      }
                    }
                    // Çıktı değişkenini de ekliyoruz.
                    let output_col = this.d_project.column_list[this.d_selectedOutput];
                    if (output_col.stats_data_type == 'categorical') {
                      stats_auto_new_1['data']['general']['selected_columns'][output_col.index] = {
                        'name': {'value': output_col.index, 'label': output_col.name},
                        'detail': {
                            "param_type_usage": {"val": {"value": "selected"} },
                            "column_param_type": {"val": {"value": "categorical"} },
                            "option_group_type": {"val": {"value": "standard_mode"} },
                            "selected_column_timeline_mode": {"val": {"value": "no"} }
                        }
                      }
                    } else if (output_col.stats_data_type == 'numeric') {
                      stats_auto_new_1['data']['general']['selected_columns'][output_col.index] = {
                        'name': {'value': output_col.index, 'label': output_col.name},
                        'detail': {
                            "param_type_usage": {"val": {"value": "selected"} },
                            "column_param_type": {"val": {"value": "numeric"} },
                            "option_group_type": {"val": {"value": "standard_mode"} },
                            "selected_column_timeline_mode": {"val": {"value": "no"} }
                        }
                      }
                    } else {
                      stats_auto_new_1['data']['general']['selected_columns'][output_col.index] = {
                        'name': {'value': output_col.index, 'label': output_col.name},
                        'detail': {
                            "param_type_usage": {"val": {"value": "auto"} },
                            "option_group_type": {"val": {"value": "standard_mode"} },
                            "selected_column_timeline_mode": {"val": {"value": "no"} }
                        }
                      }
                    }
                    target_stats_list.push(stats_auto_new_1);
                  }
                }
              }
            }

            // Seçilen değişken kategorik ise lojistik regresyon, lineer ise lineer regresyon tetiklemesi yapıyoruz.
            let test_regression_type = '';
            let cross_type = '';
            if (['integer', 'float'].indexOf(this.d_project.column_list[this.d_selectedOutput].param_type) !== -1) {
              test_regression_type = 'linear_regression';
              cross_type = 'categorical_and_or_numeric_multi_numeric';
            } else if (['select', 'radiogroup'].indexOf(this.d_project.column_list[this.d_selectedOutput].param_type) !== -1) {
              test_regression_type = 'logistic_regression';
              cross_type = 'categorical_and_or_numeric_multi_categorical';
            }

            // değişkenlerin tek tek analiz edilmesi için stats_data_regression_1,
            // değişkenlerin hepsinin analiz edildikten sonra anlamlı olanlarla yeniden analiz yapılması yani multivariate analiz için stats_data_regression_2 kullanılıyor.

            let stats_data_regression_1 = {
              'rule_algoritm': '',
                'data': {
                  'general': {
                    'analyze_type': {'val': {'value': 'cross_columns'}},
                    'usage_of_comparison_tests': {'val': {'value': 'yes'}},
                    'cross_column_type': {'val': {'value': cross_type}},
                    'selected_column_parameters': {},
                    'selected_row_parameters': {},
                  }
                }
            };
            let stats_data_regression_2 = {
              'rule_algoritm': '',
                'data': {
                  'general': {
                    'analyze_type': {'val': {'value': 'cross_columns'}},
                    'usage_of_comparison_tests': {'val': {'value': 'yes'}},
                    'cross_column_type': {'val': {'value': cross_type}},
                    'selected_column_parameters': {},
                    'selected_row_parameters': {},
                  }
                }
            };
            if (test_regression_type == 'logistic_regression') {
              if (this.d_selectedOutputTrueOption) {
                stats_data_regression_1['data']['general']['true_output_option'] = {'val': this.d_selectedOutputTrueOption};
              }
              stats_data_regression_1['data']['general']['one_or_multi_independent_one_dependent_categorical'] = {'val': {'value': test_regression_type}};
              stats_data_regression_1['data']['general']['one_or_multi_independent_one_dependent_categorical'] = {'val': {'value': test_regression_type}};
              stats_data_regression_1['data']['general']['one_or_multi_independent_one_dependent_categorical_selected'] = {};
              stats_data_regression_1['data']['general']['one_or_multi_independent_one_dependent_categorical_selected'][test_regression_type] = {
                  "name": {"value": test_regression_type, },
                  "detail":
                  {
                      "oomiodc_variable_selection":
                      {
                          "val": [
                          {
                              "value": "1",
                              "label": "tüm değişkenleri hedef değişken ile toplu analiz yap"
                          }]
                      }
                  }
              }
              if (this.d_selectedOutputTrueOption) {
                stats_data_regression_2['data']['general']['true_output_option'] = {'val': this.d_selectedOutputTrueOption};
              }
              stats_data_regression_2['data']['general']['one_or_multi_independent_one_dependent_categorical'] = {'val': {'value': test_regression_type}};
              stats_data_regression_2['data']['general']['one_or_multi_independent_one_dependent_categorical_selected'] = {};
              stats_data_regression_2['data']['general']['one_or_multi_independent_one_dependent_categorical_selected'][test_regression_type] = {
                  "name": {"value": test_regression_type, },
                  "detail":
                  {
                      "oomiodc_variable_selection":
                      {
                          "val": [
                          {
                              "value": "2",
                              "label": "girdi değişkenlerini tek tek analiz yaptıktan sonra p değeri anlamlı olanları toplu analiz olarak da yap"
                          }]
                      }
                  }
              }
            } else if (test_regression_type == 'linear_regression') {
              stats_data_regression_1['data']['general']['one_or_multi_independent_one_dependent_numeric'] = {'val': {'value': test_regression_type}};
              stats_data_regression_1['data']['general']['one_or_multi_independent_one_dependent_numeric_selected'] = {};
              stats_data_regression_1['data']['general']['one_or_multi_independent_one_dependent_numeric_selected'][test_regression_type] = {
                  "name": {"value": test_regression_type, },
                  "detail":
                  {
                      "oomiodn_variable_selection":
                      {
                          "val": [
                          {
                              "value": "1",
                              "label": "tüm değişkenleri hedef değişken ile toplu analiz yap"
                          }]
                      }
                  }
              }
              stats_data_regression_2['data']['general']['one_or_multi_independent_one_dependent_numeric'] = {'val': {'value': test_regression_type}};
              stats_data_regression_2['data']['general']['one_or_multi_independent_one_dependent_numeric_selected'] = {};
              stats_data_regression_2['data']['general']['one_or_multi_independent_one_dependent_numeric_selected'][test_regression_type] = {
                  "name": {"value": test_regression_type, },
                  "detail":
                  {
                      "oomiodn_variable_selection":
                      {
                          "val": [
                          {
                              "value": "2",
                              "label": "girdi değişkenlerini tek tek analiz yaptıktan sonra p değeri anlamlı olanları toplu analiz olarak da yap"
                          }]
                      }
                  }
              }
            }
            stats_data_regression_1.rule_algoritm = rule_algo;
            stats_data_regression_2.rule_algoritm = rule_algo;
            for (let i in this.d_project.column_list) {
              if (['select', 'integer', 'float', 'radiogroup'].indexOf(this.d_project.column_list[i].param_type) !== -1 || this.d_project.column_list[i].stats_data_type) {
                let use_column = false;
                if (['wanalyzer_create_query', 'wanalyzer_credit_count'].indexOf(this.p_selectedProjectType) !== -1) {
                  use_column = true;
                } else if (['wanalyzer_dataset_stats_query', 'wanalyzer_dataset_filter'].indexOf(this.p_selectedProjectType) !== -1) {
                  if (this.d_project.column_list[i].wai_output || this.d_project.column_list[i].wai_input) {
                    use_column = true;
                  }
                }
                // console.log('use_column ', use_column);
                // console.log('this.d_project.column_list[i].use_as_stats ', this.d_project.column_list[i].use_as_stats);
                if (use_column) {
                  if (this.d_project.column_list[i].use_as_stats === 'yes') {
                    is_there_eligible_column_to_analyze = true;
                    if (parseInt(this.d_selectedOutput) === parseInt(i)) {
                      //
                    } else {

                      stats_data_regression_1['data']['general']['selected_row_parameters'][this.d_project.column_list[i].index] = {
                        'name': {'value': this.d_project.column_list[i].index, 'label': this.d_project.column_list[i].name},
                        'detail': {
                          'name': {'value': this.d_project.column_list[i].index, 'label': this.d_project.column_list[i].name, 'param_type': this.d_project.column_list[i].param_type},
                          'detail': {
                              "column_param_type_usage": {"val": {"value": "auto"} },
                              "is_weight_column_for_mean_dependent": {"val": {"value": "no"} }
                          }
                        }
                      }


                      stats_data_regression_2['data']['general']['selected_row_parameters'][this.d_project.column_list[i].index] = {
                        'name': {'value': this.d_project.column_list[i].index, 'label': this.d_project.column_list[i].name},
                        'detail': {
                          'name': {'value': this.d_project.column_list[i].index, 'label': this.d_project.column_list[i].name, 'param_type': this.d_project.column_list[i].param_type},
                          'detail': {
                              "column_param_type_usage": {"val": {"value": "auto"} },
                              "is_weight_column_for_mean_dependent": {"val": {"value": "no"} }
                          }
                        }
                      }



                    }

                  }
                }
              }
            }
            stats_data_regression_1['data']['general']['selected_column_parameters'][this.d_project.column_list[this.d_selectedOutput].index] = {
              'name': {'value': this.d_project.column_list[this.d_selectedOutput].index, 'label': this.d_project.column_list[this.d_selectedOutput].name},
              'detail': {
                'name': {'value': this.d_project.column_list[this.d_selectedOutput].index, 'label': this.d_project.column_list[this.d_selectedOutput].name, 'param_type': this.d_project.column_list[this.d_selectedOutput].param_type},
                'detail': {
                    "column_param_type_usage": {"val": {"value": "auto"} },
                    "is_weight_column_for_mean_dependent": {"val": {"value": "no"} }
                }
              }
            }
            stats_data_regression_2['data']['general']['selected_column_parameters'][this.d_project.column_list[this.d_selectedOutput].index] = {
              'name': {'value': this.d_project.column_list[this.d_selectedOutput].index, 'label': this.d_project.column_list[this.d_selectedOutput].name},
              'detail': {
                'name': {'value': this.d_project.column_list[this.d_selectedOutput].index, 'label': this.d_project.column_list[this.d_selectedOutput].name, 'param_type': this.d_project.column_list[this.d_selectedOutput].param_type},
                'detail': {
                    "column_param_type_usage": {"val": {"value": "auto"} },
                    "is_weight_column_for_mean_dependent": {"val": {"value": "no"} }
                }
              }
            }
            if (is_there_eligible_column_to_analyze) {
              target_stats_list.push(stats_data_regression_1);
              target_stats_list.push(stats_data_regression_2);
            }

          }
        }

        this.d_statisticResults = {};
        if (target_stats_list.length > 0) {
          let query = 'project_id=' + this.d_projectId;
          if (this.p_projectPermission && this.p_projectPermission.auth_data) {
            query += '&auth_client_id=' + this.p_projectPermission.auth_data.client_id;
          }
          let data = {
            'list': target_stats_list
          };

          let column_count = 0;
          for (let i in this.d_project.column_list) {
            if (this.d_project.column_list[i].use_as_stats === 'yes') {
              column_count ++;
            }
          }
          // console.log('column_count: ',column_count)
          // if (this.d_comparedStatistics) {
          if (this.d_selectedStatisticsMethod === 'selected_variables_combinations_compare') {
            let combination_res = this.f_combination(column_count, 2)
            data.frd_usage_count = column_count + combination_res;
            // console.log('combination_res: ',combination_res)
          } else {
            data.frd_usage_count = column_count;
          }
          // console.log(data);
          this.d_statsViewLoading = true;
          ServiceFunctions.wanalyzer_project_statistics_analyze_list(query, data)
            .then(resp => {
              if (resp.data.status_code.substring(resp.data.status_code.length - 3, resp.data.status_code.length) == '000') {
                if (resp.data.credit_eligible === '0') {
                  alert(this.StoreLangTranslation.data['not_enough_credit'][this.StoreLang])
                  this.d_statsViewLoading = false;
                } else {
                  // servis id değeri ile arka planda sonucu timer ile izlemeye başlanıyor.
                  if (resp.data.user_credit_auth_data) {
                    this.p_creditAuthData.auth_data = resp.data.user_credit_auth_data;
                  }
                  this.d_statsServiceId = resp.data.service_id;
                  this.d_taskStarted = true;
                  this.f_manageBackgroundService('stats_services', this.d_statsServiceId, this.d_projectId, 'add');
                  setTimeout(function () {
                    this.f_wanalyzerProjectStatisticsResultByServiceId();
                  }.bind(this), 10000)
                }
              } else {
                this.d_taskStarted = false;
                this.d_statsViewLoading = false;
                let txt = 'status_code = ' + resp.data.status_code + '\n';
                txt += 'status_message = ' + resp.data.status_message;
                alert(txt);
              }
            });
        }
      }
    },
    f_wanalyzerProjectOldResultList: function (result_type) {
      this.d_oldResultsLoading = true;
      this.d_oldResultList = [];
      this.d_selectedOldResultItem = '';
      this.d_selectedOldStatsResultItem = '';
      this.d_selectedOldResultIndex = '';
      let query = 'project_id=' + this.d_projectId;
      if (this.p_projectPermission && this.p_projectPermission.auth_data) {
        query += '&auth_client_id=' + this.p_projectPermission.auth_data.client_id;
      }
      if (result_type == 'statistical_analysis') {
        query += '&result_type=0';
        this.d_oldStatisticResultsModal = true;
      } else if (result_type == 'ml_training') {
        query += '&result_type=1';
        this.d_oldMlResultsModal = true;
      }
      let data = {};
      ServiceFunctions.wanalyzer_project_old_result_list(query, data)
        .then(resp => {
          if (resp.data.status_code.substring(resp.data.status_code.length - 3, resp.data.status_code.length) == '000') {
            if (resp.data.list) {
              this.d_oldResultsLoading = false;
              this.d_oldResultList = resp.data.list.reverse();
            }
          } else {
            let txt = 'status_code = ' + resp.data.status_code + '\n';
            txt += 'status_message = ' + resp.data.status_message;
            alert(txt);
          }
        });
    },
    f_wanalyzerProjectStatisticsResultByServiceId: function () {
      if (this.d_statsServiceId && localStorage.getItem('selected_project_id') === this.d_projectId) {
        this.d_statsOrderList = {};
        this.d_taskStarted = true;
        this.d_statsViewLoading = true;
        let query = 'project_id=' + this.d_projectId;
        query += '&service_id=' + this.d_statsServiceId;
        if (this.p_projectPermission && this.p_projectPermission.auth_data) {
          query += '&auth_client_id=' + this.p_projectPermission.auth_data.client_id;
        }
        let data = {'list': []};
        ServiceFunctions.wanalyzer_project_statistics_analyze_list(query, data)
          .then(resp => {
            if (resp.data.status_code.substring(resp.data.status_code.length - 3, resp.data.status_code.length) == '000') {
              // istatistik sonuçları dolduysa sonuç tamamlanmıştır.
              if (resp.data.statistic_results) {
                this.d_taskStarted = false;
                this.f_manageBackgroundService('stats_services', '', this.d_projectId, 'remove');
                this.d_statsViewLoading = false;
                this.d_statsServiceId = '';
                this.d_statisticResults = resp.data.statistic_results;
                this.d_variablesShow = false;

                if (this.d_selectedStatisticsMethod === 'selected_multi_input_and_one_output_variable') {
                  // this.f_multiAndOneInput();
                } else {
                  let next_order = 1;
                  for (let stats_id in this.d_statisticResults[this.d_projectId]) {
                    if (this.d_statisticResults[this.d_projectId][stats_id].analyze_list) {
                      for (let ana_ind in this.d_statisticResults[this.d_projectId][stats_id].analyze_list) {
                        this.d_statsOrderList[stats_id + '_' + ana_ind] = next_order;
                        next_order += 1;
                      }
                    }
                  }
                }
                this.f_statsShowRefresh();
                // this.f_wanalyzerServicesTrigger();
                // if (['wanalyzer_dataset_filter', 'wanalyzer_create_query', 'wanalyzer_credit_count'].indexOf(this.p_selectedProjectType) !== -1) {
                //   this.f_wanalyzerProjectDatasetGet('dataset_filter_table');
                // }
              } else {
                // bu durumda timer devam ediyor.
                this.d_timerControlResult.interval += 5000;
                if (this.d_timerControlResult.interval > this.d_timerControlResult.max) {
                  this.d_timerControlResult.interval = this.d_timerControlResult.max;
                }
                setTimeout(function () {
                  this.f_wanalyzerProjectStatisticsResultByServiceId();
                }.bind(this), this.d_timerControlResult.interval);

              }
            } else {
              // hata alırsak istatistik modelini siliyoruz. Çünkü hata alındığında sürekli aynı hatayı vermeye devam eder.
              this.d_statsViewLoading = false;
              this.f_manageBackgroundService('stats_services', '', this.d_projectId, 'remove');
              let txt = 'status_code = ' + resp.data.status_code + '\n';
              txt += 'status_message = ' + resp.data.status_message;
              alert(txt);
            }
          })
          .catch(err => {
            this.d_timerControlResult.interval += 5000;
            if (this.d_timerControlResult.interval > this.d_timerControlResult.max) {
              this.d_timerControlResult.interval = this.d_timerControlResult.max;
            }
            setTimeout(function () {
              this.f_wanalyzerProjectStatisticsResultByServiceId();
            }.bind(this), this.d_timerControlResult.interval);
          });
      }
    },


    f_factorial: function (n) {
      if (n === 0 || n === 1) {
        return 1;
      }
      let res = 1;
      for (let i = 2; i <= n; i++) {
        res *= i;
      }
      return res;
    },

    f_combination: function (n, r) {
      if (r > n || n < 0 || r < 0) {
        return 0;
      }
      return this.f_factorial(n) / (this.f_factorial(r) * this.f_factorial(n - r));
    },

    f_prepareStatsData: function (type, easy_stats_type = '', column_selection_type = '') {
      /*
        @click="f_prepareStatsData('mean')"
        @click="f_prepareStatsData('median')"
        @click="f_prepareStatsData('frequency')"
        @click="f_prepareStatsData('cross_columns')"
        @click="f_prepareStatsData('detailed_descriptive_stats','i_will_select_columns')"
        @click="f_prepareStatsData('detailed_descriptive_stats','numeric_columns')"
        @click="f_prepareStatsData('detailed_descriptive_stats','categorical_columns')"
        @click="f_prepareStatsData('detailed_descriptive_stats','all_columns')"
        @click="f_prepareStatsData('detailed_descriptive_stats','i_will_select_columns_test_group_1')"
        @click="f_prepareStatsData('detailed_descriptive_stats','all_columns_test_group_1')"
        @click="f_prepareStatsData('sum')"
        @click="f_prepareStatsData('before_after_comparison')"
        @click="f_prepareStatsData('frequency')"
        @click="f_prepareStatsData('mean')"
        @click="f_prepareStatsData('median')"
        @click="f_prepareStatsData('max')"
        @click="f_prepareStatsData('min')"
        @click="f_prepareStatsData('standart_deviation')"
        @click="f_prepareStatsData('outliers_zindex')"
        @click="f_prepareStatsData('outliers_interquartile_range')"
        @click="f_prepareStatsData('skewness')"
        @click="f_prepareStatsData('kurtosis')"
        @click="f_prepareStatsData('kolmogorov_smirnov')"
        @click="f_prepareStatsData('shapiro_wilk')"
        @click="f_prepareStatsData('cross_columns', 'categorical_categorical_descriptive')"
        @click="f_prepareStatsData('cross_columns', 'categorical_categorical_chisquare')"
        @click="f_prepareStatsData('cross_columns', 'categorical_categorical_fisherexact')"
        @click="f_prepareStatsData('cross_columns', 'categorical_categorical_chisquare_fisherexact')"
        @click="f_prepareStatsData('cross_columns', 'categorical_numeric_descriptive')"
        @click="f_prepareStatsData('cross_columns', 'categorical_numeric_t_test')"
        @click="f_prepareStatsData('cross_columns', 'categorical_numeric_mann_whitney_u')"
        @click="f_prepareStatsData('cross_columns', 'categorical_numeric_oneway_anova')"
        @click="f_prepareStatsData('cross_columns', 'categorical_numeric_kruskal_wallis')"
        @click="f_prepareStatsData('cross_columns', 'numeric_numeric_pearson_corelation')"
        @click="f_prepareStatsData('cross_columns', 'numeric_numeric_spearman')"
        @click="f_prepareStatsData('before_after_comparison', 'numeric_numeric_pairs_sample_t_test')"
        @click="f_prepareStatsData('cross_columns', 'numeric_categorical_logistic_regression')"
        @click="f_prepareStatsData('cross_columns', 'xxxxxxxxxxx')"
        @click="f_prepareStatsData('cross_columns', 'auto_1')"
      */
      let pre_data = {};
      if (easy_stats_type === 'multi_dimension') {
        pre_data = {
          'data': {
            'general': {
              'selected_row_parameters': {},
              'selected_column_parameters': {},
              'row_parameter_list': {},
              'column_parameter_list': {},
            }
          },
        };
      }
      else {
        pre_data = {
          // 'id': 'new',
          'data': {
            'general': {
              'selected_columns': {}
            }
          },
          // 'type': 'wdm72',
          // 'reference_wdm': {},
          // 'wdm3_id': this.p_selectedProjectData.id
        };
      }

      // pre_data['reference_wdm']['version'] = this.d_statsWdm['version'];
      // pre_data['reference_wdm']['owner_type'] = this.d_statsWdm['owner_type'];
      // if (this.d_statsWdm['owner_type'] === 'wisdom') {
      //   pre_data['reference_wdm']['key'] = 'wdm_wisdom_wdm72_v' + this.d_statsWdm.version;
      // }
      // for (let i in this.d_statsWdm.param_group.param_order) {
      //   pre_data['data'][this.d_statsWdm.param_group.param_order[i]] = {};
      // }
      let analyze_type = '';
      for (let i in this.d_statsWdm.general.parameters.analyze_type.options) {
        if (this.d_statsWdm.general.parameters.analyze_type.options[i].value === type) {
          analyze_type = this.d_statsWdm.general.parameters.analyze_type.options[i];
          break;
        }
      }
      // pre_data['data']['general']['wdm3_name'] = { 'val': this.p_selectedProjectData.data.general.name.val };
      // pre_data['data']['general']['wdm3_key'] = { 'val': 'wdm3_' + this.p_selectedProjectData.id };
      pre_data['data']['general']['analyze_type'] = { 'val': analyze_type };
      pre_data['data']['general']['analyze_time_type'] = { 'val': { 'value': 'manuel', 'label': 'manuel' } };
      pre_data['data']['general']['auto_combination_cross_analysis'] = { 'val': { 'value': 'no', 'label': 'hayır' } };
      // categorical & categorical
      if (type === 'cross_columns') {
        if (easy_stats_type === 'multi_dimension') {
          pre_data['data']['general']['total_analyze_count'] = { 'val': '1' };
          pre_data['data']['general']['case_count_analyze_applied'] = { 'val': '100' };
          pre_data['data']['general']['wdm3_key'] = { 'val': 'wdm3_' + this.p_projectId };
          pre_data['data']['general']['model_info'] = { "val": "" }
          pre_data['data']['general']['are_cases_filtered'] = { 'val': { 'value': 'yes', 'label': 'evet' } };
          pre_data['data']['general']['usage_of_comparison_tests'] = { 'val': { 'value': 'no', 'label': 'hayır' } };
          // pre_data['data']['general']['case_count_analyze_applied']
          pre_data['data']['general']['wdm3_name'] = { 'val': this.p_projectId };
          // pre_data['data']['general']['total_analyze_operation_count']
          pre_data['data']['general']['multi_dimension_analyze'] = { 'val': { 'value': 'yes', 'label': 'evet' } };
          pre_data['data']['general']['are_cases_filtered'] = { 'val': { 'value': 'yes', 'label': 'evet' } };
          pre_data['data']['general']['model_name'] = { 'val': 'Comperative analysis' };
          pre_data['data']['general']['cross_column_type'] = { 'val': { 'value': 'categorical_and_categorical_or_numeric', 'label': 'kategorik & kategorik veya sayısal' } };
          pre_data['data']['general']['column_selection_type'] = { 'val': { 'value': 'manuel_column_selection', 'label': 'manuel kolon seçimi' } };
          // pre_data['data']['general']['analyzed_at']
          pre_data['data']['general']['case_rows_count'] = { 'val': '0' };
        } else if (easy_stats_type === 'auto_1') {
            pre_data['data']['general']['model_name'] = { 'val': 'Comperative analysis' };
            pre_data['data']['general']['usage_of_comparison_tests'] = { 'val': { 'value': 'yes', 'label': 'evet' } };
            pre_data['data']['general']['selected_categorical_to_nominal'] = {};
            pre_data['data']['general']['selected_categorical_to_categorical'] = {};
            pre_data['data']['general']['selected_nominal_to_nominal'] = {};
            pre_data['data']['general']['cross_column_type'] = { 'val': { 'value': 'auto', 'label': 'otomatik' } };
            pre_data['data']['general']['column_selection_type'] = { 'val': { 'value': 'manuel_column_selection', 'label': 'manuel kolon seçimi' } };
            pre_data['data']['general']['auto_combination_cross_analysis'] = { 'val': { 'value': 'no', 'label': 'hayır' } };
            pre_data['data']['general']['sample_count_control'] = { 'val': { 'value': 'no', 'label': 'hayır' } };
            pre_data['data']['general']['group_count_control'] = { 'val': { 'value': 'no', 'label': 'hayır' } };
            // numeric to numeric
            pre_data['data']['general']['selected_nominal_to_nominal']['pearson_correlation'] = {
              'name': { 'value': 'pearson_correlation', 'label': 'pearson korelasyon' },
              'detail': {
                'numeric_numeric_control_type_before_test': { 'val': { 'value': 'only_total_samples_data_distribution', 'label': 'sadece tüm örneklere ait veri dağılımı' } },
                'numeric_numeric_distribution_test_list_usage_type': { 'val': { 'value': 'all_of_them', 'label': 'tüm seçili testler normal dağılıyorsa kullan' } },
                'numeric_numeric_distribution_skewness': { 'val': { 'value': 'yes', 'label': 'evet' } },
                'numeric_numeric_distribution_skewness_range': { 'val': '1.5' },
                'numeric_numeric_distribution_kurtosis': { 'val': { 'value': 'yes', 'label': 'evet' } },
                'numeric_numeric_distribution_kurtosis_range': { 'val': '1.5' },
                'numeric_numeric_distribution_shapiro_wilk': { 'val': { 'value': 'yes', 'label': 'evet' } },
                'numeric_numeric_distribution_kolmogorov_smirnov': { 'val': { 'value': 'no', 'label': 'hayır' } },
              }
            };
            pre_data['data']['general']['selected_nominal_to_nominal']['spearman'] = {
              'name': { 'value': 'spearman', 'label': 'spearman' },
              'detail': {
                'numeric_numeric_control_type_before_test': { 'val': { 'value': 'only_total_samples_data_distribution', 'label': 'sadece tüm örneklere ait veri dağılımı' } },
                'numeric_numeric_distribution_test_list_usage_type': { 'val': { 'value': 'one_of_them_not_normally_distributed', 'label': 'testlerden birisi normal dağılmıyorsa kullan' } },
                'numeric_numeric_distribution_skewness': { 'val': { 'value': 'yes', 'label': 'evet' } },
                'numeric_numeric_distribution_skewness_range': { 'val': '1.5' },
                'numeric_numeric_distribution_kurtosis': { 'val': { 'value': 'yes', 'label': 'evet' } },
                'numeric_numeric_distribution_kurtosis_range': { 'val': '1.5' },
                'numeric_numeric_distribution_shapiro_wilk': { 'val': { 'value': 'yes', 'label': 'evet' } },
                'numeric_numeric_distribution_kolmogorov_smirnov': { 'val': { 'value': 'no', 'label': 'hayır' } },
              }
            };
            // categorical to categorical
            pre_data['data']['general']['selected_categorical_to_categorical']['fisherexact'] = { 'name': { 'value': 'fisherexact', 'label': 'Fisher Exact' }, 'detail': {} };
            pre_data['data']['general']['selected_categorical_to_categorical']['chisquare'] = { 'name': { 'value': 'chisquare', 'label': 'Chi square' }, 'detail': {} };
            // categorical to numeric
            pre_data['data']['general']['selected_categorical_to_nominal']['oneway_anova'] = {
              'name': { 'value': 'oneway_anova', 'label': 'Oneway ANOVA' },
              'detail': {
                'categorical_numeric_control_type_before_test': { 'val': { 'value': 'only_every_group_data_distribution', 'label': 'sadece her bir gruba ait veri dağılımı' } },
                'categorical_numeric_distribution_test_list_usage_type': { 'val': { 'value': 'all_of_them', 'label': 'tüm seçili testler normal dağılıyorsa kullan' } },
                'categorical_numeric_distribution_skewness': { 'val': { 'value': 'yes', 'label': 'evet' } },
                'categorical_numeric_distribution_skewness_range': { 'val': '1.5' },
                'categorical_numeric_distribution_kurtosis': { 'val': { 'value': 'yes', 'label': 'evet' } },
                'categorical_numeric_distribution_kurtosis_range': { 'val': '1.5' },
                'categorical_numeric_distribution_shapiro_wilk': { 'val': { 'value': 'yes', 'label': 'evet' } },
                'categorical_numeric_distribution_kolmogorov_smirnov': { 'val': { 'value': 'no', 'label': 'hayır' } },
              }
            };
            pre_data['data']['general']['selected_categorical_to_nominal']['kruskal_wallis'] = {
              'name': { 'value': 'kruskal_wallis', 'label': 'Kruskal Wallis' },
              'detail': {
                'categorical_numeric_control_type_before_test': { 'val': { 'value': 'only_every_group_data_distribution', 'label': 'sadece her bir gruba ait veri dağılımı' } },
                'categorical_numeric_distribution_test_list_usage_type': { 'val': { 'value': 'one_of_them_not_normally_distributed', 'label': 'testlerden birisi normal dağılmıyorsa kullan' } },
                'categorical_numeric_distribution_skewness': { 'val': { 'value': 'yes', 'label': 'evet' } },
                'categorical_numeric_distribution_skewness_range': { 'val': '1.5' },
                'categorical_numeric_distribution_kurtosis': { 'val': { 'value': 'yes', 'label': 'evet' } },
                'categorical_numeric_distribution_kurtosis_range': { 'val': '1.5' },
                'categorical_numeric_distribution_shapiro_wilk': { 'val': { 'value': 'yes', 'label': 'evet' } },
                'categorical_numeric_distribution_kolmogorov_smirnov': { 'val': { 'value': 'no', 'label': 'hayır' } },
              }
            };
            pre_data['data']['general']['selected_categorical_to_nominal']['mann_whitney_u'] = {
              'name': { 'value': 'mann_whitney_u', 'label': 'Mann Whitney U' },
              'detail': {
                'categorical_numeric_control_type_before_test': { 'val': { 'value': 'only_every_group_data_distribution', 'label': 'sadece her bir gruba ait veri dağılımı' } },
                'categorical_numeric_distribution_test_list_usage_type': { 'val': { 'value': 'all_of_them_not_normally_distributed', 'label': 'tüm seçili testler normal dağılmıyorsa kullan' } },
                'categorical_numeric_distribution_skewness': { 'val': { 'value': 'yes', 'label': 'evet' } },
                'categorical_numeric_distribution_skewness_range': { 'val': '1.5' },
                'categorical_numeric_distribution_kurtosis': { 'val': { 'value': 'yes', 'label': 'evet' } },
                'categorical_numeric_distribution_kurtosis_range': { 'val': '1.5' },
                'categorical_numeric_distribution_shapiro_wilk': { 'val': { 'value': 'yes', 'label': 'evet' } },
                'categorical_numeric_distribution_kolmogorov_smirnov': { 'val': { 'value': 'no', 'label': 'hayır' } },
              }
            };
            pre_data['data']['general']['selected_categorical_to_nominal']['t_test'] = {
              'name': { 'value': 't_test', 'label': 't test' },
              'detail': {
                'categorical_numeric_control_type_before_test': { 'val': { 'value': 'only_every_group_data_distribution', 'label': 'sadece her bir gruba ait veri dağılımı' } },
                'categorical_numeric_distribution_test_list_usage_type': { 'val': { 'value': 'all_of_them_not_normally_distributed', 'label': 'tüm seçili testler normal dağılmıyorsa kullan' } },
                'categorical_numeric_distribution_skewness': { 'val': { 'value': 'yes', 'label': 'evet' } },
                'categorical_numeric_distribution_skewness_range': { 'val': '1.5' },
                'categorical_numeric_distribution_kurtosis': { 'val': { 'value': 'yes', 'label': 'evet' } },
                'categorical_numeric_distribution_kurtosis_range': { 'val': '1.5' },
                'categorical_numeric_distribution_shapiro_wilk': { 'val': { 'value': 'yes', 'label': 'evet' } },
                'categorical_numeric_distribution_kolmogorov_smirnov': { 'val': { 'value': 'no', 'label': 'hayır' } },
              }
            };
          }
      }
      if (easy_stats_type === 'categorical_categorical_descriptive') {
        pre_data['data']['general']['cross_column_type'] = { 'val': { 'value': 'categorical_categorical', 'label': 'kategorik & kategorik' } };
        pre_data['data']['general']['usage_of_comparison_tests'] = { 'val': { 'value': 'no', 'label': 'hayır' } };
      } else if (easy_stats_type === 'categorical_categorical_fisherexact') {
        pre_data['data']['general']['cross_column_type'] = { 'val': { 'value': 'categorical_categorical', 'label': 'kategorik & kategorik' } };
        pre_data['data']['general']['usage_of_comparison_tests'] = { 'val': { 'value': 'yes', 'label': 'evet' } };
        pre_data['data']['general']['selected_categorical_to_categorical'] = {};
        pre_data['data']['general']['selected_categorical_to_categorical']['fisherexact'] = { 'name': { 'value': 'fisherexact', 'label': 'Fisher Exact' }, 'detail': {} };
      } else if (easy_stats_type === 'categorical_categorical_chisquare') {
        pre_data['data']['general']['cross_column_type'] = { 'val': { 'value': 'categorical_categorical', 'label': 'kategorik & kategorik' } };
        pre_data['data']['general']['usage_of_comparison_tests'] = { 'val': { 'value': 'yes', 'label': 'evet' } };
        pre_data['data']['general']['selected_categorical_to_categorical'] = {};
        pre_data['data']['general']['selected_categorical_to_categorical']['chisquare'] = { 'name': { 'value': 'chisquare', 'label': 'Chi square' }, 'detail': {} };
      } else if (easy_stats_type === 'categorical_categorical_chisquare_fisherexact') {
        pre_data['data']['general']['cross_column_type'] = { 'val': { 'value': 'categorical_categorical', 'label': 'kategorik & kategorik' } };
        pre_data['data']['general']['usage_of_comparison_tests'] = { 'val': { 'value': 'yes', 'label': 'evet' } };
        pre_data['data']['general']['selected_categorical_to_categorical'] = {};
        pre_data['data']['general']['selected_categorical_to_categorical']['fisherexact'] = { 'name': { 'value': 'fisherexact', 'label': 'Fisher Exact' }, 'detail': {} };
        pre_data['data']['general']['selected_categorical_to_categorical']['chisquare'] = { 'name': { 'value': 'chisquare', 'label': 'Chi square' }, 'detail': {} };
      }
      // categorical & numeric
      if (easy_stats_type === 'categorical_numeric_descriptive') {
        pre_data['data']['general']['model_name'] = { 'val': 'Kategorik verilerle sayısal verilerin karşılaştırılması' };
        pre_data['data']['general']['cross_column_type'] = { 'val': { 'value': 'categorical_numeric', 'label': 'kategorik & sayısal' } };
        pre_data['data']['general']['usage_of_comparison_tests'] = { 'val': { 'value': 'no', 'label': 'hayır' } };
      } else if (easy_stats_type === 'categorical_numeric_t_test') {
        pre_data['data']['general']['model_name'] = { 'val': 'Kategorik verilerle sayısal verilerin karşılaştırılması' };
        pre_data['data']['general']['cross_column_type'] = { 'val': { 'value': 'categorical_numeric', 'label': 'kategorik & sayısal' } };
        pre_data['data']['general']['usage_of_comparison_tests'] = { 'val': { 'value': 'yes', 'label': 'evet' } };
        pre_data['data']['general']['selected_categorical_to_nominal'] = {};
        pre_data['data']['general']['selected_categorical_to_nominal']['t_test'] = { 'name': { 'value': 't_test', 'label': 't test' }, 'detail': {} };
      } else if (easy_stats_type === 'categorical_numeric_kruskal_wallis') {
        pre_data['data']['general']['model_name'] = { 'val': 'Kategorik verilerle sayısal verilerin karşılaştırılması' };
        pre_data['data']['general']['cross_column_type'] = { 'val': { 'value': 'categorical_numeric', 'label': 'kategorik & sayısal' } };
        pre_data['data']['general']['usage_of_comparison_tests'] = { 'val': { 'value': 'yes', 'label': 'evet' } };
        pre_data['data']['general']['selected_categorical_to_nominal'] = {};
        pre_data['data']['general']['selected_categorical_to_nominal']['kruskal_wallis'] = { 'name': { 'value': 'kruskal_wallis', 'label': 'Kruskal Wallis' }, 'detail': {} };
      } else if (easy_stats_type === 'categorical_numeric_mann_whitney_u') {
        pre_data['data']['general']['model_name'] = { 'val': 'Kategorik verilerle sayısal verilerin karşılaştırılması' };
        pre_data['data']['general']['cross_column_type'] = { 'val': { 'value': 'categorical_numeric', 'label': 'kategorik & sayısal' } };
        pre_data['data']['general']['usage_of_comparison_tests'] = { 'val': { 'value': 'yes', 'label': 'evet' } };
        pre_data['data']['general']['selected_categorical_to_nominal'] = {};
        pre_data['data']['general']['selected_categorical_to_nominal']['mann_whitney_u'] = { 'name': { 'value': 'mann_whitney_u', 'label': 'Mann Whitney U test' }, 'detail': {} };
      } else if (easy_stats_type === 'categorical_numeric_oneway_anova') {
        pre_data['data']['general']['model_name'] = { 'val': 'Kategorik verilerle sayısal verilerin karşılaştırılması' };
        pre_data['data']['general']['cross_column_type'] = { 'val': { 'value': 'categorical_numeric', 'label': 'kategorik & sayısal' } };
        pre_data['data']['general']['usage_of_comparison_tests'] = { 'val': { 'value': 'yes', 'label': 'evet' } };
        pre_data['data']['general']['selected_categorical_to_nominal'] = {};
        pre_data['data']['general']['selected_categorical_to_nominal']['oneway_anova'] = { 'name': { 'value': 'oneway_anova', 'label': 'Oneway ANOVA' }, 'detail': {} };
      }
      // numeric & numeric
      if (easy_stats_type === 'numeric_numeric_pearson_corelation') {
        pre_data['data']['general']['model_name'] = { 'val': 'Sayısal verilerle sayısal verilerin karşılaştırılarak korelasyon değerlendirilmesi' };
        pre_data['data']['general']['cross_column_type'] = { 'val': { 'value': 'numeric_numeric', 'label': 'sayısal & sayısal' } };
        pre_data['data']['general']['usage_of_comparison_tests'] = { 'val': { 'value': 'yes', 'label': 'evet' } };
        pre_data['data']['general']['selected_nominal_to_nominal'] = {};
        pre_data['data']['general']['selected_nominal_to_nominal']['pearson_correlation'] = { 'name': { 'value': 'pearson_correlation', 'label': 'pearson korelasyon' }, 'detail': {} };
      } else if (easy_stats_type === 'numeric_numeric_spearman') {
        pre_data['data']['general']['model_name'] = { 'val': 'Sayısal verilerle sayısal verilerin karşılaştırılarak korelasyon değerlendirilmesi' };
        pre_data['data']['general']['cross_column_type'] = { 'val': { 'value': 'numeric_numeric', 'label': 'sayısal & sayısal' } };
        pre_data['data']['general']['usage_of_comparison_tests'] = { 'val': { 'value': 'yes', 'label': 'evet' } };
        pre_data['data']['general']['selected_nominal_to_nominal'] = {};
        pre_data['data']['general']['selected_nominal_to_nominal']['spearman'] = { 'name': { 'value': 'spearman', 'label': 'spearman' }, 'detail': {} };
      } else if (easy_stats_type === 'numeric_numeric_pairs_sample_t_test') {
        pre_data['data']['general']['model_name'] = { 'val': 'Sayısal verinin önce -> sonra değişim analizi' };
        pre_data['data']['general']['cross_column_type'] = { 'val': { 'value': 'numeric_numeric', 'label': 'sayısal & sayısal' } };
        pre_data['data']['general']['before_after'] = {
          'list': [{
            'selected_before_after_statistical_test': {
              'ttest_relation_paired_samples': { 'name': { 'value': 'ttest_relation_paired_samples', 'label': 'bağımlı gruplar t testi (paired samples)' }, 'detail': {} }
            }
          }]
        };
      }
      // numeric & categorical
      if (easy_stats_type === 'numeric_categorical_logistic_regression') {
        pre_data['data']['general']['model_name'] = { 'val': 'Verilerle 2 kategorik grup arasındaki ilişkinin logistic regresyon ile değerlendirilmesi.' };
        pre_data['data']['general']['usage_of_comparison_tests'] = { 'val': { 'value': 'no', 'label': 'hayır' } };
        pre_data['data']['general']['cross_column_type'] = { 'val': { 'value': 'numeric_categorical', 'label': 'sayısal & categorical' } };
        pre_data['data']['general']['one_or_multi_independent_one_dependent_categorical_selected'] = {};
        pre_data['data']['general']['one_or_multi_independent_one_dependent_categorical_selected']['logistic_regression'] = {
          'name': { 'value': 'logistic_regression', 'label': 'Lojistik Regresyon' },
          'detail': {
            'oomiodc_variable_selection': {
              'val': [{ 'value': '1', 'label': 'tüm değişkenleri hedef değişken ile toplu analiz yap' }]
            }
          }
        };
      }
      if (type === 'detailed_descriptive_stats') {
        pre_data['data']['general']['model_name'] = { 'val': 'Detaylı Tanımlayıcı İstatistikler' };
        if (easy_stats_type === 'i_will_select_columns') {
          pre_data['data']['general']['column_selection_type'] = { 'val': { 'value': 'manuel_column_selection', 'label': 'manuel kolon seçimi' } };
          pre_data['data']['general']['descriptive_stats'] = {
            'mean': { 'name': { 'value': 'mean', 'label': 'ortalama' }, 'detail': {} },
            'median': { 'name': { 'value': 'median', 'label': 'ortanca (medyan)' }, 'detail': {} },
            'standart_deviation': { 'name': { 'value': 'standart_deviation', 'label': 'standart sapma' }, 'detail': {} },
            'variance': { 'name': { 'value': 'variance', 'label': 'varyans' }, 'detail': {} },
            'min': { 'name': { 'value': 'min', 'label': 'minimum' }, 'detail': {} },
            'max': { 'name': { 'value': 'max', 'label': 'maksimum' }, 'detail': {} },
            'kurtosis': { 'name': { 'value': 'kurtosis', 'label': 'veri dağılımı (basıklık, kurtosis)' }, 'detail': {} },
            'skewness': { 'name': { 'value': 'skewness', 'label': 'veri dağılımı (eğim, skewness)' }, 'detail': {} },
            'frequency': { 'name': { 'value': 'frequency', 'label': 'sıklık' }, 'detail': {} },
            'kolmogorov_smirnov': { 'name': { 'value': 'kolmogorov_smirnov', 'label': 'veri dağılımı (kolmogrov smirnov)' }, 'detail': {} },
            'shapiro_wilk': { 'name': { 'value': 'shapiro_wilk', 'label': 'shapiro wilk' }, 'detail': {} },
            'outliers_zindex': { 'name': { 'value': 'outliers_zindex', 'label': 'aykırı değer saptama (outliers) z-index' }, 'detail': {} }
          };
        } else if (easy_stats_type === 'i_will_select_columns_test_group_1') {
          pre_data['data']['general']['column_selection_type'] = { 'val': { 'value': 'manuel_column_selection', 'label': 'manuel kolon seçimi' } };
          pre_data['data']['general']['descriptive_stats'] = {
            'mean': { 'name': { 'value': 'mean', 'label': 'ortalama' }, 'detail': {} },
            'median': { 'name': { 'value': 'median', 'label': 'ortanca (medyan)' }, 'detail': {} },
            'standart_deviation': { 'name': { 'value': 'standart_deviation', 'label': 'standart sapma' }, 'detail': {} },
            'min': { 'name': { 'value': 'min', 'label': 'minimum' }, 'detail': {} },
            'max': { 'name': { 'value': 'max', 'label': 'maksimum' }, 'detail': {} },
            'kurtosis': { 'name': { 'value': 'kurtosis', 'label': 'veri dağılımı (basıklık, kurtosis)' }, 'detail': {} },
            'skewness': { 'name': { 'value': 'skewness', 'label': 'veri dağılımı (eğim, skewness)' }, 'detail': {} },
            'frequency': { 'name': { 'value': 'frequency', 'label': 'sıklık' }, 'detail': {} },
            'shapiro_wilk': { 'name': { 'value': 'shapiro_wilk', 'label': 'shapiro wilk' }, 'detail': {} }
          };
        } else if (easy_stats_type === 'numeric_columns') {
          // pre_data['data']['general']['selected_columns'] = this.f_addColumnsByParamTypes(['integer', 'float']);
          pre_data['data']['general']['column_selection_type'] = { 'val': { 'value': 'all_numeric_columns', 'label': 'tüm numeric kolonlar' } };
          pre_data['data']['general']['descriptive_stats'] = {
            'mean': { 'name': { 'value': 'mean', 'label': 'ortalama' }, 'detail': {} },
            'median': { 'name': { 'value': 'median', 'label': 'ortanca (medyan)' }, 'detail': {} },
            'standart_deviation': { 'name': { 'value': 'standart_deviation', 'label': 'standart sapma' }, 'detail': {} },
            'variance': { 'name': { 'value': 'variance', 'label': 'varyans' }, 'detail': {} },
            'min': { 'name': { 'value': 'min', 'label': 'minimum' }, 'detail': {} },
            'max': { 'name': { 'value': 'max', 'label': 'maksimum' }, 'detail': {} },
            'kurtosis': { 'name': { 'value': 'kurtosis', 'label': 'veri dağılımı (basıklık, kurtosis)' }, 'detail': {} },
            'skewness': { 'name': { 'value': 'skewness', 'label': 'veri dağılımı (eğim, skewness)' }, 'detail': {} },
            'kolmogorov_smirnov': { 'name': { 'value': 'kolmogorov_smirnov', 'label': 'veri dağılımı (kolmogrov smirnov)' }, 'detail': {} },
            'shapiro_wilk': { 'name': { 'value': 'shapiro_wilk', 'label': 'veri dağılımı (shapiro_wilk)' }, 'detail': {} },
            'outliers_zindex': { 'name': { 'value': 'outliers_zindex', 'label': 'aykırı değer saptama (outliers) z-index' }, 'detail': {} }
          };

        } else if (easy_stats_type === 'categorical_columns') {
          pre_data['data']['general']['column_selection_type'] = { 'val': { 'value': 'all_categorical_columns', 'label': 'tüm kategorik kolonlar' } };
          // pre_data['data']['general']['selected_columns'] = this.f_addColumnsByParamTypes(['select', 'radiogroup', 'object_list_options', 'checkbox']);
          pre_data['data']['general']['descriptive_stats'] = {
            'frequency': { 'name': { 'value': 'frequency', 'label': 'sıklık' }, 'detail': {} }
          };
        } else if (easy_stats_type === 'all_columns') {
          pre_data['data']['general']['column_selection_type'] = { 'val': { 'value': 'all_columns', 'label': 'tüm kolonlar' } };
          // pre_data['data']['general']['selected_columns'] = this.f_addColumnsByParamTypes('all');
          pre_data['data']['general']['descriptive_stats'] = {
            'mean': { 'name': { 'value': 'mean', 'label': 'ortalama' }, 'detail': {} },
            'median': { 'name': { 'value': 'median', 'label': 'ortanca (medyan)' }, 'detail': {} },
            'standart_deviation': { 'name': { 'value': 'standart_deviation', 'label': 'standart sapma' }, 'detail': {} },
            'variance': { 'name': { 'value': 'variance', 'label': 'varyans' }, 'detail': {} },
            'min': { 'name': { 'value': 'min', 'label': 'minimum' }, 'detail': {} },
            'max': { 'name': { 'value': 'max', 'label': 'maksimum' }, 'detail': {} },
            'kurtosis': { 'name': { 'value': 'kurtosis', 'label': 'veri dağılımı (basıklık, kurtosis)' }, 'detail': {} },
            'skewness': { 'name': { 'value': 'skewness', 'label': 'veri dağılımı (eğim, skewness)' }, 'detail': {} },
            'frequency': { 'name': { 'value': 'frequency', 'label': 'sıklık' }, 'detail': {} },
            'kolmogorov_smirnov': { 'name': { 'value': 'kolmogorov_smirnov', 'label': 'veri dağılımı (kolmogrov smirnov)' }, 'detail': {} },
            'shapiro': { 'name': { 'value': 'shapiro', 'label': 'veri dağılımı (shapiro)' }, 'detail': {} },
            'outliers_zindex': { 'name': { 'value': 'outliers_zindex', 'label': 'aykırı değer saptama (outliers) z-index' }, 'detail': {} }
          };
        } else if (easy_stats_type === 'all_columns_test_group_1') {
          pre_data['data']['general']['column_selection_type'] = { 'val': { 'value': 'all_columns', 'label': 'tüm kolonlar' } };
          pre_data['data']['general']['descriptive_stats'] = {
            'mean': { 'name': { 'value': 'mean', 'label': 'ortalama' }, 'detail': {} },
            'median': { 'name': { 'value': 'median', 'label': 'ortanca (medyan)' }, 'detail': {} },
            'standart_deviation': { 'name': { 'value': 'standart_deviation', 'label': 'standart sapma' }, 'detail': {} },
            'min': { 'name': { 'value': 'min', 'label': 'minimum' }, 'detail': {} },
            'max': { 'name': { 'value': 'max', 'label': 'maksimum' }, 'detail': {} },
            'kurtosis': { 'name': { 'value': 'kurtosis', 'label': 'veri dağılımı (basıklık, kurtosis)' }, 'detail': {} },
            'skewness': { 'name': { 'value': 'skewness', 'label': 'veri dağılımı (eğim, skewness)' }, 'detail': {} },
            'frequency': { 'name': { 'value': 'frequency', 'label': 'sıklık' }, 'detail': {} },
            'shapiro_wilk': { 'name': { 'value': 'shapiro_wilk', 'label': 'shapiro wilk' }, 'detail': {} }
          };
        }
      }
      return pre_data;
    },
    f_wanalyzerProjectCellCalculate: function () {
      let query = 'project_id=' + this.d_projectId;
      if (this.d_clientId) {
        query += '&client_id=' + this.d_clientId
      }
      if (this.d_wdmrId) {
        query += '&wdmr_id=' + this.d_wdmrId
      }
      let data = {
        'column_list': [],
        'sql_name': this.d_sqlName
      };
      let not_filled_det = false;
      for (let i in this.d_project.column_list) {
        if (this.d_project.column_list[i].wai_input === 1) {
          if (this.d_project.column_list[i].val) {
            let new_input_data = {
              'id': this.d_project.column_list[i].id,
              'label': this.d_project.column_list[i].name,
              'val': this.d_project.column_list[i].val ? this.d_project.column_list[i].val : ''
            }
            data.column_list.push(new_input_data);
          } else {
            if (this.d_clientId || this.d_wdmrId) {
              //
            } else {
              not_filled_det = true;
              break            
            }
          }
        }
      }
      if (not_filled_det) {
        alert(this.StoreLangTranslation.data['please_fill_all_inputs'][this.StoreLang]);
      } else {
        for (let cl_index in this.d_project.column_list) {
          if (this.d_project.column_list[cl_index].wai_output === 1) {
            this.d_project.column_list[cl_index].obj = '';
          }
        }
        this.d_analyzeContinuing = true;
        ServiceFunctions.wanalyzer_project_cell_calculate(query, data)
          .then(resp => {
            this.d_analyzeContinuing = false;
            if (resp.data.status_code.substring(resp.data.status_code.length - 3, resp.data.status_code.length) == '000') {
              for (let col_index in resp.data.column_list) {
                if (resp.data.column_list[col_index].wai_output === 1) {
                  for (let cl_index in this.d_project.column_list) {
                    if (this.d_project.column_list[cl_index].name === resp.data.column_list[col_index].name) {
                      this.d_project.column_list[cl_index].obj = resp.data.column_list[col_index].obj;
                      if (resp.data.column_list[col_index].style !== undefined) {
                        this.d_project.column_list[cl_index].style = resp.data.column_list[col_index].style;
                      }
                      break;
                    }
                  }
                } else if (resp.data.column_list[col_index].wai_input === 1) {
                  for (let cl_index in this.d_project.column_list) {
                    if (this.d_project.column_list[cl_index].name === resp.data.column_list[col_index].name) {
                      if (!this.d_project.column_list[cl_index].val) {
                        let input_val = '';
                        for (let k in resp.data.column_list[col_index].obj) {
                          for (let l_index in resp.data.column_list[col_index].obj[k].list) {
                            input_val = resp.data.column_list[col_index].obj[k].list[l_index].val;
                            break;
                          }
                          if (input_val) {
                            break;
                          }
                        }
                        this.d_project.column_list[cl_index].val = input_val;
                      }
                      break;
                    }
                  }                  
                }
              }
              let time_based_list = [];
              for (let i in this.d_project.column_list) {
                if (this.d_project.column_list[i].wai_output === 1) {
                  if (this.d_project.column_list[i].obj) {
                    for (let obj_key in this.d_project.column_list[i].obj) {
                      let date_string = '';
                      if (this.d_project.column_list[i].obj[obj_key].date) {
                        date_string = this.d_project.column_list[i].obj[obj_key].date;
                      }
                      for (let obj_li_index in this.d_project.column_list[i].obj[obj_key].list) {
                        let obj_data = this.d_project.column_list[i].obj[obj_key].list[obj_li_index];
                        let new_val_item = {
                          'date': date_string,
                          'val': obj_data['val'],
                          'label': this.d_project.column_list[i].name,
                          'background_color': ''
                        };
                        if (this.d_project.column_list[i].style && this.d_project.column_list[i].style.backgroundColor) {
                          new_val_item.background_color = this.d_project.column_list[i].style.backgroundColor;
                        }
                        time_based_list.push(new_val_item);
                      }
                    }
                  }
                }
              }
              let param = 'date';
              let asc_or_desc = 1;
              // let asc_or_desc = -1;
              function compare(a, b) {
                // Use toUpperCase() to ignore character casing
                let param_a = '';
                let param_b = '';
                try {
                  param_a = a[param].toLocaleLowerCase();
                  param_b = b[param].toLocaleLowerCase();
                } catch (err) {
                  param_a = a[param];
                  param_b = b[param];
                }

                let comparison = 0;
                if (param_a > param_b) {
                  comparison = 1;
                } else if (param_a < param_b) {
                  comparison = -1;
                }
                return comparison * asc_or_desc;
              }
              time_based_list.sort(compare);
              // console.log('time_based_list : ', time_based_list);
              if (time_based_list.length > 0) {
                this.d_timeLineLeftToRight = [];
                // first row is year-month-day based.
                // [[{}], [{}], [{"date": "2021-12-6"}], [{"date": "2021-12-7"}], [{"date": "2021-12-16"}], [{"date": "2021-12-27"}], [{"date": "2022-1-4"}] ]
                let first_row = [[{}], [{}]];
                let unique_date_list = [];
                let unique_column_label_list = [];
                for (let t_index in time_based_list) {
                  if (unique_column_label_list.indexOf(time_based_list[t_index].label) === -1) {
                    unique_column_label_list.push(time_based_list[t_index].label);
                  }
                  let year_month_day = '';
                  if (time_based_list[t_index].date) {
                    if (time_based_list[t_index].date.indexOf(' ') !== -1) {
                      year_month_day = time_based_list[t_index].date.split(' ')[0];
                    } else if (time_based_list[t_index].date.indexOf('T') !== -1) {
                      year_month_day = time_based_list[t_index].date.split('T')[0];
                    }
                  }
                  if (year_month_day && unique_date_list.indexOf(year_month_day) === -1) {
                    unique_date_list.push(year_month_day);
                  }
                }
                // console.log('unique_date_list : ', unique_date_list);
                for (let unique_ind in unique_date_list) {
                  first_row.push([{'date': unique_date_list[unique_ind]}]);
                }
                this.d_timeLineLeftToRight.push(first_row);
                for (let unique_ind in unique_column_label_list) {
                  let first_col = {
                    "background_color": "#e5f7f3",
                    "value": unique_column_label_list[unique_ind],
                    "label": unique_column_label_list[unique_ind]
                  };
                  for (let cl_index in this.d_project.column_list) {
                    if (this.d_project.column_list[cl_index].name === unique_column_label_list[unique_ind]) {
                      if (this.d_project.column_list[cl_index].style && this.d_project.column_list[cl_index].style.backgroundColor) {
                        first_col.background_color = this.d_project.column_list[cl_index].style.backgroundColor;
                      }
                      break;
                    }
                  }
                  let new_row = [[first_col], []];
                  for (let i = 0; i < unique_date_list.length; i++) {
                    new_row.push([]);
                  }
                  this.d_timeLineLeftToRight.push(new_row);
                }
              }
              for (let row_index in this.d_timeLineLeftToRight) {
                if (row_index > 0) {
                  let row_label = this.d_timeLineLeftToRight[row_index][0][0]['label'];
                  for (let col_index in this.d_timeLineLeftToRight[row_index]) {
                    if (parseInt(col_index) === 1) {
                      for (let t_index in time_based_list) {
                        if (!time_based_list[t_index].date) {
                          let cell_value = '';
                          let cell_label = '';
                          if (typeof(time_based_list[t_index].val) === 'object') {
                            cell_value = time_based_list[t_index].val.value;
                            cell_label = time_based_list[t_index].val.label;
                          } else {
                            cell_value = time_based_list[t_index].val;
                            cell_label = time_based_list[t_index].val;                              
                          }
                          if (row_label === time_based_list[t_index].label) {
                            let new_cell_item = {
                              'label': cell_label,
                              'value': cell_value,
                              'date': '',
                              'background_color': time_based_list[t_index].background_color
                            };
                            this.d_timeLineLeftToRight[row_index][col_index].push(new_cell_item);
                          }
                        }
                      }
                    } else if (parseInt(col_index) > 1) {
                      let col_date = this.d_timeLineLeftToRight[0][col_index][0]['date'];
                      // row_label ve col_date olan verileri time_based_list içerisinden ekleyeceğiz.
                      for (let t_index in time_based_list) {
                        let year_month_day = '';
                        if (time_based_list[t_index].date) {
                          if (time_based_list[t_index].date.indexOf(' ') !== -1) {
                            year_month_day = time_based_list[t_index].date.split(' ')[0];
                          } else if (time_based_list[t_index].date.indexOf('T') !== -1) {
                            year_month_day = time_based_list[t_index].date.split('T')[0];
                          }
                        }
                        if (year_month_day) {
                          if (col_date === year_month_day) {
                            let cell_value = '';
                            let cell_label = '';
                            if (typeof(time_based_list[t_index].val) === 'object') {
                              cell_value = time_based_list[t_index].val.value;
                              cell_label = time_based_list[t_index].val.label;
                            } else {
                              cell_value = time_based_list[t_index].val;
                              cell_label = time_based_list[t_index].val;                              
                            }
                            if (row_label === time_based_list[t_index].label) {
                              let new_cell_item = {
                                'label': cell_label,
                                'value': cell_value,
                                'date': time_based_list[t_index].date,
                                'background_color': time_based_list[t_index].background_color
                              };
                              this.d_timeLineLeftToRight[row_index][col_index].push(new_cell_item);
                            }
                          }
                        }
                      }
                    }
                  }
                }
              }
              // console.log('this.d_timeLineLeftToRight : ', this.d_timeLineLeftToRight);

              for (let i in this.d_project.column_list) {
                if (this.d_project.column_list[i].obj) {
                  let obj_item_list = [];
                  for (let obj_key in this.d_project.column_list[i].obj) {
                    let obj_date = '';
                    if (this.d_project.column_list[i].obj[obj_key].date) {
                      obj_date = this.d_project.column_list[i].obj[obj_key].date;
                    }
                    let new_obj_item = {
                      'date': obj_date,
                      'key': obj_key
                    };
                    obj_item_list.push(new_obj_item);
                  }
                  let param = 'date';
                  let asc_or_desc = 1;
                  // let asc_or_desc = -1;
                  function compare(a, b) {
                    // Use toUpperCase() to ignore character casing
                    let param_a = '';
                    let param_b = '';
                    try {
                      param_a = a[param].toLocaleLowerCase();
                      param_b = b[param].toLocaleLowerCase();
                    } catch (err) {
                      param_a = a[param];
                      param_b = b[param];
                    }

                    let comparison = 0;
                    if (param_a > param_b) {
                      comparison = 1;
                    } else if (param_a < param_b) {
                      comparison = -1;
                    }
                    return comparison * asc_or_desc;
                  }
                  obj_item_list.sort(compare);
                  let new_obj_order = [];
                  for (let obj_ind in obj_item_list) {
                    new_obj_order.push(obj_item_list[obj_ind].key);
                  }
                  this.d_project.column_list[i].obj_order = new_obj_order;
                }
              }

              this.$forceUpdate();
            } else {
              let txt = 'status_code = ' + resp.data.status_code + '\n';
              txt += 'status_message = ' + resp.data.status_message;
              alert(txt);
            }
          });
      }
    },
    f_getScopes: function () {
      while(this.p_scopeList.length !== 0) {
        this.p_scopeList.pop()
      }
      for (let project of this.p_projectList['wanalyzer_create_query']) {
        if (project['wanalyzer_project_scope']){
          if (this.p_scopeList.indexOf(project['wanalyzer_project_scope']) === -1) {
            this.p_scopeList.push(project['wanalyzer_project_scope'])
          }
        }
      }
      // console.log(this.p_scopeList);
    }
  },
  watch: {
    'd_selectedOutput': function () {
      if (this.d_selectedOutput !== '') {
        this.d_project.column_list[this.d_selectedOutput].use_as_stats = 'no';
        if (['select', 'radiogroup', 'date', 'datetime', 'time'].indexOf(this.d_project.column_list[this.d_selectedOutput].param_type) !== -1) {
          this.d_selectedOutputParamType = 'categorical';
        } else if (['integer', 'float'].indexOf(this.d_project.column_list[this.d_selectedOutput].param_type) !== -1) {
          this.d_selectedOutputParamType = 'numeric';
        } else {
          this.d_selectedOutputParamType = 'categorical';
        }
        this.d_selectedOutputTrueOption = '';
      }
    },
    'd_selectedTabItemId': function () {
      // this.d_selectedOutput = '';
      this.f_getReportData();
    },
    'd_filterData.pagination.current': function () {
      // console.log("d_filterData.pagination", this.d_filterData.pagination);
      this.d_filterData.pagination.start = (this.d_filterData.pagination.current - 1) * this.d_filterData.pagination.perpage;
      this.d_filterData.pagination.end = (this.d_filterData.pagination.perpage * this.d_filterData.pagination.current);
      this.f_wanalyzerProjectStatsResultList();
    },
    'd_tablePagination.current': function () {
      this.d_tablePagination.start = (this.d_tablePagination.current - 1) * this.d_tablePagination.perpage;
      this.d_tablePagination.end = (this.d_tablePagination.perpage * this.d_tablePagination.current) - 1;
      this.f_tableShow();
    },
    'd_clientId': function () {
      // this.f_resetForm();
    },
    'd_selectScope': function () {
      if(this.d_projectLocalScope !== this.d_selectScope && this.d_selectScope !== '') {
        this.d_projectLocalScope = this.d_selectScope;
      }
    },
    'd_projectLocalScope': function () {
      if (this.p_scopeList) {
        let scopeIndex = this.p_scopeList.indexOf(this.d_projectLocalScope);
        // console.log(scopeIndex)
        if (scopeIndex !== -1) {
          this.d_selectScope = this.p_scopeList[scopeIndex];
        } else {
          this.d_selectScope = '';
        }
      } else {
        this.d_selectScope = '';
      }
    },
    'd_selectedModeTab': function () {
      if (this.d_selectedModeTab === 'graph_mode') {
        this.d_selectedStatisticsMethod === 'selected_variables_combinations_compare'
        // this.d_comparedStatistics = true;
        let active_wai_input = false;
        let active_wai_output = false;
        for (let column_index in this.d_project.column_list) {
          this.d_project.column_list[column_index].multi_dimension_order = '';
          if (this.d_project.column_list[column_index].wai_input === 1 && this.d_project.column_list[column_index].wai_output !== 1 && !active_wai_input) {
            this.d_project.column_list[column_index].use_as_stats = 'yes';
            this.d_project.column_list[column_index].multi_dimension_order = '1';
            active_wai_input = true;
          } else if (this.d_project.column_list[column_index].wai_output === 1 && !active_wai_output) {
            this.d_project.column_list[column_index].use_as_stats = 'yes';
            active_wai_output = true;
          } else {
            this.d_project.column_list[column_index].use_as_stats = 'no';
          }
        }
        this.d_compareEligible = true;
        // this.f_wanalyzerServicesTrigger();
      } else {
        if (['wanalyzer_dataset_stats_query', 'wanalyzer_dataset_filter'].indexOf(this.p_selectedProjectType) !== -1) {
          for (let column_index in this.d_project.column_list) {
            if (this.d_project.column_list[column_index].use_as_stats === 'yes' && this.d_project.column_list[column_index].compare_eligible === '0' && this.d_compareEligible) {
              this.d_compareEligible = false
            }
            this.d_project.column_list[column_index].use_as_stats = 'no';
          }
          // this.d_comparedStatistics = false;
          this.d_selectedStatisticsMethod === 'selected_variables_descriptive'
        }
      }
    },
  }
}

</script>

<style>
#d_excelCorrection_show .modal-dialog {
  max-width: 95vw !important;
  width: 95vw !important;
}
#d_excelCorrection_show .modal-content {
  height: 90vh !important;
}

.correction-table-fixed-header {
  display: block;
  }


.correction-table-fixed-header thead {
  display: table;
  width: 100%;
  table-layout: fixed;
}


.correction-table-fixed-header tbody {
  display: block;
  max-height: 65vh;
  overflow-y: auto;
}


.correction-table-fixed-header tbody tr {
  display: table;
  width: 100%;
  table-layout: fixed;
}


.even-row {
  background-color: #e8e8e8;
}


.option-box {
  max-height: 175px;
  overflow-y: auto;
  background: #f5f5f5;
  border: 1px solid #ccc;
  padding: 5px;
  border-radius: 3px;
}


.error-box {
  max-height: 175px;
  overflow-y: auto;
  background: #f8d7da;
  padding: 5px;
  border-radius: 3px;
}


.alz-wrap {
  font-family: Arial, Helvetica, sans-serif;
  line-height: 1.35;
}

.alz-card {
  background: #ffffff;
  border: 1px solid #e6edf5;
  border-radius: 12px;
  padding: 10px 12px;
  box-shadow: 0 1px 0 rgba(16, 24, 40, 0.04);
}

.alz-top {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 10px;
}

.alz-title {
  font-size: 13px;
  font-weight: 700;
  color: #0f172a;
  margin: 0;
}

.alz-sub {
  font-size: 12px;
  color: #475569;
  margin-top: 4px;
}

.alz-chips {
  margin-top: 10px;
  display: flex;
  flex-wrap: wrap;
  gap: 6px;
}

.alz-chip {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  border-radius: 999px;
  padding: 5px 9px;
  border: 1px solid #e6edf5;
  background: #f8fafc;
  font-size: 11px;
  color: #0f172a;
}

.alz-chip-k {
  opacity: 0.75;
}

.alz-chip-v {
  font-weight: 700;
}

.alz-chip-info {
  background: #f3f8ff;
  border-color: #dbeafe;
}

.alz-chip-ok {
  background: #f0fdf4;
  border-color: #bbf7d0;
}

.alz-chip-warn {
  background: #fffbeb;
  border-color: #fde68a;
}

.alz-chip-danger {
  background: #fef2f2;
  border-color: #fecaca;
}

.alz-chip-neutral {
  background: #f8fafc;
  border-color: #e2e8f0;
}


.processing-banner {
  display: flex;
  align-items: center;
  gap: 14px;
  padding: 14px 20px;
  border-radius: 10px;
  background: linear-gradient(90deg, #e6f7fb, #f0fcff);
  border: 1px solid #bfeaf2;
  color: #0f4c5c;
  font-size: 14px;
  box-shadow: 0 4px 10px rgba(0, 0, 0, 0.04);
  margin: 12px 0;
}

.processing-text {
  display: flex;
  flex-direction: column;
  line-height: 1.3;
}

.processing-text strong {
  font-size: 15px;
  font-weight: 600;
}

.processing-text span {
  font-size: 13px;
  opacity: 0.85;
}

/* Spinner */
.spinner {
  width: 22px;
  height: 22px;
  border: 3px solid rgba(15, 76, 92, 0.2);
  border-top-color: #0f4c5c;
  border-radius: 50%;
  animation: spin 0.9s linear infinite;
}

@keyframes spin {
  to {
    transform: rotate(360deg);
  }
}

.modal-90 .modal-dialog {
  max-width: 90vw;
  width: 90vw;
}

.modal-90 .modal-content {
  height: 90vh;
}

.modal-90 .modal-body {
  max-height: calc(90vh - 120px); /* header + footer payı */
  overflow-y: auto;
}

#d_excelCorrection_show .modal-dialog {
  max-width: 95vw !important;
  width: 95vw !important;
}
#d_excelCorrection_show .modal-content {
  height: 90vh !important;
}

.correction-table-fixed-header {
  display: block;
  }


.correction-table-fixed-header thead {
  display: table;
  width: 100%;
  table-layout: fixed;
}


.correction-table-fixed-header tbody {
  display: block;
  max-height: 65vh;
  overflow-y: auto;
}


.correction-table-fixed-header tbody tr {
  display: table;
  width: 100%;
  table-layout: fixed;
}


.even-row {
  background-color: #e8e8e8;
}


.option-box {
  max-height: 175px;
  overflow-y: auto;
  background: #f5f5f5;
  border: 1px solid #ccc;
  padding: 5px;
  border-radius: 3px;
}


.error-box {
  max-height: 175px;
  overflow-y: auto;
  background: #f8d7da;
  padding: 5px;
  border-radius: 3px;
}


.alz-wrap {
  font-family: Arial, Helvetica, sans-serif;
  line-height: 1.35;
}

.alz-card {
  background: #ffffff;
  border: 1px solid #e6edf5;
  border-radius: 12px;
  padding: 10px 12px;
  box-shadow: 0 1px 0 rgba(16, 24, 40, 0.04);
}

.alz-top {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 10px;
}

.alz-title {
  font-size: 13px;
  font-weight: 700;
  color: #0f172a;
  margin: 0;
}

.alz-sub {
  font-size: 12px;
  color: #475569;
  margin-top: 4px;
}

.alz-chips {
  margin-top: 10px;
  display: flex;
  flex-wrap: wrap;
  gap: 6px;
}

.alz-chip {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  border-radius: 999px;
  padding: 5px 9px;
  border: 1px solid #e6edf5;
  background: #f8fafc;
  font-size: 11px;
  color: #0f172a;
}

.alz-chip-k {
  opacity: 0.75;
}

.alz-chip-v {
  font-weight: 700;
}

.alz-chip-info {
  background: #f3f8ff;
  border-color: #dbeafe;
}

.alz-chip-ok {
  background: #f0fdf4;
  border-color: #bbf7d0;
}

.alz-chip-warn {
  background: #fffbeb;
  border-color: #fde68a;
}

.alz-chip-danger {
  background: #fef2f2;
  border-color: #fecaca;
}

.alz-chip-neutral {
  background: #f8fafc;
  border-color: #e2e8f0;
}


.processing-banner {
  display: flex;
  align-items: center;
  gap: 14px;
  padding: 14px 20px;
  border-radius: 10px;
  background: linear-gradient(90deg, #e6f7fb, #f0fcff);
  border: 1px solid #bfeaf2;
  color: #0f4c5c;
  font-size: 14px;
  box-shadow: 0 4px 10px rgba(0, 0, 0, 0.04);
  margin: 12px 0;
}

.processing-text {
  display: flex;
  flex-direction: column;
  line-height: 1.3;
}

.processing-text strong {
  font-size: 15px;
  font-weight: 600;
}

.processing-text span {
  font-size: 13px;
  opacity: 0.85;
}

/* Spinner */
.spinner {
  width: 22px;
  height: 22px;
  border: 3px solid rgba(15, 76, 92, 0.2);
  border-top-color: #0f4c5c;
  border-radius: 50%;
  animation: spin 0.9s linear infinite;
}

@keyframes spin {
  to {
    transform: rotate(360deg);
  }
}

.modal-90 .modal-dialog {
  max-width: 90vw;
  width: 90vw;
}

.modal-90 .modal-content {
  height: 90vh;
}

.modal-90 .modal-body {
  max-height: calc(90vh - 120px); /* header + footer payı */
  overflow-y: auto;
}


/* ===============================
   WAI Analytics Dashboard Skin
   Non-breaking visual layer: keeps all Vue variables, v-models, v-if and methods unchanged.
   =============================== */
.wai-analytics-page {
  min-height: 750px;
  font-size: 15px;
  padding: 18px;
  background:
    radial-gradient(circle at top left, rgba(37, 99, 235, 0.12), transparent 30%),
    linear-gradient(135deg, #f4f8fb 0%, #eef5ff 100%);
  color: #0f172a;
}

.wai-hero {
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 18px;
  padding: 3px 3px;
  margin-bottom: 18px;
  border-radius: 22px;
  background: linear-gradient(135deg, #0f172a 0%, #1e3a8a 55%, #0284c7 100%);
  color: white;
  box-shadow: 0 16px 42px rgba(15, 23, 42, 0.24);
  position: relative;
  overflow: hidden;
}

.wai-hero:before {
  content: "";
  position: absolute;
  right: -80px;
  top: -80px;
  width: 260px;
  height: 260px;
  border-radius: 50%;
  background: rgba(255, 255, 255, 0.12);
}

.wai-hero:after {
  content: "";
  position: absolute;
  right: 110px;
  bottom: -90px;
  width: 220px;
  height: 220px;
  border-radius: 50%;
  background: rgba(14, 165, 233, 0.18);
}

.wai-hero-left,
.wai-credit-card {
  position: relative;
  z-index: 1;
}

.wai-hero h2 {
  margin: 8px 0 5px 0;
  font-size: 30px;
  font-weight: 800;
  letter-spacing: -0.5px;
}

.wai-hero p {
  margin: 0;
  opacity: 0.88;
  font-size: 14px;
}

.wai-badge {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  padding: 6px 13px;
  border-radius: 999px;
  background: rgba(255,255,255,0.16);
  border: 1px solid rgba(255,255,255,0.24);
  font-size: 13px;
  font-weight: 700;
}

.wai-credit-card {
  min-width: 170px;
  padding: 3px 3px;
  border-radius: 18px;
  background: rgba(255,255,255,0.16);
  border: 1px solid rgba(255,255,255,0.26);
  text-align: center;
  backdrop-filter: blur(8px);
}

.wai-credit-card span {
  display: block;
  font-size: 12px;
  opacity: 0.82;
  text-transform: uppercase;
  letter-spacing: 0.6px;
}

.wai-credit-card strong {
  display: block;
  margin-top: 3px;
  font-size: 16px;
  line-height: 1;
  font-weight: 900;
}

.wai-tabs > .nav-tabs {
  border-bottom: none;
  gap: 6px;
  flex-wrap: wrap;
}

.wai-tabs > .nav-tabs .nav-link {
  border: none !important;
  border-radius: 14px 14px 0 0 !important;
  background: #e8eef7;
  color: #334155;
  font-weight: 700;
  padding: 11px 16px;
  margin-right: 5px;
  box-shadow: inset 0 -1px 0 rgba(15,23,42,0.08);
}

.wai-tabs > .nav-tabs .nav-link.active {
  background: #ffffff !important;
  color: #0f172a !important;
  box-shadow: 0 -4px 18px rgba(15, 23, 42, 0.08);
}

.wai-tabs > .tab-content {
  background: #ffffff;
  border-radius: 0 20px 20px 20px;
  padding: 18px;
  box-shadow: 0 14px 34px rgba(15, 23, 42, 0.09);
  border: 1px solid rgba(226, 232, 240, 0.9);
}

.wai-analytics-page .card,
.wai-analytics-page .card-header {
  border-radius: 16px !important;
  border-color: #e5edf5 !important;
}

.wai-analytics-page .card-header {
  background: linear-gradient(90deg, #f8fafc, #e0f2fe) !important;
  border: 1px solid #dbeafe !important;
  color: #0f172a !important;
  font-weight: 750;
  box-shadow: 0 3px 10px rgba(15, 23, 42, 0.04);
}

.wai-analytics-page hr {
  border-top: 1px solid #e2e8f0;
}

.wai-analytics-page .btn {
  border-radius: 999px !important;
  font-weight: 700;
  box-shadow: 0 2px 8px rgba(15, 23, 42, 0.05);
}

.wai-analytics-page .btn-outline-primary {
  border-color: #2563eb !important;
  color: #1d4ed8 !important;
}

.wai-analytics-page .btn-outline-primary:hover {
  background: #2563eb !important;
  color: #ffffff !important;
}

.wai-analytics-page .btn-outline-success {
  border-color: #16a34a !important;
  color: #15803d !important;
}

.wai-analytics-page .btn-outline-danger {
  border-color: #dc2626 !important;
  color: #b91c1c !important;
}

.wai-analytics-page .form-control,
.wai-analytics-page .custom-select,
.wai-analytics-page select,
.wai-analytics-page textarea,
.wai-analytics-page input {
  border-radius: 12px !important;
  border-color: #dbe4ee !important;
  background-color: #ffffff;
}

.wai-analytics-page .form-control:focus,
.wai-analytics-page .custom-select:focus,
.wai-analytics-page textarea:focus,
.wai-analytics-page input:focus {
  border-color: #38bdf8 !important;
  box-shadow: 0 0 0 3px rgba(56, 189, 248, 0.16) !important;
}

.wai-analytics-page .dropdown-menu {
  border-radius: 14px;
  border-color: #dbe4ee;
  box-shadow: 0 12px 28px rgba(15, 23, 42, 0.14);
}

.wai-analytics-page .dropdown-item:hover,
.wai-analytics-page .dropdown-item:focus {
  background: #eff6ff;
  color: #1d4ed8;
}

.wai-analytics-page .progress {
  border-radius: 999px;
  background-color: #e2e8f0;
  overflow: hidden;
}

.wai-analytics-page .progress-bar {
  border-radius: 999px;
}

.wai-analytics-page table {
  border-radius: 14px;
  overflow: hidden;
}

.wai-analytics-page th {
  white-space: nowrap;
}

.wai-analytics-page td {
  vertical-align: middle;
}

.processing-banner {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 16px;
  padding: 16px 20px;
  border-radius: 18px;
  background: linear-gradient(135deg, #0ea5e9, #2563eb);
  border: 1px solid rgba(255, 255, 255, 0.18);
  color: white;
  font-size: 15px;
  font-weight: 800;
  box-shadow: 0 14px 28px rgba(37, 99, 235, 0.28);
  margin: 12px 0;
}

.processing-text {
  display: flex;
  flex-direction: column;
  line-height: 1.3;
}

.spinner {
  width: 24px;
  height: 24px;
  border: 3px solid rgba(255, 255, 255, 0.35);
  border-top-color: #ffffff;
  border-radius: 50%;
  animation: spin 0.85s linear infinite;
}

/* ML model table enhancement */
.wai-analytics-page table thead[style*="position:sticky"] tr:first-child th {
  text-transform: uppercase;
  letter-spacing: .4px;
  font-size: 12px;
}

.wai-analytics-page table thead[style*="position:sticky"] tr:nth-child(2) th {
  border: 1px solid #dbe4ee !important;
  color: #0f172a;
  font-size: 12px;
}

.wai-analytics-page table tbody tr {
  transition: background .18s ease, transform .18s ease, box-shadow .18s ease;
}

.wai-analytics-page table tbody tr:hover {
  background: #eff6ff !important;
  box-shadow: inset 3px 0 0 #2563eb;
}

@media (max-width: 992px) {
  .wai-hero {
    flex-direction: column;
    align-items: flex-start;
  }

  .wai-credit-card {
    width: 100%;
    text-align: left;
  }

  .wai-tabs > .tab-content {
    padding: 12px;
  }
}


</style>